(function() {
    'use strict';

    angular
        .module('womenCellApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngPrint',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('ViewSuggestionDetailController', ViewSuggestionDetailController);

    ViewSuggestionDetailController.$inject = ['$scope', 'entity','$timeout'];

    function ViewSuggestionDetailController($scope,entity,$timeout) {
        var vm = this;
        vm.suggestion=entity;
        vm.printToCart=printToCart;

        function printToCart(printSectionId) {
            var innerContents = document.getElementById(printSectionId).innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=1100,height=700');
            popupWinindow.document.open();
            popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
            $timeout(function() {
            popupWinindow.document.close();
            },100);
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('view-suggestion', {
            parent: 'app',
            url: '/view-suggestion',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_HSCW']
            },
            views: {
                'content@': {
                    templateUrl: 'app/view-suggestion/view-suggestion.html',
                    controller: 'ViewSuggestionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('view-suggestion');
                    return $translate.refresh();
                }]
            }
        })
        .state('view-suggestion-detail', {
            parent: 'view-suggestion',
            url: '/view-suggestion/{id}',
              data: {
                    authorities: ['ROLE_ADMIN','ROLE_HSCW'],
                    },
            views: {
                'content@': {
                    templateUrl: 'app/view-suggestion/viewSuggestionDetail.html',
                    controller: 'ViewSuggestionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('view-suggestion-detail');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Suggestion', function($stateParams, Suggestion) {
                    return Suggestion.get({id : $stateParams.id}).$promise;
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('ViewSuggestionController', ViewSuggestionController);

    ViewSuggestionController.$inject = ['$scope','Suggestion'];

    function ViewSuggestionController($scope,Suggestion) {
        var vm = this;

        Suggestion.query(function(result) {
            vm.suggestions = result;
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('ViewComplaintDetailController', ViewComplaintDetailController);

    ViewComplaintDetailController.$inject = ['$scope', 'entity', 'ComplaintDownloadPdf', '$timeout'];

    function ViewComplaintDetailController($scope,entity, ComplaintDownloadPdf, $timeout) {
        var vm = this;
        vm.complaintForm=entity;
        vm.afilename=null;
        vm.pcfilename=null;
        vm.ccfilename=null;
        vm.complaintFormPdf=complaintFormPdf;
        vm.printToCart=printToCart;
        vm.asVictim="No";
        if(vm.complaintForm.complainantAsVictim){
          vm.asVictim="Yes";
        }else{vm.asVictim="No";}

        function printToCart(printSectionId) {
            var innerContents = document.getElementById(printSectionId).innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=1100,height=700');
//            var popupWinindow;
            popupWinindow.document.open();
            popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
            $timeout(function() {
            popupWinindow.document.close();
            },100);
        }

        if(vm.complaintForm.attachedFileName!=null)
        {
            vm.afilename=vm.complaintForm.attachedFileName+"-"+vm.complaintForm.cName+"_OtherAttachment";
        }
        if(vm.complaintForm.policeComplaintFileName!=null)
        {
            vm.pcfilename=vm.complaintForm.policeComplaintFileName+"-"+vm.complaintForm.cName+"_PoliceComplaint";
        }
        if(vm.complaintForm.caseInCourtFileName!=null)
        {
            vm.ccfilename=vm.complaintForm.caseInCourtFileName+"-"+vm.complaintForm.cName+"_CaseFiledInCourt";
        }

        function complaintFormPdf(){
            ComplaintDownloadPdf.download(vm.complaintForm.id);
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('view-complaint', {
            parent: 'app',
            url: '/view-complaint',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_HSCW']
            },
            views: {
                'content@': {
                    templateUrl: 'app/view-complaint/view-complaint.html',
                    controller: 'ViewComplaintController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('view-complaint');
                    return $translate.refresh();
                }]
            }
        })
        .state('view-complaint-detail', {
            parent: 'view-complaint',
            url: '/view-complaint/{id}',
            data: {
                    authorities: ['ROLE_ADMIN','ROLE_HSCW']
                },
            views: {
                'content@': {
                    templateUrl: 'app/view-complaint/viewComplaintDetail.html',
                    controller: 'ViewComplaintDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('view-complaint-detail');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ComplaintForm', function($stateParams, ComplaintForm) {
                    return ComplaintForm.get({id : $stateParams.id}).$promise;
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('ViewComplaintController', ViewComplaintController);

    ViewComplaintController.$inject = ['$scope', 'ComplaintForm'];

    function ViewComplaintController($scope,ComplaintForm) {
        var vm = this;
        vm.complaintForms = [];
        loadAll();

        function loadAll() {
            ComplaintForm.query(function(result) {
                vm.complaintForms = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
    .module('womenCellApp')
    .factory('ComplaintDownloadPdf', ['$q', '$timeout', '$window',
        function($q, $timeout, $window, $http) {
            return {
                download: function(id) {
                    var defer = $q.defer();
                    $timeout(function() {
                       $window.location = 'api/downloadPdf?id=' + id;}
                        , 1000)
                        .then(function() {
                            defer.resolve('success');
                        }, function() {
                            defer.reject('error');
                        });
                    return defer.promise;
                }
            };
        }
    ]);
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('useful-links', {
            parent: 'app',
            url: '/useful-links',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/useful-links/useful-links.html',
                    controller: 'UsefulLinksController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('useful-links');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('UsefulLinksController', UsefulLinksController);

    UsefulLinksController.$inject = ['$scope'];

    function UsefulLinksController($scope) {
        var vm = this;



    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('updatesoon', {
            parent: 'app',
            url: '/updatesoon',
            data: {
                authorities: [],
                pageTitle: 'global.menu.suggestions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/update-soon/update-soon.html',
                    controller: 'UpdateSoonController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('news-update', {
            parent: 'app',
            url: '/news-update/{value}',
            data: {
                authorities: [],
                pageTitle: 'global.menu.suggestions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/update-soon/news.html',
                    controller: 'UpdateSoonController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('UpdateSoonController', UpdateSoonController);

    UpdateSoonController.$inject = ['$scope','$stateParams'];

    function UpdateSoonController($scope,$stateParams) {
        var vm = this;
        vm.news1=false;
        vm.news2=false;
        vm.news3=false;
        loadAll();

        function loadAll()
        {
            if($stateParams.value=="news1")
            {
                vm.news1=true;
            }
            if($stateParams.value=="news2")
            {
                vm.news2=true;
            }
            if($stateParams.value=="news3")
            {
                vm.news3=true;
            }

        }

    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('suggestions', {
            parent: 'app',
            url: '/suggestions',
            data: {
                authorities: [],
                pageTitle: 'global.menu.suggestions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/suggestions/suggestions.html',
                    controller: 'SuggestionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('suggestions');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('SuggestionsController', SuggestionsController);

    SuggestionsController.$inject = ['$scope','Suggestion', 'CheckContent'];

    function SuggestionsController($scope,Suggestion, CheckContent) {
        var vm = this;
        vm.success = null;
        vm.error = null;
        vm.save=save;
        vm.suggestions = ["Related To ACTs","Complaint Form","Online Support","Other"];

        function save () {
            if(vm.suggestion.suggestionType=='Other'){
                vm.suggestion.suggestionType=vm.suggestion.other;
            }else{
               vm.suggestion.suggestionType=vm.suggestion.suggestionType;
            }
            Suggestion.save(vm.suggestion, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            vm.success = 'OK';
        }

        function onSaveError () {
            vm.error = 'ERROR';
        }

        $('input').each(function(){ CheckContent.checkInput($(this))});
        $('textarea').each(function() { CheckContent.checkInput($(this))});
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sitemap', {
            parent: 'app',
            url: '/sitemap',
            data: {
                authorities: [],
                pageTitle: 'global.menu.sitemap'
            },
            views: {
                'content@': {
                    templateUrl: 'app/sitemap/sitemap.html',
                    controller: 'SitemapController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sitemap');
                    return $translate.refresh();
                }]
            }
        })
        .state('budget', {
            parent: 'app',
            url: '/budget',
            data: {
                authorities: [],
                pageTitle: 'global.menu.sitemap'
            },
            views: {
                'content@': {
                    templateUrl: 'app/sitemap/budget.html',
                    controller: 'SitemapController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sitemap');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('SitemapController', SitemapController);

    SitemapController.$inject = ['$scope'];

    function SitemapController($scope) {
        var vm = this;


    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('CheckContent', CheckContent);

    CheckContent.$inject = [];

    function CheckContent () {
        var service = {
            checkFile: checkFile,
            checkInput : checkInput,
            getExtension: getExtension
        };

        return service;

        function checkFile(fileName) {
            if(fileName!=null){
                var splitArr = fileName.split(".");
                if(splitArr[0]!=""){
                    return splitArr.length == 2;
                }
            } return false;
        }

        function getExtension(fileName) {
            if(fileName!=null){
                var splitArr = fileName.split(".");
                if(splitArr[0]!=""){
                    if(splitArr.length == 2) {
                        return splitArr[1];
                    }else return false
                }else return false;
            } return false;
        }

        function checkInput (elem) {
            elem.bind("propertychange change click keyup input paste", function(){
                if(elem.val().includes('<script') || elem.val().includes('alert(') || elem.val().includes('.js') || elem.val().includes('.exe')
                    || elem.val().includes('.sh') || elem.val().includes('.jar') || elem.val().includes('.class') || elem.val().includes('.class')
                    || elem.val().includes('bash') || elem.val().includes('./') || elem.val().includes('.tar.gz') || elem.val().includes('.deb')
                    || elem.val().includes('.rpm') || elem.val().includes('.ko') || elem.val().includes('.php') || elem.val().includes('.py')
                    || elem.val().includes('.tar')){
                    elem.val('');
                    alert('Please insert relevant information in this field! \n' +
                        'कृपया इस क्षेत्र में वैध जानकारी डालें!');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('ImgSave',['$http', function($http){
        return {
            upload: function(file,callit){
            var resourceUrl =  'api/ImgSave';
            var fd = new FormData();
            fd.append('file', file);
            return $http.post(resourceUrl, fd, {
            transformRequest : angular.identity,
            headers : {
            'Content-Type' : undefined
            }
            }).success(function(result){
                callit(result);
            }).error(function(){
                alert("Error while saving your image. File should not be more than 5MB!");
                location.reload();
            });
            }
        }
    }]);
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('ImgDel',['$resource',

      function ImgDel($resource){

        var resourceUrl =  'api/ImgDel/:filename';

        return $resource(resourceUrl, {}, {
           'delete': {
                   method: 'DELETE',
                   transformResponse: function (data) {
                       if (data) {
                           data = angular.fromJson(data);
                       }
                       return data;
                   }
               }
           });
    }]);
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('FileSave',['$http','$state', function($http,$state){
        return {
            upload: function(file,callit){
            var resourceUrl =  'api/FileSave';
            var fd = new FormData();
            fd.append('file', file);
            return $http.post(resourceUrl, fd, {
            transformRequest : angular.identity,
            headers : {
            'Content-Type' : undefined
            }
            }).success(function(result){
                callit(result);
            }).error(function(result){
              alert("Error while uploading your files!");
              $state.go('home');
              location.reload();
            });
            }
        }
    }]);
})();

(function() {
    'use strict';
    angular
        .module('womenCellApp')
        .directive('fileModel', ['$parse', function ($parse) {
            return {
                restrict: 'A',
                link: function(scope, element, attrs) {
                    var model = $parse(attrs.fileModel);
                    var modelSetter = model.assign;
                    var maxSize = 1024*1024; //1 MB

                    element.bind('change', function(){
                        scope.$apply(function(){
//                            scope.file.maxSizeError = false;
                            if (element[0].files.length > 1) {
                                modelSetter(scope, element[0].files);
                                } else {
                                modelSetter(scope, element[0].files[0]);
                                }
                            var fileSize = element[0].files[0].size;
                            if (fileSize > maxSize) {
//                                scope.file.maxSizeError = true;
                            }
                        });
                    });
                }
            };
        }]);
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('DefaultImgSave',['$http', function($http){
        return {
            upload: function(file,callit){
            var resourceUrl =  'api/DefaultImgSave';
            var fd = new FormData();
            fd.append('file', file);
            return $http.post(resourceUrl, fd, {
            transformRequest : angular.identity,
            headers : {
            'Content-Type' : undefined
            }
            }).success(function(result){
                callit(result);
            }).error(function(){
                alert("Error while saving your image. File should not be more than 5MB!");
                location.reload();
            });
            }
        }
    }]);
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset-password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset-password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change-password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            checkPassword : checkPassword,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }

        function checkPassword (credentials, callback) {
            return AuthServerProvider.checkPassword(credentials)
                .then(function(result){
                    callback(result.data);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            checkPassword: checkPassword,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {

            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {

            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }

        function checkPassword (credentials) {
            var data = {
                username: credentials.username,
                password: credentials.password
            };
            return $http.post('api/checkPassword', data);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('PressNoteViewController', PressNoteViewController);

    PressNoteViewController.$inject = ['$scope','$stateParams','$uibModalInstance'];

    function PressNoteViewController($scope,$stateParams, $uibModalInstance) {
        var vm = this;
        $scope.filename=$stateParams.filename;
        vm.closeView=closeView;

        function closeView()
        {
            $uibModalInstance.dismiss('cancel');
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('pressnote', {
            parent: 'app',
            url: '/pressnote',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/press-note/press-note.html',
                    controller: 'PressNoteController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('news');
                    return $translate.refresh();
                }]
            }
        })
        .state('press-note-view', {
            parent: 'pressnote',
            url: '/press-note-view/{filename}',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/press-note/press-note-view.html',
                    controller: 'PressNoteViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    keyboard: false,
                    resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('news');
                        return $translate.refresh();
                    }]
                    }
                }).result.then(function() {
                    $state.go('pressnote', null, {});
                }, function() {
                    $state.go('pressnote');
                });
            }]
        });
      }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('PressNoteController', PressNoteController);

    PressNoteController.$inject = ['$scope','ImgSave','Gallery','ImgDel', 'CheckContent'];

      function PressNoteController($scope, ImgSave, Gallery,ImgDel, CheckContent) {
          var vm = this;
          vm.upload=upload;
          vm.gallery={};
          vm.gallery.fileType="Image";
          vm.removeImg=removeImg;
          vm.del=false;
          vm.delIcon=delIcon;
          $scope.selection=[];

          Gallery.query({id:"all",type:"pressNote"},function(result){
              vm.newsList=result;
              if(vm.newsList.length==0)
              {
                  $scope.nofile=true;
              }else $scope.nofile=false;
          });

          function delIcon() {
            vm.del = !vm.del;
          }

          function upload(){
              if(vm.image.length>1) {
                  for(var i=0;i<vm.image.length;i++) {
                      if(CheckContent.checkFile(vm.image[i].name)){
                          ImgSave.upload(vm.image[i], function(result){
                              saveEntity(result);
                          });
                      }else alert('Invalid file format!\n' +
                          'अमान्य फ़ाइल प्रकार!');
                  }
              }
              else{
                  if(CheckContent.checkFile(vm.image.name)){
                      ImgSave.upload(vm.image, function(result){
                          saveEntity(result);
                      });
                  }else alert('Invalid File');
              }
          }

          function saveEntity(result) {
              vm.gallery.filename=result.filename;
              vm.gallery.type="pressNote";
              Gallery.save(vm.gallery,onSaveSuccess,onSaveError);
          }

          function onSaveSuccess() {
              alert("Successfully added file!");
              location.reload();
          }

          function onSaveError() {
              alert("Error while adding file. Please try again after some time!");
              location.reload();
          }

          $scope.toggleSelection=function(twoValue){
              var index=$scope.selection.indexOf(twoValue);
              if(index > -1) {
                  $scope.selection.splice(index,1);
              }else{
                 $scope.selection.push(twoValue);
              }
          }

          function removeImg() {
             for(var i=0;i<$scope.selection.length;i++) {
               var id=$scope.selection[i].id;
               var filename=$scope.selection[i].filename;
               confDel($scope.selection[i].fileType,id,filename);
             }
          }

          function confDel(type,id,filename) {
            if(type==="Image" || type==="Pdf") {
                ImgDel.delete({filename: filename},function(){
                Gallery.delete({id: id},onDelSuccess,onDelError);
                 });
            } else{
                Gallery.delete({id: id},onDelSuccess,onDelError);
            }
          }

          function onDelSuccess() {
              alert("File deleted successfully!");
              location.reload();
          }

          function onDelError() {
              alert("Error while deleting the file. Please try again after some time!");
              location.reload();
          }
      }
    })();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('PicGalleryViewController', PicGalleryViewController);

    PicGalleryViewController.$inject = ['$scope','$stateParams','$uibModalInstance'];

    function PicGalleryViewController($scope,$stateParams, $uibModalInstance) {
        var vm = this;
        $scope.filename=$stateParams.filename;
        vm.closeView=closeView;

        function closeView()
        {
            $uibModalInstance.dismiss('cancel');
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('PicGalleryFolderController', PicGalleryFolderController);

    PicGalleryFolderController.$inject = ['$scope','ImgSave','Gallery','ImgDel', 'CheckContent'];

    function PicGalleryFolderController($scope, ImgSave, Gallery,ImgDel, CheckContent) {
        var vm = this;
        vm.upload=upload;
        vm.confirmDelete=confirmDelete;
        vm.gallery={};
        vm.galleryList=[];
        vm.del=false;
        vm.imageVal=null;
        vm.delIcon=delIcon;

        Gallery.query({toGet:"totalCaptions",type:"gallery"},function(result){
            vm.folderList=result;
            if(vm.folderList.length==0){
                $scope.nofile=true;
            }else $scope.nofile=false;
        });

        function delIcon() {
            vm.del = !vm.del;
        }

        function upload(){
            if(CheckContent.checkFile(vm.image.name)){
                Gallery.query({toGet:vm.photo.caption,type:"gallery_"},function(result){
                    vm.folderCheck=result;
                    if(vm.folderCheck.length==0) {
                        ImgSave.upload(vm.image, function(result){
                            saveEntity(result);
                        });
                    }else{
                        alert('Caption already exist, choose different caption');
                    }
                });
            }else alert('Invalid file format!\n' +
                'अमान्य फ़ाइल प्रकार!');
        }

        function saveEntity(result) {
            vm.gallery.filename=result.filename;
            vm.gallery.type="gallery";
            vm.gallery.caption=vm.photo.caption;
            vm.gallery.fileType="Image";
            Gallery.save(vm.gallery,onSaveSuccess,onSaveError);
        }

        function onSaveSuccess() {
            ImgSave.upload(vm.image, function(result){
              vm.gallery.filename=result.filename;
              vm.gallery.description=vm.photo.caption;
              vm.gallery.caption=null;
              Gallery.save(vm.gallery,function(){
                   alert("Successfully added album!");
                   location.reload();
                });
            });
        }

        function onSaveError() {
            alert("Error while adding image in gallery! Please try again after some time.");
            location.reload();
        }

        function confirmDelete(image) {
            ImgDel.delete({filename: image.filename},function(){
                Gallery.delete({id: image.id},onSuccessDel(image));
            });
        }

        function onSuccessDel(result){
            Gallery.query({toGet:result.caption,type:"gallery"},function(result){
                vm.galleryList=result;
                for(var i=0;i<vm.galleryList.length;i++)
                {
                    var id=vm.galleryList[i].id;
                   if(vm.galleryList[i].fileType==="Image")
                     {
                       ImgDel.delete({filename: vm.galleryList[i].filename});
                       Gallery.delete({id: id});
                     }else{
                         Gallery.delete({id: id});
                     }
                }
                alert("Successfully deleted the album!");
                location.reload();
            });
        }

        $scope.setValue=function(val){
         vm.imageVal=val;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('pic-gallery', {
            parent: 'app',
            url: '/pic-gallery/album/{caption}',
            data: {
                authorities: [],
                pageTitle: 'global.menu.gallery'
            },
            views: {
                'content@': {
                    templateUrl: 'app/pics-gallery/pic-gallery.html',
                    controller: 'PicGalleryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pic-gallery');
                    return $translate.refresh();
                }]
            }
        })
            .state('pic-gallery-folder', {
                parent: 'app',
                url: '/pic-gallery/album',
                data: {
                    authorities: [],
                    pageTitle: 'global.menu.gallery'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/pics-gallery/pic-gallery-folders.html',
                        controller: 'PicGalleryFolderController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('pic-gallery');
                        return $translate.refresh();
                    }]
                }
            })
            .state('pic-gallery-view', {
                parent: 'pic-gallery',
                url: '/pic-gallery-view/{filename}',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/pics-gallery/pic-gallery-view.html',
                        controller: 'PicGalleryViewController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        keyboard: false,
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('pic-gallery');
                                return $translate.refresh();
                            }]
                        }
                    }).result.then(function() {
                        $state.go('pic-gallery', null, {});
                    }, function() {
                        $state.go('pic-gallery');
                    });
                }]
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('PicGalleryController', PicGalleryController);

    PicGalleryController.$inject = ['$stateParams', '$sce','$scope','ImgSave','Gallery','ImgDel', 'CheckContent'];

    function PicGalleryController($stateParams, $sce,$scope, ImgSave, Gallery,ImgDel, CheckContent) {
        var vm = this;
        vm.upload=upload;
        vm.uploadCover=uploadCover;
        vm.gallery={};
        vm.gallery.fileType="Image";
        vm.filenameList=[];
        vm.removeImg=removeImg;
        vm.del=false;
        vm.mov=false;
        vm.delIcon=delIcon;
        vm.confirmMove=confirmMove;
        vm.moveIcon=moveIcon;
        $scope.selection=[];
        vm.caption=$stateParams.caption;
        vm.moveTo=null;

        Gallery.query({toGet:vm.caption,type:"gallery"},function(result){
            vm.galleryList=result;
            if(vm.galleryList.length==0) {
                $scope.nofile=true;
            }else $scope.nofile=false;
        });
        Gallery.query({toGet:"totalCaptions",type:"gallery"},function(result){
            vm.folderList=result;
        });

        function delIcon()
        {
            if(vm.del)
            {
                vm.del=false;
            }else vm.del=true;
        }
        function moveIcon()
        {
            if(vm.mov)
            {
                vm.mov=false;
            }else vm.mov=true;
        }

        function upload(){
            if(vm.image==null){
                saveEntity("Video")
            }
            else{
                if(vm.image.length>1) {
                    for(var i=0;i<vm.image.length;i++) {
                        if(CheckContent.checkFile(vm.image[i].name)){
                            ImgSave.upload(vm.image[i], function(result){
                                saveEntity(result);
                            });
                        }else alert('Invalid file format!\n' +
                            'अमान्य फ़ाइल प्रकार!');
                    }
                }
                else{
                    if(CheckContent.checkFile(vm.image.name)){
                        ImgSave.upload(vm.image, function(result){
                            saveEntity(result);
                        });
                    }else alert('Invalid file format!\n' +
                        'अमान्य फ़ाइल प्रकार!');
                }
            }
        }
        function saveEntity(result) {
            if(result==="Video"){
                vm.gallery.filename=vm.filename;
            }
            else {
                vm.gallery.filename=result.filename;
            }
            vm.gallery.type="gallery";
            vm.gallery.description=vm.caption;
            Gallery.save(vm.gallery,onSaveSuccess,onSaveError);
        }
        function onSaveSuccess()
        {
            alert("Successfully added file!");
            location.reload();

        }
        function onSaveError()
        {
            alert("Error while adding. Please try again after some time!");
            location.reload();
        }

        $scope.toggleSelection=function(twoValue){
            var index=$scope.selection.indexOf(twoValue);
            if(index > -1)
            {
                $scope.selection.splice(index,1);
            }else{
               $scope.selection.push(twoValue);
            }
        }
        function removeImg()
        {
            for(var i=0;i<$scope.selection.length;i++)
            {
              var id=$scope.selection[i].id;
              var filename=$scope.selection[i].filename;
              confDel($scope.selection[i].fileType,id,filename);
            }
        }
        function confDel(type,id,filename)
        {
          if(type==="Image")
          {
            ImgDel.delete({filename: filename},function(){
              Gallery.delete({id: id},onDelSuccess,onDelError);
            });
          }else{
              Gallery.delete({id: id},onDelSuccess,onDelError);
           }
         }
        function onDelSuccess()
        {
            alert("File is deleted successfully!");
            location.reload();
        }
        function onDelError()
        {
            alert("Error while deleting the file. Please try again after some time!");
            location.reload();
        }
        function confirmMove()
        {
           for(var i=0;i<$scope.selection.length;i++)
           {
             $scope.selection[i].description=vm.moveTo;
             Gallery.update($scope.selection[i],onMoveSuccess,onMoveFail);
           }
        }
        function onMoveSuccess()
        {
           alert("Successfully moved!");
           location.reload();
        }
        function onMoveFail()
        {
           alert("Error while moving the file! Please try again after sometime.");
           location.reload();
        }
        function uploadCover(){
            Gallery.query({toGet:vm.photo.caption,type:"gallery_"},function(result){
                vm.folderCheck=result;
                if(vm.folderCheck.length==0) {
                    ImgSave.upload(vm.image, function(result){
                        saveEntityCover(result);
                    });
                }else{
                    alert('Caption already exist, choose different caption');
                }
            });
        }
        function saveEntityCover(result)
        {
            vm.gallery.filename=result.filename;
            vm.gallery.type="gallery";
            vm.gallery.caption=vm.photo.caption;
            vm.gallery.fileType="Image";
            vm.moveTo=vm.gallery.caption;
            Gallery.save(vm.gallery,onSaveCaptionSuccess,onSaveError);
        }
        function onSaveCaptionSuccess()
        {
            ImgSave.upload(vm.image, function(result){
              vm.gallery.filename=result.filename;
              vm.gallery.description=vm.photo.caption;
              vm.gallery.caption=null;
              Gallery.save(vm.gallery,function(){
                   confirmMove();
                });
            });
        }
        vm.getImageUrl=function (image) {
            if(image.fileType==="Video"){
                return $sce.trustAsResourceUrl("https://www.youtube.com/embed/"+image.filename);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('NewsViewController', NewsViewController);

    NewsViewController.$inject = ['$scope','$stateParams','$uibModalInstance'];

    function NewsViewController($scope,$stateParams, $uibModalInstance) {
        var vm = this;
        $scope.filename=$stateParams.filename;
        vm.closeView=closeView;

        function closeView()
        {
            $uibModalInstance.dismiss('cancel');
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('news', {
            parent: 'app',
            url: '/news',
            data: {
                authorities: [],
                pageTitle: 'global.menu.news'
            },
            views: {
                'content@': {
                    templateUrl: 'app/news/news.html',
                    controller: 'NewsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('news');
                    return $translate.refresh();
                }]
            }
        })
        .state('news-view', {
            parent: 'news',
            url: '/news-view/{filename}',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/news/news-view.html',
                    controller: 'NewsViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    keyboard: false,
                    resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('news');
                        return $translate.refresh();
                    }]
                    }
                }).result.then(function() {
                    $state.go('news', null, {});
                }, function() {
                    $state.go('news');
                });
            }]
        });
      }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('NewsController', NewsController);

    NewsController.$inject = ['$scope', '$sce','ImgSave','Gallery','ImgDel', 'CheckContent'];

      function NewsController($scope, $sce, ImgSave, Gallery,ImgDel, CheckContent) {
          var vm = this;
          vm.upload=upload;
          vm.gallery={};
          vm.gallery.fileType="Image";
          vm.filenameList=[];
          vm.removeImg=removeImg;
          vm.del=false;
          vm.delIcon=delIcon;
          $scope.selection=[];

          Gallery.query({id:"all",type:"news"},function(result){
              vm.newsList=result;
              if(vm.newsList.length==0)
              {
                  $scope.nofile=true;
              }else $scope.nofile=false;
          });

          function delIcon()
          {
            if(vm.del)
            {
                vm.del=false;
            }else vm.del=true;
          }

          function upload(){
            if(vm.image==null){
                saveEntity("Video")
            }
            else{
                if(vm.image.length>1) {
                    for(var i=0;i<vm.image.length;i++) {
                        if(CheckContent.checkFile(vm.image[i].name)){
                            ImgSave.upload(vm.image[i], function(result){
                                saveEntity(result);
                            });
                        }else alert('Invalid file format!\n' +
                            'अमान्य फ़ाइल प्रकार!');
                    }
                }
                else{
                    if(CheckContent.checkFile(vm.image.name)){
                        ImgSave.upload(vm.image, function(result){
                            saveEntity(result);
                        });
                    }else alert('Invalid file format!\n' +
                        'अमान्य फ़ाइल प्रकार!');
                }
            }
          }
          function saveEntity(result) {
              if(result==="Video"){
                  vm.gallery.filename=vm.filename;
              }
              else {
                  vm.gallery.filename=result.filename;
              }
              vm.gallery.type="news";
              Gallery.save(vm.gallery,onSaveSuccess,onSaveError);
          }
          function onSaveSuccess()
          {
              alert("Successfully added file!");
              location.reload();

          }
          function onSaveError()
          {
              alert("Error while adding file. Please try again after some time!");
              location.reload();
          }

          $scope.toggleSelection=function(twoValue){
              var index=$scope.selection.indexOf(twoValue);
              if(index > -1)
              {
                  $scope.selection.splice(index,1);
              }else{
                 $scope.selection.push(twoValue);
              }
          }
          function removeImg()
          {
             for(var i=0;i<$scope.selection.length;i++)
             {
               var id=$scope.selection[i].id;
               var filename=$scope.selection[i].filename;
               confDel($scope.selection[i].fileType,id,filename);
             }
          }
          function confDel(type,id,filename)
          {
            if(type==="Image")
           {
             ImgDel.delete({filename: filename},function(){
                Gallery.delete({id: id},onDelSuccess,onDelError);
             });
           }else{
                Gallery.delete({id: id},onDelSuccess,onDelError);
           }
          }
          function onDelSuccess()
          {
              alert("File is deleted successfully!");
              location.reload();
          }
          function onDelError()
          {
              alert("Error while deleting the file. Please try again after some time!");
              location.reload();
          }
          vm.getImageUrl=function (image) {
              if(image.fileType==="Video"){
                  return $sce.trustAsResourceUrl("https://www.youtube.com/embed/"+image.filename);
              }
          }

      }
    })();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', '$scope', '$timeout', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, $scope, $timeout, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        $scope.clock = "loading clock..."; // initialise the time variable
        $scope.tickInterval = 1000 //ms
        var tick = function () {
            $scope.clock = Date.now() // get the current time
            $timeout(tick, $scope.tickInterval); // reset the timer
        }

        // Start the timer
        $timeout(tick, $scope.tickInterval);


        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('laws-pertaining-to-women', {
            parent: 'app',
            url: '/laws-pertaining-to-women',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/laws-pertaining-to-women/laws-pertaining-to-women.html',
                    controller: 'LawsPertainingToWomenController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('laws-pertaining-to-women');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('LawsPertainingToWomenController', LawsPertainingToWomenController);

    LawsPertainingToWomenController.$inject = ['$scope'];

    function LawsPertainingToWomenController($scope) {
        var vm = this;

    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('joinus', {
            parent: 'app',
            url: '/joinus',
            data: {
                authorities: [],
                pageTitle: 'global.menu.suggestions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/join-us/join-us.html',
                    controller: 'JoinUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('join-us');
                    return $translate.refresh();
                }]
            }
        })
        .state('joinusInterns', {
            parent: 'joinus',
            url: '/interns/reviews',
            data: {
                authorities: [],
                pageTitle: 'global.menu.suggestions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/join-us/join-us-interns.html',
                    controller: 'JoinUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('join-us');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('JoinUsController', JoinUsController);

    JoinUsController.$inject = ['$scope','$filter','$sce','Gallery'];

    function JoinUsController($scope,$filter,$sce,Gallery) {
        var vm = this;
        vm.getImageUrl=getImageUrl;
        vm.joinUs=[];
        vm.newsList=[];
        vm.saveEntity=saveEntity;
        vm.del=false;
        vm.delIcon=delIcon;
        vm.removeImg=removeImg;
        $scope.selection=[];

        Gallery.query({id:"all",type:"joinUs"},function(result){
          vm.newsList=result;   //all video type files

          if(vm.newsList.length==0)
          {
              $scope.nofile=true;
          }else {
              $scope.nofile=false;
              vm.src1= $sce.trustAsResourceUrl("https://www.youtube.com/embed/"+vm.newsList[0].filename);
              vm.src2= $sce.trustAsResourceUrl("https://www.youtube.com/embed/"+vm.newsList[1].filename);
              vm.src3= $sce.trustAsResourceUrl("https://www.youtube.com/embed/"+vm.newsList[2].filename);
              $scope.toggle1=vm.newsList[0].id+"_"+vm.newsList[0].filename;
              $scope.toggle2=vm.newsList[1].id+"_"+vm.newsList[1].filename;
              $scope.toggle3=vm.newsList[2].id+"_"+vm.newsList[2].filename;
          }
        });

        function delIcon()
        {
           if(vm.del)
           {
               vm.del=false;
           }else vm.del=true;
        }


        function getImageUrl(image) {
          if(image.fileType==="Video"){
              return $sce.trustAsResourceUrl("https://www.youtube.com/embed/"+image.filename);
          }
        }
        function saveEntity() {
          vm.gallery.type="joinUs";
          vm.gallery.fileType="Video";
          Gallery.save(vm.gallery,onSaveSuccess,onSaveError);
        }
        function onSaveSuccess()
        {
           alert("Successfully added file!");
           location.reload();
        }
        function onSaveError()
        {
           alert("Error while adding file. Please try again after some time!");
           location.reload();
        }

        $scope.toggleSelection=function(twoValue){
          var index=$scope.selection.indexOf(twoValue);
          if(index > -1)
          {
              $scope.selection.splice(index,1);
          }else{
             $scope.selection.push(twoValue);
          }
        }
        function removeImg()
        {
           for(var i=0;i<$scope.selection.length;i++)
           {
             var id=$scope.selection[i].id;
             var filename=$scope.selection[i].filename;
             confDel($scope.selection[i].fileType,id,filename);
           }
        }
        function confDel(type,id,filename)
        {
           Gallery.delete({id: id},onDelSuccess,onDelError);
        }
        function onDelSuccess()
        {
          alert("File is deleted successfully!");
          location.reload();
        }
        function onDelError()
        {
          alert("Error while deleting the file. Please try again after some time!");
          location.reload();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('InterviewViewController', InterviewViewController);

    InterviewViewController.$inject = ['$scope','$stateParams','$uibModalInstance'];

    function InterviewViewController($scope,$stateParams, $uibModalInstance) {
        var vm = this;
        $scope.filename=$stateParams.filename;
        vm.closeView=closeView;

        function closeView()
        {
            $uibModalInstance.dismiss('cancel');
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('InterviewFolderController', InterviewFolderController);

    InterviewFolderController.$inject = ['$scope','ImgSave','Gallery','ImgDel', 'CheckContent'];

    function InterviewFolderController($scope, ImgSave, Gallery,ImgDel, CheckContent) {
        var vm = this;
        vm.upload=upload;
        vm.confirmDelete=confirmDelete;
        vm.gallery={};
        vm.galleryList=[];
        vm.del=false;
        vm.imageVal=null;
        vm.delIcon=delIcon;

        Gallery.query({toGet:"totalCaptions",type:"interview"},function(result){
            vm.folderList=result;
            if(vm.folderList.length==0){
                $scope.nofile=true;
            }else $scope.nofile=false;
        });

        function delIcon() {
            vm.del = !vm.del;
        }

        function upload(){
            if(CheckContent.checkFile(vm.image.name)){
                Gallery.query({toGet:vm.photo.caption,type:"interview_"},function(result){
                    vm.folderCheck=result;
                    if(vm.folderCheck.length==0) {
                        ImgSave.upload(vm.image, function(result){
                            saveEntity(result);
                        });
                    }else{
                        alert('Caption already exist, choose different caption');
                    }
                });
            }else alert('Invalid file format!\n' +
                'अमान्य फ़ाइल प्रकार!');
        }

        function saveEntity(result) {
            vm.gallery.filename=result.filename;
            vm.gallery.type="interview";
            vm.gallery.caption=vm.photo.caption;
            vm.gallery.fileType="Image";
            Gallery.save(vm.gallery,onSaveSuccess,onSaveError);
        }

        function onSaveSuccess() {
            ImgSave.upload(vm.image, function(result){
              vm.gallery.filename=result.filename;
              vm.gallery.description=vm.photo.caption;
              vm.gallery.caption=null;
              Gallery.save(vm.gallery,function(){
                   alert("Successfully added album!");
                   location.reload();
                });
            });
        }

        function onSaveError() {
            alert("Error while adding image in gallery! Please try again after some time.");
            location.reload();
        }

        function confirmDelete(image) {
            ImgDel.delete({filename: image.filename},function(){
                Gallery.delete({id: image.id},onSuccessDel(image));
            });
        }

        function onSuccessDel(result){
            Gallery.query({toGet:result.caption,type:"interview"},function(result){
                vm.galleryList=result;
                for(var i=0;i<vm.galleryList.length;i++)
                {
                    var id=vm.galleryList[i].id;
                   if(vm.galleryList[i].fileType==="Image")
                     {
                       ImgDel.delete({filename: vm.galleryList[i].filename});
                       Gallery.delete({id: id});
                     }else{
                         Gallery.delete({id: id});
                     }
                }
                alert("Successfully deleted the album!");
                location.reload();
            });
        }

        $scope.setValue=function(val){
         vm.imageVal=val;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('interview', {
            parent: 'app',
            url: '/interview/album/{caption}',
            data: {
                authorities: [],
                pageTitle: 'global.menu.gallery'
            },
            views: {
                'content@': {
                    templateUrl: 'app/interview/interview.html',
                    controller: 'InterviewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('news');
                    return $translate.refresh();
                }]
            }
        })
        .state('interview-folder', {
            parent: 'app',
            url: '/interview/album',
            data: {
                authorities: [],
                pageTitle: 'global.menu.gallery'
            },
            views: {
                'content@': {
                    templateUrl: 'app/interview/interview-folders.html',
                    controller: 'InterviewFolderController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('news');
                    return $translate.refresh();
                }]
            }
        })
        .state('interview-view', {
            parent: 'interview',
            url: '/interview-view/{filename}',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/interview/interview-view.html',
                    controller: 'InterviewViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    keyboard: false,
                    resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('news');
                        return $translate.refresh();
                    }]
                    }
                }).result.then(function() {
                    $state.go('interview', null, {});
                }, function() {
                    $state.go('interview');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('InterviewController', InterviewController);

    InterviewController.$inject = ['$stateParams', '$sce','$scope','ImgSave','Gallery','ImgDel', 'CheckContent'];

    function InterviewController($stateParams, $sce,$scope, ImgSave, Gallery,ImgDel, CheckContent) {
        var vm = this;
        vm.upload=upload;
        vm.uploadCover=uploadCover;
        vm.gallery={};
        vm.gallery.fileType="Image";
        vm.filenameList=[];
        vm.removeImg=removeImg;
        vm.del=false;
        vm.mov=false;
        vm.delIcon=delIcon;
        vm.confirmMove=confirmMove;
        vm.moveIcon=moveIcon;
        $scope.selection=[];
        vm.caption=$stateParams.caption;
        vm.moveTo=null;

        Gallery.query({toGet:vm.caption,type:"interview"},function(result){
            vm.galleryList=result;
            if(vm.galleryList.length==0) {
                $scope.nofile=true;
            }else $scope.nofile=false;
        });
        Gallery.query({toGet:"totalCaptions",type:"interview"},function(result){
            vm.folderList=result;
        });

        function delIcon()
        {
            if(vm.del)
            {
                vm.del=false;
            }else vm.del=true;
        }
        function moveIcon()
        {
            if(vm.mov)
            {
                vm.mov=false;
            }else vm.mov=true;
        }

        function upload(){
            if(vm.image==null){
                saveEntity("Video")
            }
            else{
                if(vm.image.length>1) {
                    for(var i=0;i<vm.image.length;i++) {
                        if(CheckContent.checkFile(vm.image[i].name)){
                            ImgSave.upload(vm.image[i], function(result){
                                saveEntity(result);
                            });
                        }else alert('Invalid file format!\n' +
                            'अमान्य फ़ाइल प्रकार!');
                    }
                }
                else{
                    if(CheckContent.checkFile(vm.image.name)){
                        ImgSave.upload(vm.image, function(result){
                            saveEntity(result);
                        });
                    }else alert('Invalid file format!\n' +
                        'अमान्य फ़ाइल प्रकार!');
                }
            }
        }
        function saveEntity(result) {
            if(result==="Video"){
                vm.gallery.filename=vm.filename;
            }
            else {
                vm.gallery.filename=result.filename;
            }
            vm.gallery.type="interview";
            vm.gallery.description=vm.caption;
            Gallery.save(vm.gallery,onSaveSuccess,onSaveError);
        }
        function onSaveSuccess()
        {
            alert("Successfully added file!");
            location.reload();

        }
        function onSaveError()
        {
            alert("Error while adding. Please try again after some time!");
            location.reload();
        }

        $scope.toggleSelection=function(twoValue){
            var index=$scope.selection.indexOf(twoValue);
            if(index > -1)
            {
                $scope.selection.splice(index,1);
            }else{
               $scope.selection.push(twoValue);
            }
        }
        function removeImg()
        {
            for(var i=0;i<$scope.selection.length;i++)
            {
              var id=$scope.selection[i].id;
              var filename=$scope.selection[i].filename;
              confDel($scope.selection[i].fileType,id,filename);
            }
        }
        function confDel(type,id,filename)
        {
          if(type==="Image")
          {
            ImgDel.delete({filename: filename},function(){
              Gallery.delete({id: id},onDelSuccess,onDelError);
            });
          }else{
              Gallery.delete({id: id},onDelSuccess,onDelError);
           }
         }
        function onDelSuccess()
        {
            alert("File is deleted successfully!");
            location.reload();
        }
        function onDelError()
        {
            alert("Error while deleting the file. Please try again after some time!");
            location.reload();
        }
        function confirmMove()
        {
           for(var i=0;i<$scope.selection.length;i++)
           {
             $scope.selection[i].description=vm.moveTo;
             Gallery.update($scope.selection[i],onMoveSuccess,onMoveFail);
           }
        }
        function onMoveSuccess()
        {
           alert("Successfully moved!");
           location.reload();
        }
        function onMoveFail()
        {
           alert("Error while moving the file! Please try again after sometime.");
           location.reload();
        }
        function uploadCover(){
            Gallery.query({toGet:vm.photo.caption,type:"interview_"},function(result){
                vm.folderCheck=result;
                if(vm.folderCheck.length==0) {
                    ImgSave.upload(vm.image, function(result){
                        saveEntityCover(result);
                    });
                }else{
                    alert('Caption already exist, choose different caption');
                }
            });
        }
        function saveEntityCover(result)
        {
            vm.gallery.filename=result.filename;
            vm.gallery.type="interview";
            vm.gallery.caption=vm.photo.caption;
            vm.gallery.fileType="Image";
            vm.moveTo=vm.gallery.caption;
            Gallery.save(vm.gallery,onSaveCaptionSuccess,onSaveError);
        }
        function onSaveCaptionSuccess()
        {
            ImgSave.upload(vm.image, function(result){
              vm.gallery.filename=result.filename;
              vm.gallery.description=vm.photo.caption;
              vm.gallery.caption=null;
              Gallery.save(vm.gallery,function(){
                   confirmMove();
                });
            });
        }
        vm.getImageUrl=function (image) {
            if(image.fileType==="Video"){
                return $sce.trustAsResourceUrl("https://www.youtube.com/embed/"+image.filename);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('home-msg', {
            parent: 'app',
            url: '/home-msg',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home-msg.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
            .state('vc-msg', {
                parent: 'app',
                url: '/vc-msg',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/home/vc-msg.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('womenCellApp')
        .factory('HomeService', HomeService);

    HomeService.$inject = ['$resource'];

    function HomeService ($resource) {
        var resourceUrl =  'api/defaultImageDel/:filename';

        return $resource(resourceUrl, {}, {
            'delete': {
               method: 'DELETE',
               transformResponse: function (data) {
                   if (data) {
                       data = angular.fromJson(data);
                   }
                   return data;
               }
             }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state','DefaultImgSave','HomeService'];

    function HomeController ($scope, Principal, LoginService, $state, DefaultImgSave, HomeService) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.del=false;

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });
        $scope.name="IY";
        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

        $scope.upload=function(){
        //Filename added from here is of without extension
            DefaultImgSave.upload(vm.image, function(result){
                alert("Uploaded successfully");
            });
        };

        $scope.setDeleteVal=function(){
            if(vm.del==false) {
                vm.del=true;
             }else{
                vm.del=false;
             }
        };
        $scope.deletePhoto=function(filename){
            HomeService.delete({filename: filename},function(result){
                if(result.filename==("true")){
                   alert("Image deleted successfully!");
                }else{
                   alert("Error while deleting image!")
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('file-complaints', {
            parent: 'app',
            url: '/file-complaints',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/file-complaints/file-complaints.html',
                    controller: 'FileComplaintsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('file-complaints');
                    return $translate.refresh();
                }]
            }
        })
        .state('complaintInstruction', {
            parent: 'file-complaints',
            url: '/complaintInstruction',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/file-complaints/complaintInstruction.html',
                    controller: 'ComplaintInstructionController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    keyboard: false,
                    resolve: {
                    }
                }).result.then(function() {
                    $state.go('file-complaints', null, { reload: 'file-complaints' });
                }, function() {
                    $state.go('home');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('FileComplaintsController', FileComplaintsController);

    FileComplaintsController.$inject = ['$scope','ComplaintForm','FileSave', 'CheckContent'];

    function FileComplaintsController($scope,ComplaintForm,FileSave, CheckContent) {

        var vm = this;
        vm.success = null;
        vm.error = null;
        vm.afFile=null;
        vm.pfFile=null;
        vm.cfFile=null;
        vm.save=save;
        vm.complainantByVictim=complainantByVictim;
        vm.saveEntity=saveEntity;
        vm.pfUpload=pfUpload;
        vm.cfUpload=cfUpload;
        vm.expectedActionFromCommission = ["Counseling","Compromise","Help Through Police","Free Legal Help","Other"];
        vm.district= ["Ambala","Bhiwani","Charkhi Dadri","Faridabad","Fatehabad","Gurugram","Hisar","Jhajjar","Jind","Kaithal","Karnal",
                    "Kurukshetra","Mahendragarh","Mewat","Palwal","Panchkula","Panipat","Rewari","Rohtak","Sirsa","Sonipat","Yamunanagar"];
        vm.sex = ["Male","Female","Transgender","Unknown","Not Mentioned"];
        vm.complaint = ["Acid Attack","Attempt to Murder","Attempt to Rape","Bigamy/polygamy","Complaints by In Laws","Cyber Crime Against Women","Deprivation of Property Rights",
            "Deprivation of Women Rights","Divorce","Dowry Death","Dowry Harassment/Dowry Death","Free Legal Aid for Women","Gender Discrimination including equal right to education &amp; work",
            "Harassment at Workplace","Indecent Representation of Women","Kidnapping/Abduction","Maintenance Claim","Matter involving Custody of Children","Miscellaneous","Murder","Outraging Modesty of Women",
            "Police Apathy against Women","Pre Marital Breach of Trust","Privacy of women and rights thereof","Rape","Reproductive health rights of women","Right to exercise choice in marriage","Right to live with dignity",
            "Sex Scandals","Sex selective abortion/female foeticide/amniocentesis","Sexual harassment including sexual harassment at workplace","Stalking/Voyeurism","Suicide","Trafficking/Prostitution of women",
            "Violence against women", "Honey Trap/Extortion Matter"];
        vm.casvictim = {'true': 'Yes', 'false': 'No'};
        vm.religion =["Hindu","Muslim","Sikh","Christian","Others","Unknown"];
        vm.caste =["General","SC","ST","OBC","Unknown","Not Mentioned"];

        function save(){
            if(vm.afFile!=null) afUpload();
            else if(vm.pfFile!=null) pfUpload();
            else if(vm.cfFile!=null) cfUpload();
            else saveEntity();
        }

        function afUpload() {
            if(CheckContent.checkFile(vm.afFile.name)){
                var file=vm.afFile;
                FileSave.upload(file, function(result){
                    vm.complaintForm.attachedFileName=result.filename;
                    if(vm.pfFile!=null) pfUpload();
                    else if(vm.cfFile!=null) cfUpload();
                    else saveEntity();
                });
            }else alert('Invalid Attachment File');
        }

        function pfUpload(){
            if(CheckContent.checkFile(vm.pfFile.name)){
                var file=vm.pfFile;
                FileSave.upload(file, function(result){
                    vm.complaintForm.policeComplaintFileName=result.filename;
                    if(vm.cfFile!=null) cfUpload();
                    else saveEntity();
                });
            }else alert('Invalid Police Complaint File');
        }

        function cfUpload(){
            if(CheckContent.checkFile(vm.cfFile.name)){
                var file=vm.cfFile;
                FileSave.upload(file, function(result){
                    vm.complaintForm.caseInCourtFileName=result.filename;
                    saveEntity();
                });
            }else alert('Invalid Case filed in Court File');
        }

        function saveEntity () {
            if(vm.complaintForm.complaintType=='Any Other'){
                vm.complaintForm.complaintType=vm.complaintForm.other;
            }else{
                vm.complaintForm.complaintType=vm.complaintForm.complaintType;
            }
            ComplaintForm.save(vm.complaintForm, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            vm.success = 'OK';
        }

        function onSaveError () {
            vm.error = 'ERROR';
        }

        function complainantByVictim(){
            vm.complaintForm.vName=vm.complaintForm.cName;
            vm.complaintForm.vSex=vm.complaintForm.cSex;
            vm.complaintForm.vAddress=vm.complaintForm.cAddress;
            vm.complaintForm.vPin=vm.complaintForm.cPin;
            vm.complaintForm.vMobile=vm.complaintForm.cMobile;
            vm.complaintForm.vLandline=vm.complaintForm.cLandline;
            vm.complaintForm.vEmail=vm.complaintForm.cEmail;
        }

        $('input').each(function(){ CheckContent.checkInput($(this))});
        $('textarea').each(function() { CheckContent.checkInput($(this))});
    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('ComplaintInstructionController', ComplaintInstructionController);

    ComplaintInstructionController.$inject = ['$scope','$state','$uibModalInstance'];

    function ComplaintInstructionController($scope,$state,$uibModalInstance) {
        var vm = this;
        vm.clear=clear;
        vm.agree=agree;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function agree () {
            $state.go('file-complaints');
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('faqs', {
            parent: 'app',
            url: '/faqs',
            data: {
                authorities: [],
                pageTitle: 'global.menu.f-a-qs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/faqs/faqs.html',
                    controller: 'FAQsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('faqs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('FAQsController', FAQsController);

    FAQsController.$inject = ['$scope'];

    function FAQsController($scope) {
        var vm = this;

    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('SuggestionDialogController', SuggestionDialogController);

    SuggestionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Suggestion'];

    function SuggestionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Suggestion) {
        var vm = this;

        vm.suggestion = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.suggestion.id !== null) {
                Suggestion.update(vm.suggestion, onSaveSuccess, onSaveError);
            } else {
                Suggestion.save(vm.suggestion, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('womenCellApp:suggestionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.suggestionDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('SuggestionDetailController', SuggestionDetailController);

    SuggestionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Suggestion'];

    function SuggestionDetailController($scope, $rootScope, $stateParams, previousState, entity, Suggestion) {
        var vm = this;

        vm.suggestion = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('womenCellApp:suggestionUpdate', function(event, result) {
            vm.suggestion = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('SuggestionDeleteController',SuggestionDeleteController);

    SuggestionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Suggestion'];

    function SuggestionDeleteController($uibModalInstance, entity, Suggestion) {
        var vm = this;

        vm.suggestion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Suggestion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('suggestion', {
            parent: 'entity',
            url: '/suggestion',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'womenCellApp.suggestion.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/suggestion/suggestions.html',
                    controller: 'SuggestionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('suggestion');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('suggestion-detail', {
            parent: 'suggestion',
            url: '/suggestion/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'womenCellApp.suggestion.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/suggestion/suggestion-detail.html',
                    controller: 'SuggestionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('suggestion');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Suggestion', function($stateParams, Suggestion) {
                    return Suggestion.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'suggestion',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('suggestion-detail.edit', {
            parent: 'suggestion-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/suggestion/suggestion-dialog.html',
                    controller: 'SuggestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Suggestion', function(Suggestion) {
                            return Suggestion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('suggestion.new', {
            parent: 'suggestion',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/suggestion/suggestion-dialog.html',
                    controller: 'SuggestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                email: null,
                                mobile: null,
                                suggestionType: null,
                                message: null,
                                suggestionDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('suggestion', null, { reload: 'suggestion' });
                }, function() {
                    $state.go('suggestion');
                });
            }]
        })
        .state('suggestion.edit', {
            parent: 'suggestion',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/suggestion/suggestion-dialog.html',
                    controller: 'SuggestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Suggestion', function(Suggestion) {
                            return Suggestion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('suggestion', null, { reload: 'suggestion' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('suggestion.delete', {
            parent: 'suggestion',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/suggestion/suggestion-delete-dialog.html',
                    controller: 'SuggestionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Suggestion', function(Suggestion) {
                            return Suggestion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('suggestion', null, { reload: 'suggestion' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('womenCellApp')
        .factory('Suggestion', Suggestion);

    Suggestion.$inject = ['$resource', 'DateUtils'];

    function Suggestion ($resource, DateUtils) {
        var resourceUrl =  'api/suggestions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.suggestionDate = DateUtils.convertDateTimeFromServer(data.suggestionDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('SuggestionController', SuggestionController);

    SuggestionController.$inject = ['Suggestion'];

    function SuggestionController(Suggestion) {

        var vm = this;

        vm.suggestions = [];

        loadAll();

        function loadAll() {
            Suggestion.query(function(result) {
                vm.suggestions = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('GalleryDialogController', GalleryDialogController);

    GalleryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Gallery'];

    function GalleryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Gallery) {
        var vm = this;

        vm.gallery = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.gallery.id !== null) {
                Gallery.update(vm.gallery, onSaveSuccess, onSaveError);
            } else {
                Gallery.save(vm.gallery, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('womenCellApp:galleryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.uploadDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('GalleryDetailController', GalleryDetailController);

    GalleryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Gallery'];

    function GalleryDetailController($scope, $rootScope, $stateParams, previousState, entity, Gallery) {
        var vm = this;

        vm.gallery = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('womenCellApp:galleryUpdate', function(event, result) {
            vm.gallery = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('GalleryDeleteController',GalleryDeleteController);

    GalleryDeleteController.$inject = ['$uibModalInstance', 'entity', 'Gallery'];

    function GalleryDeleteController($uibModalInstance, entity, Gallery) {
        var vm = this;

        vm.gallery = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Gallery.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('gallery', {
            parent: 'entity',
            url: '/gallery',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'womenCellApp.gallery.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/gallery/galleries.html',
                    controller: 'GalleryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gallery');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('gallery-detail', {
            parent: 'gallery',
            url: '/gallery/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'womenCellApp.gallery.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/gallery/gallery-detail.html',
                    controller: 'GalleryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gallery');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Gallery', function($stateParams, Gallery) {
                    return Gallery.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'gallery',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('gallery-detail.edit', {
            parent: 'gallery-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gallery/gallery-dialog.html',
                    controller: 'GalleryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Gallery', function(Gallery) {
                            return Gallery.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('gallery.new', {
            parent: 'gallery',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gallery/gallery-dialog.html',
                    controller: 'GalleryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                filename: null,
                                type: null,
                                description: null,
                                uploadDate: null,
                                caption: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('gallery', null, { reload: 'gallery' });
                }, function() {
                    $state.go('gallery');
                });
            }]
        })
        .state('gallery.edit', {
            parent: 'gallery',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gallery/gallery-dialog.html',
                    controller: 'GalleryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Gallery', function(Gallery) {
                            return Gallery.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('gallery', null, { reload: 'gallery' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('gallery.delete', {
            parent: 'gallery',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gallery/gallery-delete-dialog.html',
                    controller: 'GalleryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Gallery', function(Gallery) {
                            return Gallery.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('gallery', null, { reload: 'gallery' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('womenCellApp')
        .factory('Gallery', Gallery);

    Gallery.$inject = ['$resource'];

    function Gallery ($resource) {
        var resourceUrl =  'api/galleries/:id/:toGet/:type';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('GalleryController', GalleryController);

    GalleryController.$inject = ['Gallery'];

    function GalleryController(Gallery) {

        var vm = this;

        vm.galleries = [];

        loadAll();

        function loadAll() {
            Gallery.query(function(result) {
                vm.galleries = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('ComplaintFormDialogController', ComplaintFormDialogController);

    ComplaintFormDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ComplaintForm'];

    function ComplaintFormDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ComplaintForm) {
        var vm = this;

        vm.complaintForm = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.complaintForm.id !== null) {
                ComplaintForm.update(vm.complaintForm, onSaveSuccess, onSaveError);
            } else {
                ComplaintForm.save(vm.complaintForm, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('womenCellApp:complaintFormUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.complaintDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('ComplaintFormDetailController', ComplaintFormDetailController);

    ComplaintFormDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ComplaintForm'];

    function ComplaintFormDetailController($scope, $rootScope, $stateParams, previousState, entity, ComplaintForm) {
        var vm = this;

        vm.complaintForm = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('womenCellApp:complaintFormUpdate', function(event, result) {
            vm.complaintForm = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('ComplaintFormDeleteController',ComplaintFormDeleteController);

    ComplaintFormDeleteController.$inject = ['$uibModalInstance', 'entity', 'ComplaintForm'];

    function ComplaintFormDeleteController($uibModalInstance, entity, ComplaintForm) {
        var vm = this;

        vm.complaintForm = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ComplaintForm.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('complaint-form', {
            parent: 'entity',
            url: '/complaint-form',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'womenCellApp.complaintForm.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/complaint-form/complaint-forms.html',
                    controller: 'ComplaintFormController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('complaintForm');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('complaint-form-detail', {
            parent: 'complaint-form',
            url: '/complaint-form/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'womenCellApp.complaintForm.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/complaint-form/complaint-form-detail.html',
                    controller: 'ComplaintFormDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('complaintForm');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ComplaintForm', function($stateParams, ComplaintForm) {
                    return ComplaintForm.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'complaint-form',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('complaint-form-detail.edit', {
            parent: 'complaint-form-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/complaint-form/complaint-form-dialog.html',
                    controller: 'ComplaintFormDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ComplaintForm', function(ComplaintForm) {
                            return ComplaintForm.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('complaint-form.new', {
            parent: 'complaint-form',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/complaint-form/complaint-form-dialog.html',
                    controller: 'ComplaintFormDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                cName: null,
                                cAddress: null,
                                cDistrict: null,
                                cPin: null,
                                cEmail: null,
                                cMobile: null,
                                cLandline: null,
                                cSex: null,
                                complainantAsVictim: null,
                                vName: null,
                                vAddress: null,
                                vDistrict: null,
                                vPin: null,
                                vEmail: null,
                                vLandline: null,
                                vMobile: null,
                                vSex: null,
                                vReligion: null,
                                vCaste: null,
                                accusedName: null,
                                accusedAddress: null,
                                accusedDistrict: null,
                                accusedPin: null,
                                accusedEmail: null,
                                accusedMobile: null,
                                accusedLandline: null,
                                accusedSex: null,
                                complaintDate: null,
                                complaintType: null,
                                incidentDetail: null,
                                policeComplaintRegistrationStatus: null,
                                caseFiledInCourtStatus: null,
                                expectedActionFromCommission: null,
                                policeComplaintFileName: null,
                                caseInCourtFileName: null,
                                attachedFileName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('complaint-form', null, { reload: 'complaint-form' });
                }, function() {
                    $state.go('complaint-form');
                });
            }]
        })
        .state('complaint-form.edit', {
            parent: 'complaint-form',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/complaint-form/complaint-form-dialog.html',
                    controller: 'ComplaintFormDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ComplaintForm', function(ComplaintForm) {
                            return ComplaintForm.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('complaint-form', null, { reload: 'complaint-form' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('complaint-form.delete', {
            parent: 'complaint-form',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/complaint-form/complaint-form-delete-dialog.html',
                    controller: 'ComplaintFormDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ComplaintForm', function(ComplaintForm) {
                            return ComplaintForm.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('complaint-form', null, { reload: 'complaint-form' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('womenCellApp')
        .factory('ComplaintForm', ComplaintForm);

    ComplaintForm.$inject = ['$resource', 'DateUtils'];

    function ComplaintForm ($resource, DateUtils) {
        var resourceUrl =  'api/complaint-forms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.complaintDate = DateUtils.convertDateTimeFromServer(data.complaintDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('ComplaintFormController', ComplaintFormController);

    ComplaintFormController.$inject = ['ComplaintForm'];

    function ComplaintFormController(ComplaintForm) {

        var vm = this;

        vm.complaintForms = [];

        loadAll();

        function loadAll() {
            ComplaintForm.query(function(result) {
                vm.complaintForms = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('contact-us', {
            parent: 'app',
            url: '/contact-us',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/contact-us/contact-us.html',
                    controller: 'ContactUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contact-us');
                    return $translate.refresh();
                }]
            }
        }),
        $stateProvider.state('contacts', {
            parent: 'app',
            url: '/contacts',
            data: {
                authorities: [],
                pageTitle: 'contacts'
            },
            views: {
                'content@': {
                    templateUrl: 'app/contact-us/contacts.html',
                    controller: 'ContactUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contact-us');
                    return $translate.refresh();
                }]
            }
        }),
        $stateProvider.state('sp', {
            parent: 'app',
            url: '/sp',
            data: {
                authorities: [],
                pageTitle: 'contacts'
            },
            views: {
                'content@': {
                    templateUrl: 'app/contact-us/sp.html',
                    controller: 'ContactUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contact-us');
                    return $translate.refresh();
                }]
            }
        }),
        $stateProvider.state('po', {
            parent: 'app',
            url: '/po',
            data: {
                authorities: [],
                pageTitle: 'contacts'
            },
            views: {
                'content@': {
                    templateUrl: 'app/contact-us/po.html',
                    controller: 'ContactUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contact-us');
                    return $translate.refresh();
                }]
            }
        }),
        $stateProvider.state('dpo', {
            parent: 'app',
            url: '/dpo',
            data: {
                authorities: [],
                pageTitle: 'contacts'
            },
            views: {
                'content@': {
                    templateUrl: 'app/contact-us/dpo.html',
                    controller: 'ContactUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contact-us');
                    return $translate.refresh();
                }]
            }
        }),
        $stateProvider.state('dcpo', {
            parent: 'app',
            url: '/dcpo',
            data: {
                authorities: [],
                pageTitle: 'contacts'
            },
            views: {
                'content@': {
                    templateUrl: 'app/contact-us/dcpo.html',
                    controller: 'ContactUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contact-us');
                    return $translate.refresh();
                }]
            }
        }),
        $stateProvider.state('chairpersons', {
            parent: 'app',
            url: '/chairpersons',
            data: {
                authorities: [],
                pageTitle: 'contacts'
            },
            views: {
                'content@': {
                    templateUrl: 'app/contact-us/chairpersons.html',
                    controller: 'ContactUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contact-us');
                    return $translate.refresh();
                }]
            }
        }),
        $stateProvider.state('vicechairpersons', {
            parent: 'app',
            url: '/vicechairpersons',
            data: {
                authorities: [],
                pageTitle: 'contacts'
            },
            views: {
                'content@': {
                    templateUrl: 'app/contact-us/vicechairpersons.html',
                    controller: 'ContactUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contact-us');
                    return $translate.refresh();
                }]
            }
        }),
            $stateProvider.state('member-list', {
            parent: 'app',
            url: '/member-list',
            data: {
                authorities: [],
                pageTitle: 'contacts'
            },
            views: {
                'content@': {
                    templateUrl: 'app/contact-us/members-list.html',
                    controller: 'ContactUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contact-us');
                    return $translate.refresh();
                }]
            }
        }),
        $stateProvider.state('wps', {
            parent: 'app',
            url: '/wps',
            data: {
                authorities: [],
                pageTitle: 'contacts'
            },
            views: {
                'content@': {
                    templateUrl: 'app/contact-us/wps.html',
                    controller: 'ContactUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contact-us');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('ContactUsController', ContactUsController);

    ContactUsController.$inject = ['$scope'];

    function ContactUsController($scope) {
        var vm = this;

    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('womenCellApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info" data-translate="global.item-count" ' +
        'translate-value-first="{{(($ctrl.page - 1) * $ctrl.itemsPerPage) === 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}}" ' +
        'translate-value-second="{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}}" ' +
        'translate-value-total="{{$ctrl.queryCount}}">' +
        'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
        '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
        'of {{$ctrl.queryCount}} items.' +
        '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('womenCellApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .constant('errorConstants', (function() {
            var problemBaseUrl = 'http://www.jhipster.tech/problem';
            return {
                EMAIL_ALREADY_USED_TYPE: problemBaseUrl + '/email-already-used',
                LOGIN_ALREADY_USED_TYPE: problemBaseUrl + '/login-already-used',
                EMAIL_NOT_FOUND_TYPE: problemBaseUrl + '/email-not-found'
            }
        })());
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            var fileURL = 'data:' + type +';base64,' + data;
            var win = $window.open('', '_blank');
            win.document.write(
                '<iframe src="' +
                fileURL +
                '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
            );
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('womenCellApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: new AesUtil().encryptPassword(vm.password),
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

var AesUtil = function(keySize, iterationCount) {
  this.keySize = keySize / 32;
  this.iterationCount = iterationCount;
};

AesUtil.prototype.generateKey = function(salt, passPhrase) {
  var key = CryptoJS.PBKDF2(
      passPhrase,
      CryptoJS.enc.Hex.parse(salt),
      { keySize: this.keySize, iterations: this.iterationCount });
  return key;
};

AesUtil.prototype.encrypt = function(salt, iv, passPhrase, plainText) {
  var key = this.generateKey(salt, passPhrase);
  var encrypted = CryptoJS.AES.encrypt(
      plainText,
      key,
      { iv: CryptoJS.enc.Hex.parse(iv) });
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
};

AesUtil.prototype.decrypt = function(salt, iv, passPhrase, cipherText) {
  var key = this.generateKey(salt, passPhrase);
  var cipherParams = CryptoJS.lib.CipherParams.create({
    ciphertext: CryptoJS.enc.Base64.parse(cipherText)
  });
  var decrypted = CryptoJS.AES.decrypt(
      cipherParams,
      key,
      { iv: CryptoJS.enc.Hex.parse(iv) });
  return decrypted.toString(CryptoJS.enc.Utf8);
};

AesUtil.prototype.encryptPassword = function (plainString) {
    var iv = "a407f444de6179cf5dfe97dba0aa11dc";
    var salt = "c826254a90f626f011eb21bca9a79c65";
    var keySize = 128;
    var iterationCount = 10000;
    var passPhrase = "NAimIodPNkqOyHQXmEpoFA==Sdty=jHY";
    var aesUtil = new AesUtil(keySize, iterationCount);
    var encryptedString = aesUtil.encrypt(salt, iv, passPhrase, plainString);
    return encryptedString;
};

/*
CryptoJS v3.0.2
code.google.com/p/crypto-js
(c) 2009-2012 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/
var CryptoJS=CryptoJS||function(p,h){var i={},l=i.lib={},r=l.Base=function(){function a(){}return{extend:function(e){a.prototype=this;var c=new a;e&&c.mixIn(e);c.$super=this;return c},create:function(){var a=this.extend();a.init.apply(a,arguments);return a},init:function(){},mixIn:function(a){for(var c in a)a.hasOwnProperty(c)&&(this[c]=a[c]);a.hasOwnProperty("toString")&&(this.toString=a.toString)},clone:function(){return this.$super.extend(this)}}}(),o=l.WordArray=r.extend({init:function(a,e){a=
this.words=a||[];this.sigBytes=e!=h?e:4*a.length},toString:function(a){return(a||s).stringify(this)},concat:function(a){var e=this.words,c=a.words,b=this.sigBytes,a=a.sigBytes;this.clamp();if(b%4)for(var d=0;d<a;d++)e[b+d>>>2]|=(c[d>>>2]>>>24-8*(d%4)&255)<<24-8*((b+d)%4);else if(65535<c.length)for(d=0;d<a;d+=4)e[b+d>>>2]=c[d>>>2];else e.push.apply(e,c);this.sigBytes+=a;return this},clamp:function(){var a=this.words,e=this.sigBytes;a[e>>>2]&=4294967295<<32-8*(e%4);a.length=p.ceil(e/4)},clone:function(){var a=
r.clone.call(this);a.words=this.words.slice(0);return a},random:function(a){for(var e=[],c=0;c<a;c+=4)e.push(4294967296*p.random()|0);return o.create(e,a)}}),m=i.enc={},s=m.Hex={stringify:function(a){for(var e=a.words,a=a.sigBytes,c=[],b=0;b<a;b++){var d=e[b>>>2]>>>24-8*(b%4)&255;c.push((d>>>4).toString(16));c.push((d&15).toString(16))}return c.join("")},parse:function(a){for(var e=a.length,c=[],b=0;b<e;b+=2)c[b>>>3]|=parseInt(a.substr(b,2),16)<<24-4*(b%8);return o.create(c,e/2)}},n=m.Latin1={stringify:function(a){for(var e=
a.words,a=a.sigBytes,c=[],b=0;b<a;b++)c.push(String.fromCharCode(e[b>>>2]>>>24-8*(b%4)&255));return c.join("")},parse:function(a){for(var e=a.length,c=[],b=0;b<e;b++)c[b>>>2]|=(a.charCodeAt(b)&255)<<24-8*(b%4);return o.create(c,e)}},k=m.Utf8={stringify:function(a){try{return decodeURIComponent(escape(n.stringify(a)))}catch(e){throw Error("Malformed UTF-8 data");}},parse:function(a){return n.parse(unescape(encodeURIComponent(a)))}},f=l.BufferedBlockAlgorithm=r.extend({reset:function(){this._data=o.create();
this._nDataBytes=0},_append:function(a){"string"==typeof a&&(a=k.parse(a));this._data.concat(a);this._nDataBytes+=a.sigBytes},_process:function(a){var e=this._data,c=e.words,b=e.sigBytes,d=this.blockSize,q=b/(4*d),q=a?p.ceil(q):p.max((q|0)-this._minBufferSize,0),a=q*d,b=p.min(4*a,b);if(a){for(var j=0;j<a;j+=d)this._doProcessBlock(c,j);j=c.splice(0,a);e.sigBytes-=b}return o.create(j,b)},clone:function(){var a=r.clone.call(this);a._data=this._data.clone();return a},_minBufferSize:0});l.Hasher=f.extend({init:function(){this.reset()},
reset:function(){f.reset.call(this);this._doReset()},update:function(a){this._append(a);this._process();return this},finalize:function(a){a&&this._append(a);this._doFinalize();return this._hash},clone:function(){var a=f.clone.call(this);a._hash=this._hash.clone();return a},blockSize:16,_createHelper:function(a){return function(e,c){return a.create(c).finalize(e)}},_createHmacHelper:function(a){return function(e,c){return g.HMAC.create(a,c).finalize(e)}}});var g=i.algo={};return i}(Math);
(function(){var p=CryptoJS,h=p.lib.WordArray;p.enc.Base64={stringify:function(i){var l=i.words,h=i.sigBytes,o=this._map;i.clamp();for(var i=[],m=0;m<h;m+=3)for(var s=(l[m>>>2]>>>24-8*(m%4)&255)<<16|(l[m+1>>>2]>>>24-8*((m+1)%4)&255)<<8|l[m+2>>>2]>>>24-8*((m+2)%4)&255,n=0;4>n&&m+0.75*n<h;n++)i.push(o.charAt(s>>>6*(3-n)&63));if(l=o.charAt(64))for(;i.length%4;)i.push(l);return i.join("")},parse:function(i){var i=i.replace(/\s/g,""),l=i.length,r=this._map,o=r.charAt(64);o&&(o=i.indexOf(o),-1!=o&&(l=o));
for(var o=[],m=0,s=0;s<l;s++)if(s%4){var n=r.indexOf(i.charAt(s-1))<<2*(s%4),k=r.indexOf(i.charAt(s))>>>6-2*(s%4);o[m>>>2]|=(n|k)<<24-8*(m%4);m++}return h.create(o,m)},_map:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="}})();
(function(p){function h(f,g,a,e,c,b,d){f=f+(g&a|~g&e)+c+d;return(f<<b|f>>>32-b)+g}function i(f,g,a,e,c,b,d){f=f+(g&e|a&~e)+c+d;return(f<<b|f>>>32-b)+g}function l(f,g,a,e,c,b,d){f=f+(g^a^e)+c+d;return(f<<b|f>>>32-b)+g}function r(f,g,a,e,c,b,d){f=f+(a^(g|~e))+c+d;return(f<<b|f>>>32-b)+g}var o=CryptoJS,m=o.lib,s=m.WordArray,m=m.Hasher,n=o.algo,k=[];(function(){for(var f=0;64>f;f++)k[f]=4294967296*p.abs(p.sin(f+1))|0})();n=n.MD5=m.extend({_doReset:function(){this._hash=s.create([1732584193,4023233417,
2562383102,271733878])},_doProcessBlock:function(f,g){for(var a=0;16>a;a++){var e=g+a,c=f[e];f[e]=(c<<8|c>>>24)&16711935|(c<<24|c>>>8)&4278255360}for(var e=this._hash.words,c=e[0],b=e[1],d=e[2],q=e[3],a=0;64>a;a+=4)16>a?(c=h(c,b,d,q,f[g+a],7,k[a]),q=h(q,c,b,d,f[g+a+1],12,k[a+1]),d=h(d,q,c,b,f[g+a+2],17,k[a+2]),b=h(b,d,q,c,f[g+a+3],22,k[a+3])):32>a?(c=i(c,b,d,q,f[g+(a+1)%16],5,k[a]),q=i(q,c,b,d,f[g+(a+6)%16],9,k[a+1]),d=i(d,q,c,b,f[g+(a+11)%16],14,k[a+2]),b=i(b,d,q,c,f[g+a%16],20,k[a+3])):48>a?(c=
l(c,b,d,q,f[g+(3*a+5)%16],4,k[a]),q=l(q,c,b,d,f[g+(3*a+8)%16],11,k[a+1]),d=l(d,q,c,b,f[g+(3*a+11)%16],16,k[a+2]),b=l(b,d,q,c,f[g+(3*a+14)%16],23,k[a+3])):(c=r(c,b,d,q,f[g+3*a%16],6,k[a]),q=r(q,c,b,d,f[g+(3*a+7)%16],10,k[a+1]),d=r(d,q,c,b,f[g+(3*a+14)%16],15,k[a+2]),b=r(b,d,q,c,f[g+(3*a+5)%16],21,k[a+3]));e[0]=e[0]+c|0;e[1]=e[1]+b|0;e[2]=e[2]+d|0;e[3]=e[3]+q|0},_doFinalize:function(){var f=this._data,g=f.words,a=8*this._nDataBytes,e=8*f.sigBytes;g[e>>>5]|=128<<24-e%32;g[(e+64>>>9<<4)+14]=(a<<8|a>>>
24)&16711935|(a<<24|a>>>8)&4278255360;f.sigBytes=4*(g.length+1);this._process();f=this._hash.words;for(g=0;4>g;g++)a=f[g],f[g]=(a<<8|a>>>24)&16711935|(a<<24|a>>>8)&4278255360}});o.MD5=m._createHelper(n);o.HmacMD5=m._createHmacHelper(n)})(Math);
(function(){var p=CryptoJS,h=p.lib,i=h.Base,l=h.WordArray,h=p.algo,r=h.EvpKDF=i.extend({cfg:i.extend({keySize:4,hasher:h.MD5,iterations:1}),init:function(i){this.cfg=this.cfg.extend(i)},compute:function(i,m){for(var h=this.cfg,n=h.hasher.create(),k=l.create(),f=k.words,g=h.keySize,h=h.iterations;f.length<g;){a&&n.update(a);var a=n.update(i).finalize(m);n.reset();for(var e=1;e<h;e++)a=n.finalize(a),n.reset();k.concat(a)}k.sigBytes=4*g;return k}});p.EvpKDF=function(i,l,h){return r.create(h).compute(i,
l)}})();
CryptoJS.lib.Cipher||function(p){var h=CryptoJS,i=h.lib,l=i.Base,r=i.WordArray,o=i.BufferedBlockAlgorithm,m=h.enc.Base64,s=h.algo.EvpKDF,n=i.Cipher=o.extend({cfg:l.extend(),createEncryptor:function(b,d){return this.create(this._ENC_XFORM_MODE,b,d)},createDecryptor:function(b,d){return this.create(this._DEC_XFORM_MODE,b,d)},init:function(b,d,a){this.cfg=this.cfg.extend(a);this._xformMode=b;this._key=d;this.reset()},reset:function(){o.reset.call(this);this._doReset()},process:function(b){this._append(b);return this._process()},
finalize:function(b){b&&this._append(b);return this._doFinalize()},keySize:4,ivSize:4,_ENC_XFORM_MODE:1,_DEC_XFORM_MODE:2,_createHelper:function(){return function(b){return{encrypt:function(a,q,j){return("string"==typeof q?c:e).encrypt(b,a,q,j)},decrypt:function(a,q,j){return("string"==typeof q?c:e).decrypt(b,a,q,j)}}}}()});i.StreamCipher=n.extend({_doFinalize:function(){return this._process(!0)},blockSize:1});var k=h.mode={},f=i.BlockCipherMode=l.extend({createEncryptor:function(b,a){return this.Encryptor.create(b,
a)},createDecryptor:function(b,a){return this.Decryptor.create(b,a)},init:function(b,a){this._cipher=b;this._iv=a}}),k=k.CBC=function(){function b(b,a,d){var c=this._iv;c?this._iv=p:c=this._prevBlock;for(var e=0;e<d;e++)b[a+e]^=c[e]}var a=f.extend();a.Encryptor=a.extend({processBlock:function(a,d){var c=this._cipher,e=c.blockSize;b.call(this,a,d,e);c.encryptBlock(a,d);this._prevBlock=a.slice(d,d+e)}});a.Decryptor=a.extend({processBlock:function(a,d){var c=this._cipher,e=c.blockSize,f=a.slice(d,d+
e);c.decryptBlock(a,d);b.call(this,a,d,e);this._prevBlock=f}});return a}(),g=(h.pad={}).Pkcs7={pad:function(b,a){for(var c=4*a,c=c-b.sigBytes%c,e=c<<24|c<<16|c<<8|c,f=[],g=0;g<c;g+=4)f.push(e);c=r.create(f,c);b.concat(c)},unpad:function(b){b.sigBytes-=b.words[b.sigBytes-1>>>2]&255}};i.BlockCipher=n.extend({cfg:n.cfg.extend({mode:k,padding:g}),reset:function(){n.reset.call(this);var b=this.cfg,a=b.iv,b=b.mode;if(this._xformMode==this._ENC_XFORM_MODE)var c=b.createEncryptor;else c=b.createDecryptor,
this._minBufferSize=1;this._mode=c.call(b,this,a&&a.words)},_doProcessBlock:function(b,a){this._mode.processBlock(b,a)},_doFinalize:function(){var b=this.cfg.padding;if(this._xformMode==this._ENC_XFORM_MODE){b.pad(this._data,this.blockSize);var a=this._process(!0)}else a=this._process(!0),b.unpad(a);return a},blockSize:4});var a=i.CipherParams=l.extend({init:function(a){this.mixIn(a)},toString:function(a){return(a||this.formatter).stringify(this)}}),k=(h.format={}).OpenSSL={stringify:function(a){var d=
a.ciphertext,a=a.salt,d=(a?r.create([1398893684,1701076831]).concat(a).concat(d):d).toString(m);return d=d.replace(/(.{64})/g,"$1\n")},parse:function(b){var b=m.parse(b),d=b.words;if(1398893684==d[0]&&1701076831==d[1]){var c=r.create(d.slice(2,4));d.splice(0,4);b.sigBytes-=16}return a.create({ciphertext:b,salt:c})}},e=i.SerializableCipher=l.extend({cfg:l.extend({format:k}),encrypt:function(b,d,c,e){var e=this.cfg.extend(e),f=b.createEncryptor(c,e),d=f.finalize(d),f=f.cfg;return a.create({ciphertext:d,
key:c,iv:f.iv,algorithm:b,mode:f.mode,padding:f.padding,blockSize:b.blockSize,formatter:e.format})},decrypt:function(a,c,e,f){f=this.cfg.extend(f);c=this._parse(c,f.format);return a.createDecryptor(e,f).finalize(c.ciphertext)},_parse:function(a,c){return"string"==typeof a?c.parse(a):a}}),h=(h.kdf={}).OpenSSL={compute:function(b,c,e,f){f||(f=r.random(8));b=s.create({keySize:c+e}).compute(b,f);e=r.create(b.words.slice(c),4*e);b.sigBytes=4*c;return a.create({key:b,iv:e,salt:f})}},c=i.PasswordBasedCipher=
e.extend({cfg:e.cfg.extend({kdf:h}),encrypt:function(a,c,f,j){j=this.cfg.extend(j);f=j.kdf.compute(f,a.keySize,a.ivSize);j.iv=f.iv;a=e.encrypt.call(this,a,c,f.key,j);a.mixIn(f);return a},decrypt:function(a,c,f,j){j=this.cfg.extend(j);c=this._parse(c,j.format);f=j.kdf.compute(f,a.keySize,a.ivSize,c.salt);j.iv=f.iv;return e.decrypt.call(this,a,c,f.key,j)}})}();
(function(){var p=CryptoJS,h=p.lib.BlockCipher,i=p.algo,l=[],r=[],o=[],m=[],s=[],n=[],k=[],f=[],g=[],a=[];(function(){for(var c=[],b=0;256>b;b++)c[b]=128>b?b<<1:b<<1^283;for(var d=0,e=0,b=0;256>b;b++){var j=e^e<<1^e<<2^e<<3^e<<4,j=j>>>8^j&255^99;l[d]=j;r[j]=d;var i=c[d],h=c[i],p=c[h],t=257*c[j]^16843008*j;o[d]=t<<24|t>>>8;m[d]=t<<16|t>>>16;s[d]=t<<8|t>>>24;n[d]=t;t=16843009*p^65537*h^257*i^16843008*d;k[j]=t<<24|t>>>8;f[j]=t<<16|t>>>16;g[j]=t<<8|t>>>24;a[j]=t;d?(d=i^c[c[c[p^i]]],e^=c[c[e]]):d=e=1}})();
var e=[0,1,2,4,8,16,32,64,128,27,54],i=i.AES=h.extend({_doReset:function(){for(var c=this._key,b=c.words,d=c.sigBytes/4,c=4*((this._nRounds=d+6)+1),i=this._keySchedule=[],j=0;j<c;j++)if(j<d)i[j]=b[j];else{var h=i[j-1];j%d?6<d&&4==j%d&&(h=l[h>>>24]<<24|l[h>>>16&255]<<16|l[h>>>8&255]<<8|l[h&255]):(h=h<<8|h>>>24,h=l[h>>>24]<<24|l[h>>>16&255]<<16|l[h>>>8&255]<<8|l[h&255],h^=e[j/d|0]<<24);i[j]=i[j-d]^h}b=this._invKeySchedule=[];for(d=0;d<c;d++)j=c-d,h=d%4?i[j]:i[j-4],b[d]=4>d||4>=j?h:k[l[h>>>24]]^f[l[h>>>
16&255]]^g[l[h>>>8&255]]^a[l[h&255]]},encryptBlock:function(a,b){this._doCryptBlock(a,b,this._keySchedule,o,m,s,n,l)},decryptBlock:function(c,b){var d=c[b+1];c[b+1]=c[b+3];c[b+3]=d;this._doCryptBlock(c,b,this._invKeySchedule,k,f,g,a,r);d=c[b+1];c[b+1]=c[b+3];c[b+3]=d},_doCryptBlock:function(a,b,d,e,f,h,i,g){for(var l=this._nRounds,k=a[b]^d[0],m=a[b+1]^d[1],o=a[b+2]^d[2],n=a[b+3]^d[3],p=4,r=1;r<l;r++)var s=e[k>>>24]^f[m>>>16&255]^h[o>>>8&255]^i[n&255]^d[p++],u=e[m>>>24]^f[o>>>16&255]^h[n>>>8&255]^
i[k&255]^d[p++],v=e[o>>>24]^f[n>>>16&255]^h[k>>>8&255]^i[m&255]^d[p++],n=e[n>>>24]^f[k>>>16&255]^h[m>>>8&255]^i[o&255]^d[p++],k=s,m=u,o=v;s=(g[k>>>24]<<24|g[m>>>16&255]<<16|g[o>>>8&255]<<8|g[n&255])^d[p++];u=(g[m>>>24]<<24|g[o>>>16&255]<<16|g[n>>>8&255]<<8|g[k&255])^d[p++];v=(g[o>>>24]<<24|g[n>>>16&255]<<16|g[k>>>8&255]<<8|g[m&255])^d[p++];n=(g[n>>>24]<<24|g[k>>>16&255]<<16|g[m>>>8&255]<<8|g[o&255])^d[p++];a[b]=s;a[b+1]=u;a[b+2]=v;a[b+3]=n},keySize:8});p.AES=h._createHelper(i)})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .filter('findLanguageFromKey', findLanguageFromKey)
        .filter('findLanguageRtlFromKey', findLanguageRtlFromKey);

    var languages = {
        'en': { name: 'English' },
        'hi': { name: 'हिंदी' }
        // jhipster-needle-i18n-language-key-pipe - JHipster will add/remove languages in this object
    };

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return languages[lang].name;
        }
    }

    function findLanguageRtlFromKey() {
        return findLanguageRtlFromKeyFilter;

        function findLanguageRtlFromKeyFilter(lang) {
            return languages[lang].rtl;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            'hi'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('womenCellApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('womenCellApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (angular.isString(errorHeader)) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('womenCellApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('womenCellApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('womenCellApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            if (!config || !config.url || /^http/.test(config.url)) return config;

            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }


        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "en"');
                $cookies.putObject(name, 'en');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider', 'BUILD_TIMESTAMP'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider, BUILD_TIMESTAMP) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json' + (BUILD_TIMESTAMP ? '?build=' + BUILD_TIMESTAMP : '')
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'topHeader@': {
                    templateUrl: 'app/layouts/navbar/topHeader.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                },
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                },
                'footer@': {
                    templateUrl: 'app/layouts/navbar/footer.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('womenCellApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('BUILD_TIMESTAMP', 1781605800473)
;
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_HSCW'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load(login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/{login}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_HSCW'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];


        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query(onSuccess, onError);
        }

        function onSuccess(data, headers) {

            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.includes('web.rest') || key.includes('service')) {
                    vm.servicesStats[key] = value;
                }
            });

        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('womenCellApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth', 'errorConstants'];

    function RequestResetController ($timeout, Auth, errorConstants) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_NOT_FOUND_TYPE) {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: new AesUtil().encryptPassword(vm.resetAccount.password)}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService', 'errorConstants'];

    function RegisterController ($translate, $timeout, Auth, LoginService, errorConstants) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.LOGIN_ALREADY_USED_TYPE) {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_ALREADY_USED_TYPE) {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal', '$state'];

    function PasswordController (Auth, Principal, $state) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.errorOldNotMatch = false;
        vm.oldPassword = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.checkPassword({
                    username: vm.account.login,
                    password: new AesUtil().encryptPassword(vm.oldPassword)
                },function(result){
                    if(result){
                        vm.errorOldNotMatch = false;
                        vm.doNotMatch = null;
                        Auth.changePassword( new AesUtil().encryptPassword(vm.password)).then(function () {
                            vm.error = null;
                            vm.success = 'OK';
                            alert('Password Change Successfully');
                            $state.reload('password');
                        }).catch(function () {
                            vm.success = null;
                            vm.error = 'ERROR';
                        });
                    }else vm.errorOldNotMatch = true;
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('about-us', {
            parent: 'app',
            url: '/about-us',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/about-us/about-us.html',
                    controller: 'AboutUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('about-us');
                    return $translate.refresh();
                }]
            }
        }),
        $stateProvider.state('constitution', {
            parent: 'app',
            url: '/constitution',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/about-us/constitution.html',
                    controller: 'AboutUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('about-us');
                    return $translate.refresh();
                }]
            }
        }),
        $stateProvider.state('hscwact', {
            parent: 'app',
            url: '/hscwact',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/about-us/hscwact.html',
                    controller: 'AboutUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('about-us');
                    return $translate.refresh();
                }]
            }
        });
        $stateProvider.state('hscwfunctions', {
            parent: 'app',
            url: '/hscwfunctions',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/about-us/hscwfunctions.html',
                    controller: 'AboutUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('about-us');
                    return $translate.refresh();
                }]
            }
        });
         $stateProvider.state('hscwpowers', {
            parent: 'app',
            url: '/hscwpowers',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/about-us/powershscw.html',
                    controller: 'AboutUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('about-us');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('AboutUsController', AboutUsController);

    AboutUsController.$inject = ['$scope'];

    function AboutUsController($scope) {
        var vm = this;



    }
})();
(function(){'use strict';angular.module('womenCellApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/about-us/about-us.html','<div class="container-fluid"><div class="col-md-9"><h3 class="text-info" data-translate="about-us.titleconstitution"></h3><p class="text-warning text-justify" data-translate="about-us.contentconstitution">Content</p><!--<br><div class="well"><a href=\'http://ncw.nic.in/PDFFiles/StateCommissions09022018.pdf\' target=\'_blank\' data-translate="about-us.statecomission"></a></div>--></div><div class="col-md-3"><h5 class="text-success" data-translate="about-us.subtitle"></h5><hr><ul><!--<li><a data-translate="about-us.titlebriefhistory">Brief History</a></li>--><li><a ui-sref="about-us" data-translate="about-us.titleconstitution">Constitution of Commission</a></li><!--<li><a data-translate="about-us.titlemandate">Mandate of Commission</a></li>--><li><a ui-sref="hscwact" data-translate="about-us.titlehscwact">HSCW ACT</a></li><li><a ui-sref="hscwfunctions" data-translate="about-us.titlebriefhistory">Brief History</a></li><li><a ui-sref="hscwpowers" data-translate="about-us.titlepowers">POWERS OF HSCW</a></li></ul></div></div>');
$templateCache.put('app/about-us/hscwact.html','<div class="container-fluid"><div class="col-md-9"><h3 class="text-info" data-translate="about-us.titlehscwact"></h3><p class="text-warning text-justify" data-translate="about-us.contenthscwact">Content</p></div><div class="col-md-3"><h5 class="text-success" data-translate="about-us.subtitle"></h5><hr><ul><!--<li><a data-translate="about-us.titlebriefhistory">Brief History</a></li>--><li><a ui-sref="about-us" data-translate="about-us.titleconstitution">Constitution of Commission</a></li><!--<li><a data-translate="about-us.titlemandate">Mandate of Commission</a></li>--><li><a ui-sref="hscwact" data-translate="about-us.titlehscwact">HSCW ACT</a></li><li><a ui-sref="hscwfunctions" data-translate="about-us.titlebriefhistory">Brief History</a></li><li><a ui-sref="hscwpowers" data-translate="about-us.titlepowers">POWERS OF HSCW</a></li><li><a target="_blank" href="../content/document/HSCW Act, 2012.pdf">Download PDF</a></li></ul></div></div>');
$templateCache.put('app/about-us/hscwfunctions.html','<div class="container-fluid"><div class="col-md-9"><h3 class="text-info" data-translate="about-us.titlebriefhistory"></h3><p class="text-warning text-justify" data-translate="about-us.contenthscwfunctions">Content</p></div><div class="col-md-3"><h5 class="text-success" data-translate="about-us.subtitle"></h5><hr><ul><li><a ui-sref="about-us" data-translate="about-us.titleconstitution">Constitution of Commission</a></li><!--<li><a data-translate="about-us.titlemandate">Mandate of Commission</a></li>--><li><a ui-sref="hscwact" data-translate="about-us.titlehscwact">HSCW ACT</a></li><li><a ui-sref="hscwfunctions" data-translate="about-us.titlebriefhistory">Brief History</a></li><li><a ui-sref="hscwpowers" data-translate="about-us.titlepowers">POWERS OF HSCW</a></li><li><a ui-sref="hscwpowers">Download PDF</a></li></ul></div></div>');
$templateCache.put('app/about-us/powershscw.html','<div class="container-fluid"><div class="col-md-9"><h3 class="text-info" data-translate="about-us.titlepowers"></h3><p class="text-warning text-justify" data-translate="about-us.titlecontentpowers">Content</p></div><div class="col-md-3"><h5 class="text-success" data-translate="about-us.subtitle"></h5><hr><ul><!--<li><a data-translate="about-us.titlebriefhistory">Brief History</a></li>--><li><a ui-sref="about-us" data-translate="about-us.titleconstitution">Constitution of Commission</a></li><!--<li><a data-translate="about-us.titlemandate">Mandate of Commission</a></li>--><li><a ui-sref="hscwact" data-translate="about-us.titlehscwact">HSCW ACT</a></li><li><a ui-sref="hscwfunctions" data-translate="about-us.titlebriefhistory">Brief History</a></li><li><a ui-sref="hscwpowers" data-translate="about-us.titlepowers">POWERS OF HSCW</a></li></ul></div></div>');
$templateCache.put('app/contact-us/chairpersons.html','<div class="container-fluid"><div class="col-md-9 table-responsive"><h3 class="text-warning" data-translate="contact-us.titlechairpersons">List of Chairpersons<hr></h3><table class="table table-Stripped table-inverse table-bordered"><thead><tr><th>#</th><th>Name</th><th>Designation</th><th>Period</th></tr></thead><tbody><tr><td>1</td><td>Smt. Hemlata Kashyap</td><td>Chairperson</td><td>23.12.1999 to 29.02.2000</td></tr><tr><td>2</td><td>Smt. Sheela Bhayan</td><td>Chairperson</td><td>10.04.2000 to 07.03.2005</td></tr><tr><td>3</td><td>Ms. Sushila Sharma</td><td>Chairperson</td><td>23.01.2008 to 22.01.2014</td></tr><tr><td>4</td><td>Ms. Kamlesh Panchal</td><td>Chairperson</td><td>23.05.2014 to 22.05.2017</td></tr><tr><td>5</td><td>Ms. Partibha Suman</td><td>Chairperson</td><td>25.07.2017 to 24.07.2020</td></tr><tr><td>6</td><td>Ms. Preeti Bhardwaj Dalal</td><td>Chairperson (O)</td><td>25.07.2020 to 17.01.2022</td></tr><tr><td>7</td><td>Smt. Renu Bhatia</td><td>Chairperson</td><td>19.01.2022 to 09.06.2026</td></tr><tr><td>8</td><td>Smt. Usha Priyadarshi</td><td>Chairperson</td><td><b>15.06.2026 onwards</b></td></tr></tbody></table></div><div class="col-md-3"><br><h3 class="text-warning" data-translate="contact-us.inthissection">&nbsp; &nbsp; &nbsp; In this section</h3><hr><ul><li><a ui-sref="chairpersons" data-translate="contact-us.chairperson">List of Chairpersons</a></li><li><a ui-sref="vicechairpersons" data-translate="contact-us.vicechairperson">List of Vice Chairpersons</a></li><li><a ui-sref="member-list">List of Members</a></li></ul></div></div>');
$templateCache.put('app/contact-us/contact-us.html','<div class="container-fluid"><h3 class="text-danger" data-translate="contact-us.title">title</h3><div class="row"><div class="col-md-6"><div class="panel panel-danger jumbotron"><h4 class="text-danger" data-translate="contact-us.subtitle"></h4><h5 data-translate="contact-us.content"></h5></div></div><div class="col-md-6"><iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3430.7258242079993!2d76.85671478013326!3d30.697989409111454!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390f9371c5ceef49%3A0x9f2835b7ce2a6e6!2s31-34%2C%20haryana%20state%20commission%20for%20women%20Bay%2C%20near%20by%20BP%20PETROL%E2%9B%BD%20PUMP%2C%20Sector%202%2C%20Panchkula%2C%20Haryana%20134109!5e0!3m2!1sen!2sin!4v1781593863255!5m2!1sen!2sin" width="600" height="450" style="border:0" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe></div></div><h3 class="text-center" data-translate="contact-us.members"><b>Staff HSCW</b></h3><div class="col-md-12 table-responsive"><table class="table table-bordered"><thead><tr><th>#</th><th>Name</th><th>Designation</th><th>Mobile No.</th></tr></thead><tbody><tr><td>1</td><td>Smt. Usha Priyadarshi</td><td>Chairperson</td><td>0172-2584039</td></tr><tr><td>2</td><td>Smt. Meena Parmar</td><td>Vice Chairperson</td><td>0172-2583639</td></tr><tr><td>3</td><td>Smt. Monica Malik, IAS</td><td>Member Secretary</td><td>0172-2583639</td></tr><tr><td>4</td><td>Smt. Bharti Saini</td><td>Member</td><td>0172-2584039</td></tr><tr><td>5</td><td>Smt. Sunita Lohchab</td><td>Member</td><td>0172-2583639</td></tr><tr><td>6</td><td>Smt. Suman Sehzadwala</td><td>Member</td><td>0172-2583639</td></tr><tr><td>7</td><td>Dr. Anukampa Garg</td><td>Member</td><td>0172-2584039</td></tr><tr><td>8</td><td>Kumari Sunita Chauhan</td><td>Member</td><td>0172-2583639</td></tr><tr><td>9</td><td>Smt. Priyanka Soni, IAS</td><td>Director, Women and Child Development Department Haryana<br>(Ex-officio Member)</td><td>0172-2583639</td></tr><tr><td>10</td><td>Ajay Singhal, IPS</td><td>Director General of Police<br>(Ex-Officio Member)</td><td>0172-2584039</td></tr><tr><td>11</td><td>Sh. Shekhar Vidyarthi, IAS</td><td>Commissioner &amp; Secretary WCD to Government of Haryana<br>(Special Invitee)</td><td>0172-2583639</td></tr><tr><td>12</td><td>Sh. Jitender Kumar</td><td>Dy. Superintendent</td><td>0172-2583639<br>95600-80115</td></tr><tr><td>13</td><td>Sh. Anshul Nain</td><td>Consultant</td><td>0172-2584039</td></tr></tbody></table></div></div>');
$templateCache.put('app/contact-us/contacts.html','<div class="container-fluid"><div class="col-md-8 table-responsive"><h3 class="text-warning" data-translate="contact-us.titlecp">Commissioner of Police, Haryana :<hr></h3><table class="table table-Stripped table-inverse table-bordered" data-translate="contact-us.cptable"><thead><tr><th>#</th><th>District Name</th><th>Contact No.</th></tr></thead><tbody><tr><td>1</td><td>PANCHKULA</td><td>0172-2555917<br>9729990000</td></tr><tr><td>2</td><td>GURUGRAM</td><td>0124-2311200<br>9999981801<br></td></tr><tr><td>3</td><td>FARIDABAD</td><td>0129-2437444<br>9582200100<br></td></tr></tbody></table></div><div class="col-md-4"><h3 class="text-warning" data-translate="contact-us.inthissection">&nbsp; &nbsp; &nbsp; In this Section</h3><hr><ul><li><a ui-sref="contacts" data-translate="contact-us.cp">Commisssioner of Police</a></li><li><a ui-sref="sp" data-translate="contact-us.sp">Superintendent of Police</a></li><li><a ui-sref="po" data-translate="contact-us.po">Protection Officer</a></li><li><a ui-sref="dpo" data-translate="contact-us.dpo">District Programme Officer</a></li><li><a ui-sref="dcpo" data-translate="contact-us.dcpo">District Child Program Officer</a></li><li><a ui-sref="wps" data-translate="contact-us.wps">Women Police Station</a></li></ul></div></div>');
$templateCache.put('app/contact-us/dcpo.html','<div class="container-fluid"><div class="col-md-8 table-responsive"><h3 class="text-warning" data-translate="contact-us.titledcpo">District Child Program Officer, Haryana :<hr></h3><table class="table table-Stripped table-inverse table-bordered" data-translate="contact-us.dcpotable"><thead><tr><th>#</th><th>District Name</th><th>Contact No.</th><th>E-mail ID</th><th>Address</th></tr></thead><tbody><tr><td>1</td><td>Ambala</td><td>0171-2530051<br>9466831018</td><td>dcpo.amb@gmail.com</td><td>Distt. Child Protection Officer, Ambala, H#168-XI B Shastri Nagar Near Manav Chowk, Ambala City</td></tr><tr><td>2</td><td>Bhiwani</td><td>01664-252352<br>7357428352</td><td>dcpobwn@gmail.com</td><td>Bal Bhawan Campus, Near Red Cross Society Office, Zoo Road, Bhiwani, 127021</td></tr><tr><td>3</td><td>Faridabad</td><td>0129-2265199<br>9868845544</td><td>dcps.faridabad.icps@gmail.com</td><td>DPO Office, ICDS Cell, Opposite Sai Mandir, Sector-16, faridabad</td></tr><tr><td>4</td><td>Fatehabad</td><td>01667-222606<br>9802317731<br>7015689440</td><td>dcpuftb@gmail.com</td><td>Room No.52, Mini Secretariat, Fatehabad</td></tr><tr><td>5</td><td>Gurgaon</td><td>0124-2300098<br>9467749103</td><td>dcps.ggn@gmil.com</td><td>DPO office, First Floor, Front of Mini Secretariat, Gurugram</td></tr><tr><td>6</td><td>Hisar</td><td>01662-253754<br>9996013790</td><td>icpshisar@gmail.com</td><td>Red Cross Building, Block-A, Room No.16, Delhi Road, Hisar</td></tr><tr><td>7</td><td>Jhajjar</td><td>01251-252797<br>9871531697</td><td>dcpsjhajjar@gmail.com</td><td>District Child Program Officer, Kosli Road, First Street, Behind LIC Office, Jhajjar</td></tr><tr><td>8</td><td>Jind</td><td>01681-245003<br>8607054800</td><td>icpsjind@gmail.com</td><td>Mini Secretariat Old Building, Room No.8, Jind</td></tr><tr><td>9</td><td>Kaithal</td><td>01746-234525<br>9467659137</td><td>dcpoktl@gmail.com</td><td>Distt. Child Protection Unit, Near DC Residence, Karnal road, Kaithal</td></tr><tr><td>10</td><td>Karnal</td><td>0184-2272020<br>8813860846</td><td>dcpskrl@gmail.com</td><td>Mahila Ashram Complex, Near DAV Public School, Karnal</td></tr><tr><td>11</td><td>Kurukshetra</td><td>01744-222932<br>9255976784</td><td>dcpokkr.wcd@gmail.com</td><td>Room No 2019, First Floor, New Building, Mini Secretariatpokkr.wcd@gmail.com</td></tr><tr><td>12</td><td>Mewat</td><td>01267-274270<br>8059159786</td><td>pomwt.wcd@gmail.com</td><td>SRS Showroom cloth & Garment, Tauru road, Nuh, Mewat</td></tr><tr><td>13</td><td>Narnual</td><td>01282-254721<br>9813654301<br>9991133722<br>9416254301</td><td>ponrl.wcd@gmail.com</td><td>Kothi no.721 Hooda, sec-1, near subhash park, Narnaul</td></tr><tr><td>14</td><td>Panchkula</td><td>0172-2582220<br>9988747546</td><td>dcpspanchkula@gmail.com</td><td>Room no 67, 3rd floor, New Mini Secretariat, Sector-1, Panchkula</td></tr><tr><td>15</td><td>Panipat</td><td>0180-2641574<br>9255644002</td><td>Popnp.wcd@gmail.com</td><td>Mini Secretariat, Room no 213-14, Second Floor, Panipat</td></tr><tr><td>16</td><td>Palwal</td><td>9991249664</td><td>Popwl.wcd@gmail.com</td><td>Bal Bhawan, Near BSNL, Telephone exchange, committee chowk, Palwal</td></tr><tr><td>17</td><td>Rewari</td><td>01274-221852<br>9992080512</td><td>dcpsrewari@gmail.com<br>porewari.wcd@gmail.com</td><td>Bal Bhawan, Rewari</td></tr><tr><td>18</td><td>Rohtak</td><td>01262-252920<br>9728299633</td><td>Portk.wcd@gmail.com</td><td>Distt. Programme Officer-Cum DCPO, near Canal Rest House and DC Residence, Rohtak</td></tr><tr><td>19</td><td>Sirsa</td><td>01666-230295<br>9888077235</td><td>dcpssirsa@gmail.com<br>posirsa@gmail.com</td><td>Red Cross Working Women Hostel, opp. Divya Yog Sadna Mandir, Sirsa</td></tr><tr><td>20</td><td>Sonepat</td><td>0130-2222736<br>9728504509</td><td>dcposnp@gmail.com</td><td>ADC office, Gohana road, Vikas sadan, Sonepat</td></tr><tr><td>21</td><td>Yamunanagar</td><td>01732-237050<br>9034044880</td><td>dcpo.ynr@gmail.com</td><td>SCO-30P, First Floor, Shopping Center No 1, Sec-17, HUDA, Jagadhri</td></tr></tbody></table></div><div class="col-md-4"><h3 class="text-warning" data-translate="contact-us.inthissection">&nbsp; &nbsp; &nbsp; Contact Details</h3><hr><ul><li><a ui-sref="contacts" data-translate="contact-us.cp">Commisssioner of Police</a></li><li><a ui-sref="sp" data-translate="contact-us.sp">Superintendent of Police</a></li><li><a ui-sref="po" data-translate="contact-us.po">Protection Officer</a></li><li><a ui-sref="dpo" data-translate="contact-us.dpo">District Programme Officer</a></li><li><a ui-sref="dcpo" data-translate="contact-us.dcpo">District Child Program Officer</a></li><li><a ui-sref="wps" data-translate="contact-us.wps">Women Police Station</a></li></ul></div></div>');
$templateCache.put('app/contact-us/dpo.html','<div class="container-fluid"><div class="col-md-8 table-responsive"><h3 class="text-warning" data-translate="contact-us.titledpo">District Programme Officers, Haryana :<hr></h3><table class="table table-Stripped table-inverse table-bordered" data-translate="contact-us.dpotable"><thead><tr><th>#</th><th>District Name</th><th>Contact No.</th><th>Address</th></tr></thead><tbody><tr><td>1</td><td>Ambala</td><td>0171-2530910</td><td>29, Manav Vihar, Opp. Dayanand Public School, Ambala City</td></tr><tr><td>2</td><td>Bhiwani</td><td>01664-243956</td><td>Vikas Sadan, Bhiwani</td></tr><tr><td>3</td><td>Faridabad</td><td>0129-2264207</td><td>Sector 16-A, Opp. Sai Mandir</td></tr><tr><td>4</td><td>Fatehabad</td><td>01667-230606</td><td>Mini Secretariat, Fatehabad</td></tr><tr><td>5</td><td>Gurgaon</td><td>0124-2331148</td><td>Ist Floor-Vikas sadan, Opp. Mini Secretariat, Gururam</td></tr><tr><td>6</td><td>Hisar</td><td>01662-239097</td><td>Mini Secretariat, Hisar</td></tr><tr><td>7</td><td>Jhajjar</td><td>01251-254840</td><td>Mini Secretariat, Jhajjar</td></tr><tr><td>8</td><td>Jind</td><td>01681-246930</td><td>Mini Secretariat, Jind</td></tr><tr><td>9</td><td>Kaithal</td><td>01746-235102</td><td>Mini Secretariat, Kaithal</td></tr><tr><td>10</td><td>Karnal</td><td>0184-2270175</td><td>Mahila Ashram, Karnal</td></tr><tr><td>11</td><td>Kurukshetra</td><td>01744-223931</td><td>Mini Secretariat, Kurukshetra</td></tr><tr><td>12</td><td>Mewat</td><td>01267-274478</td><td>MDA Colony, Nangli Road, Mewat</td></tr><tr><td>13</td><td>Narnual</td><td>01282-252331</td><td>Mini Secretariat, Narnual</td></tr><tr><td>14</td><td>Panchkula</td><td>0172-2590462</td><td>Haryana Seeds Corporation, Beej Bhawan, Bays 3-6, Sector-2, Panchkula</td></tr><tr><td>15</td><td>Panipat</td><td>0180-2653574</td><td>Mini Secretariat, Panipat</td></tr><tr><td>16</td><td>Palwal</td><td>01275-245245</td><td>Mini Secretariat, Palwal</td></tr><tr><td>17</td><td>Rewari</td><td>01274-223694</td><td>Model Town, Old DC Office, Rewari</td></tr><tr><td>18</td><td>Rohtak</td><td>01262-247135</td><td>Vikas Bhawan, Room-3(4) First floor Opp. Irrigation Rest House, Rohtak</td></tr><tr><td>19</td><td>Sirsa</td><td>01666-247239</td><td>Mini Secretariat, Sirsa</td></tr><tr><td>20</td><td>Sonepat</td><td>0130-2222735</td><td>Vikas Sadan, Sonepat</td></tr><tr><td>21</td><td>Yamunanagar</td><td>01732-220588</td><td>Guru Arjun Nagar, Near Vivekanand School, Sector-17, HUDA, Yamunanagar</td></tr></tbody></table></div><div class="col-md-4"><h3 class="text-warning" data-translate="contact-us.inthissection">&nbsp; &nbsp; &nbsp; Contact Details</h3><hr><ul><li><a ui-sref="contacts" data-translate="contact-us.cp">Commisssioner of Police</a></li><li><a ui-sref="sp" data-translate="contact-us.sp">Superintendent of Police</a></li><li><a ui-sref="po" data-translate="contact-us.po">Protection Officer</a></li><li><a ui-sref="dpo" data-translate="contact-us.dpo">District Programme Officer</a></li><li><a ui-sref="dcpo" data-translate="contact-us.dcpo">District Child Program Officer</a></li><li><a ui-sref="wps" data-translate="contact-us.wps">Women Police Station</a></li></ul></div></div>');
$templateCache.put('app/contact-us/members-list.html','<div class="container-fluid"><div class="col-md-9 table-responsive"><h3 class="text-warning">List of Members<hr></h3><table class="table table-Stripped table-inverse table-bordered"><thead><tr><th>#</th><th>Name</th><th>Designation</th><th>Period</th></tr></thead><tbody><tr><td>1</td><td>Smt. Bharti Saini</td><td>Member</td><td>15.06.2026 onwards</td></tr><tr><td>2</td><td>Smt. Sunita Lohchab</td><td>Member</td><td>15.06.2026 onwards</td></tr><tr><td>3</td><td>Smt. Suman Sehzadwala</td><td>Member</td><td>15.06.2026 onwards</td></tr><tr><td>4</td><td>Dr. Anukampa Garg</td><td>Member</td><td>15.06.2026 onwards</td></tr><tr><td>5</td><td>Kumari Sunita Chauhan</td><td>Member</td><td>15.06.2026 onwards</td></tr></tbody></table></div><div class="col-md-3"><br><h3 class="text-warning" data-translate="contact-us.inthissection">&nbsp; &nbsp; &nbsp; In this section</h3><hr><ul><li><a ui-sref="chairpersons" data-translate="contact-us.chairperson">List of Chairpersons</a></li><li><a ui-sref="vicechairpersons" data-translate="contact-us.vicechairperson">List of Vice Chairpersons</a></li><li><a ui-sref="member-list">List of Members</a></li></ul></div></div>');
$templateCache.put('app/contact-us/members.html','<div class="container-fluid"><div class="col-md-9 table-responsive"><h3 class="text-warning" data-translate="contact-us.titlemember">Name of Office Bearers and Members of Haryana State Commission for Women:<hr></h3><table class="table table-Stripped table-inverse table-bordered" data-translate="contact-us.membertable"><thead><tr><th>#</th><th>Name</th><th>Designation</th><th>Contact No.</th></tr></thead><tbody><tr><td>1</td><td>Smt. Partibha Suman</td><td>Chairperson</td><td>0172-2584039</td></tr><tr><td>2</td><td>Smt. Preeti Bhardwaj</td><td>Vice Chairperson</td><td>0172-2583639</td></tr><tr><td>3</td><td>Smt. Monica Malik, HCS</td><td>Member Secretary</td><td>-</td></tr><tr><td>4</td><td>Smt. Indu Yadav</td><td>Member</td><td>-</td></tr><tr><td>5</td><td>Ms. Namrata Gaur</td><td>Member</td><td>-</td></tr><tr><td>6</td><td>Ms. Sonia Aggarwal</td><td>Member</td><td>-</td></tr><tr><td>7</td><td>Smt. Suman Bedi</td><td>Member</td><td>-</td></tr><tr><td>8</td><td>Smt. Anita Yadav, IAS</td><td>Director, Women and Child Development<br>Department Haryana<br>(Ex-officio Member)</td><td>-</td></tr><tr><td>9</td><td>Sh. Baljit Singh Sandhu, IPS</td><td>Director General of Police<br>(Ex-Officio Member)</td><td>-</td></tr><tr><td>10</td><td>Sh. Raja Sekhar Vundru, IAS</td><td>Principal Secretary to Govt. Haryana,<br>Women and Child Development Haryana<br>(Special Invitee)</td><td>-</td></tr></tbody></table></div><div class="col-md-3"><br><h3 class="text-warning" data-translate="contact-us.inthissection">&nbsp; &nbsp; &nbsp; In this section</h3><hr><ul><li><a data-translate="contact-us.chairperson">List of Chairpersons</a></li><li><a data-translate="contact-us.vicechairperson">List of Vice Chairpersons</a></li><li><a data-translate="contact-us.members">List of Members</a></li></ul></div></div>');
$templateCache.put('app/contact-us/po.html','<div class="container-fluid"><div class="col-md-8 table-responsive"><h3 class="text-warning" data-translate="contact-us.titlepo">Police Protection Officers, Haryana :<hr></h3><table class="table table-Stripped table-inverse table-bordered" data-translate="contact-us.potable"><thead><tr><th>#</th><th>District Name</th><th>Contact No.</th><th>Address</th></tr></thead><tbody><tr><td>1</td><td>Ambala</td><td>9416201344<br>9729990159</td><td>Mahila Thana O/o DCP, Police Line, Ambala City</td></tr><tr><td>2</td><td>Bhiwani</td><td>8607222475</td><td>Mahila Thana , Police line, Bhiwani</td></tr><tr><td>3</td><td>Faridabad</td><td>9210474464</td><td>Mahila Thana, Sector- 16A, Opposite Sai Baba Mandir, Old Faridabad</td></tr><tr><td>4</td><td>Fatehabad</td><td>9467161633<br>8814011719</td><td>Mahila Thana, Natana Road, Fathehabad</td></tr><tr><td>5</td><td>Gurgaon</td><td>9968902506<br>7065192903</td><td>Gurgaon\tMahila Thana ,Gurgaon</td></tr><tr><td>6</td><td>Hisar</td><td>9729011052</td><td>Mahila Thana , Police Line Hisar</td></tr><tr><td>7</td><td>Jhajjar</td><td>8860421000</td><td>Mahila Thana , Jhajjar</td></tr><tr><td>8</td><td>Jind</td><td>9466106100</td><td>Mahila Thana , Safidon Chowk, Jind</td></tr><tr><td>9</td><td>Kaithal</td><td>9813453138</td><td>Mahila Thana , Pehwa Chowk, Karnal Road, Kaithal</td></tr><tr><td>10</td><td>Karnal</td><td>9466125250</td><td>Mahila Thana , Near Gandhi Chowk, Karnal</td></tr><tr><td>11</td><td>Kurukshetra</td><td>9466125250</td><td>Mahila Thana , Sec-8. Near Ayurvedic Collage, Kurukshetra</td></tr><tr><td>12</td><td>Mewat</td><td>9466200554</td><td>Mahila Thana ,Nuh, Mewat</td></tr><tr><td>13</td><td>Mahendragarh</td><td>9466117028</td><td>Mahila Thana , Near Police Line, Mahendragarh</td></tr><tr><td>14</td><td>Panchkula</td><td>9501144188</td><td>Mahila Thana , Mansa Devi Complex, Sec-5, Panchkula</td></tr><tr><td>15</td><td>Panipat</td><td>9729022757</td><td>Mahila Thana , Sec-13-17, Near Yamunanagar Enclave, HUDA, Panipat</td></tr><tr><td>16</td><td>Palwal</td><td>9813985280</td><td>Mahila Thana , Near Agra Chowk, Palwal</td></tr><tr><td>17</td><td>Rewari</td><td>9466117028</td><td>Mahila Thana , Police Line, Rewari</td></tr><tr><td>18</td><td>Rohtak</td><td>9466106100</td><td>Mahila Police, Ambedkar Chowk, Rohtak</td></tr><tr><td>19</td><td>Sirsa</td><td>9467161600<br>8814011719</td><td>Mahila Thana , F Block, Near Govt. Hospital Rania Road, Sirsa</td></tr><tr><td>20</td><td>Sonepat</td><td>9466111474</td><td>Mahila Thana , Near Gudh Mandi, Sonepat</td></tr><tr><td>21</td><td>Yamunanagar</td><td>9416201344</td><td>Mahila Thana , Model Town Near Yamunanagar Bus Stand, Yamunanagar</td></tr></tbody></table></div><div class="col-md-4"><h3 class="text-warning" data-translate="contact-us.inthissection">&nbsp; &nbsp; &nbsp; Contact Details</h3><hr><ul><li><a ui-sref="contacts" data-translate="contact-us.cp">Commisssioner of Police</a></li><li><a ui-sref="sp" data-translate="contact-us.sp">Superintendent of Police</a></li><li><a ui-sref="po" data-translate="contact-us.po">Protection Officer</a></li><li><a ui-sref="dpo" data-translate="contact-us.dpo">District Programme Officer</a></li><li><a ui-sref="dcpo" data-translate="contact-us.dcpo">District Child Program Officer</a></li><li><a ui-sref="wps" data-translate="contact-us.wps">Women Police Station</a></li></ul></div></div>');
$templateCache.put('app/contact-us/sp.html','<div class="container-fluid"><div class="col-md-8 table-responsive"><h3 class="text-warning" data-translate="contact-us.titlesp">Superintendent Of Police, Haryana :<hr></h3><table class="table table-Stripped table-inverse table-bordered" data-translate="contact-us.sptable"><thead><tr><th>#</th><th>District Name</th><th>Contact No.</th></tr></thead><tbody><tr><td>1</td><td>Ambala</td><td>0171-2553520<br>0171-2550060<br>9729990001</td></tr><tr><td>2</td><td>Bhiwani</td><td>01664-243700<br>01664-242544<br>8814011400</td></tr><tr><td>3</td><td>Charkhi Dadri</td><td>01250-222409<br>9488193112<br>8814072100</td></tr><tr><td>4</td><td>Fatehabad</td><td>01667-230005<br>01667-230012<br>01667-230575</td></tr><tr><td>5</td><td>Hansi</td><td>01663-257100<br>9983977715</td></tr><tr><td>6</td><td>Hisar</td><td>01662-232307<br>01662-281401</td></tr><tr><td>7</td><td>Jhajjar</td><td>01251-252049<br>01251-253200</td></tr><tr><td>8</td><td>Jind</td><td>01681-245285<br>01681-246809</td></tr><tr><td>9</td><td>Kaithal</td><td>01746-235933<br>01746-229987</td></tr><tr><td>10</td><td>Karnal</td><td>0184-4091002<br>0184-2267700</td></tr><tr><td>11</td><td>Kurukshetra</td><td>01744-220319<br>01744-220320</td></tr><tr><td>12</td><td>Mewat at Nuh</td><td>01267-274616</td></tr><tr><td>13</td><td>M. Garh at Narnaul</td><td>01282-251022<br>01282-254396</td></tr><tr><td>14</td><td>Palwal</td><td>01275-298069<br>8814000400</td></tr><tr><td>15</td><td>Panipat</td><td>0180-2699100<br>9896906100</td></tr><tr><td>16</td><td>Rewari</td><td>01274-222790<br>01274-223317</td></tr><tr><td>17</td><td>Rohtak</td><td>01262-228114<br>01262-228145</td></tr><tr><td>18</td><td>Sirsa</td><td>01666-247212<br>8814011600</td></tr><tr><td>19</td><td>Sonipat</td><td>0130-2222934<br>8053882399</td></tr><tr><td>20</td><td>Yamunanagar</td><td>01732-200203<br>01732-200202</td></tr></tbody></table></div><div class="col-md-4"><h3 class="text-warning" data-translate="contact-us.inthissection">&nbsp; &nbsp; &nbsp; Contact Details</h3><hr><ul><li><a ui-sref="contacts" data-translate="contact-us.cp">Commisssioner of Police</a></li><li><a ui-sref="sp" data-translate="contact-us.sp">Superintendent of Police</a></li><li><a ui-sref="po" data-translate="contact-us.po">Protection Officer</a></li><li><a ui-sref="dpo" data-translate="contact-us.dpo">District Programme Officer</a></li><li><a ui-sref="dcpo" data-translate="contact-us.dcpo">District Child Program Officer</a></li><li><a ui-sref="wps" data-translate="contact-us.wps">Women Police Station</a></li></ul></div></div>');
$templateCache.put('app/contact-us/vicechairpersons.html','<div class="container-fluid"><div class="col-md-9 table-responsive"><h3 class="text-warning">List of Vice Chairpersons<hr></h3><table class="table table-Stripped table-inverse table-bordered"><thead><tr><th>#</th><th>Name</th><th>Designation</th><th>Period</th></tr></thead><tbody><tr><td>1</td><td>Ms. Preeti Chawla</td><td>Vice Chairperson</td><td>04.01.2000 to 07.03.2005</td></tr><tr><td>2</td><td>Ms. Chander Prabha</td><td>Vice Chairperson</td><td>23.01.2008 to 23.01.2014</td></tr><tr><td>3</td><td>Ms. Suman Dahiya</td><td>Member Secretary</td><td>26.05.2014 to 25.05.2017</td></tr><tr><td>4</td><td>Ms. Preeti Bhardwaj</td><td>Member</td><td>15.12.2017 to 18.01.2023</td></tr><tr><td>5</td><td>Ms. Sonia Aggarwal</td><td>Vice Chairperson</td><td>15.03.2024 to 09.01.2025</td></tr><tr><td>6</td><td>Smt. Meena Parmar</td><td>Vice Chairperson</td><td>15.06.2026 onwards</td></tr></tbody></table></div><div class="col-md-3"><br><h3 class="text-warning" data-translate="contact-us.inthissection">&nbsp; &nbsp; &nbsp; In this section</h3><hr><ul><li><a ui-sref="chairpersons" data-translate="contact-us.chairperson">List of Chairpersons</a></li><li><a ui-sref="vicechairpersons" data-translate="contact-us.vicechairperson">List of Vice Chairpersons</a></li><li><a ui-sref="member-list">List of Members</a></li></ul></div></div>');
$templateCache.put('app/contact-us/wps.html','<div class="container-fluid"><div class="col-md-8 table-responsive"><h3 class="text-warning" data-translate="contact-us.wps">Women Police Station, Haryana :<hr></h3><table class="table table-Stripped table-inverse table-bordered" data-translate="contact-us.wpstable"><thead><tr><th>#</th><th>District Name</th><th>Contact No.</th><th>Email</th></tr></thead><tbody><tr><td>1</td><td>Panchkula</td><td>(0172)-2021091<br>8146630022</td><td>showomenpkl-hry@gov.in</td></tr><tr><td>2</td><td>Ambala</td><td>(0171)-2551091<br>9729990165</td><td>showomenuamb-hry@gov.in</td></tr><tr><td>3</td><td>Kurukshetra</td><td>(01744)-221091<br>7056700135</td><td>showomenkkr-hry@gov.in</td></tr><tr><td>4</td><td>Karnal</td><td>(0184)-2251091<br>8572881091</td><td>showomenkrl-hry@gov.in</td></tr><tr><td>5</td><td>Panipat</td><td>(0180)-2691091<br>7056731091</td><td>showomenppt-hry@gov.in</td></tr><tr><td>6</td><td>Sonipat</td><td>(0130)-2241091<br>8053882349</td><td>showomenspt1-hry@gov.in</td></tr><tr><td>7</td><td>Rohtak</td><td>(01262)-271091<br>8199001091</td><td>showomenroh-hry@gov.in</td></tr><tr><td>8</td><td>Jhajjar</td><td>8930111091</td><td>showomenjjr-hry@gov.in</td></tr><tr><td>9</td><td>Rewari</td><td>(01274)-251722<br>7056666133</td><td>showomenrwr-hry@gov.in</td></tr><tr><td>10</td><td>Gurugram</td><td>8506000342</td><td>showomenpsgn-hry@gov.in</td></tr><tr><td>11</td><td>Faridabad</td><td>(0129)-2261092<br>9582200061</td><td>showomenfbd-hry@gov.in</td></tr><tr><td>12</td><td>Yamunanagar</td><td>(01732)-251002<br>8818001307</td><td>showomenynr-hry@gov.in</td></tr><tr><td>13</td><td>Mewat</td><td>8397991091</td><td>showomenmwt-hry@gov.in</td></tr><tr><td>14</td><td>Palwal</td><td>(01275)-241091<br>8930511091</td><td>showomenpwl-hry@gov.in</td></tr><tr><td>15</td><td>Narnaul</td><td>(01282)-251091<br>7056601091</td><td>showomennnl-hry@gov.in</td></tr><tr><td>16</td><td>Bhiwani</td><td>(01664)-251091<br>8814011409</td><td>showomenbwn-hry@gov.in</td></tr><tr><td>17</td><td>Sirsa</td><td>(01666)\xA0231091<br>8813801091</td><td>showomensrs-hry@gov.in</td></tr><tr><td>18</td><td>Fatehabad</td><td>(01667)-230140<br>8814011721</td><td>showomenftb-hry@gov.in</td></tr><tr><td>19</td><td>Hisar</td><td>(01662)-271091<br>8814031091</td><td>showomenhsr-hry@gov.in</td></tr><tr><td>20</td><td>Jind</td><td>8813991091</td><td>showomenjind-hry@gov.in</td></tr><tr><td>21</td><td>Kaithal</td><td>9053052118</td><td>showomenktl-hry@gov.in</td></tr><tr><td>22</td><td>Charkhi Dadri</td><td>7419301109</td><td>--</td></tr></tbody></table></div><div class="col-md-4"><h3 class="text-warning" data-translate="contact-us.inthissection">&nbsp; &nbsp; &nbsp; Contact Details</h3><hr><ul><li><a ui-sref="contacts" data-translate="contact-us.cp">Commisssioner of Police</a></li><li><a ui-sref="sp" data-translate="contact-us.sp">Superintendent of Police</a></li><li><a ui-sref="po" data-translate="contact-us.po">Protection Officer</a></li><li><a ui-sref="dpo" data-translate="contact-us.dpo">District Programme Officer</a></li><li><a ui-sref="dcpo" data-translate="contact-us.dcpo">District Child Program Officer</a></li><li><a ui-sref="wps" data-translate="contact-us.wps">Women Police Station</a></li></ul></div></div>');
$templateCache.put('app/faqs/faqs.html','<div ng-cloak><div class="container-fluid"><div class="page-header"><h1 data-translate="faqs.title"><small>Frequently Asked Questions - HSCW</small></h1></div><div class="row"><div id="faq" class="col-md-12"><div class="panel-group" id="accordion"><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" data-target="#collapse-1" data-translate="faqs.q1">Q1. How can I file a petition in the Commission?</a></h4></div><div id="collapse-1" class="panel-collapse collapse"><div class="panel-body"><p data-translate="faqs.ans1">Petitions can be submitted to the Commission on white paper, either written or typed giving the full postal addresses, contact number of the petitioner and respondents.</p></div></div></div><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" data-target="#collapse-2" data-translate="faqs.q2">Q2. Is it necessary to affix court fee stamp in the petition submitted?</a></h4></div><div id="collapse-2" class="panel-collapse collapse"><div class="panel-body" data-translate="faqs.ans2">There is no need for affixing court fee stamp or remitting fee for filing a petition with the Commission.</div></div></div><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" data-target="#collapse-3" data-translate="faqs.q3">Q3. What is the number of copies of the petition to be submitted?</a></h4></div><div id="collapse-3" class="panel-collapse collapse"><div class="panel-body" data-translate="faqs.ans3">Copies of the petition to be submitted depend on the number of addresses of respondents.</div></div></div><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" data-target="#collapse-4" data-translate="faqs.q4">Q4. Is it necessary to have the legal assistance of an advocate for filing the petition?</a></h4></div><div id="collapse-4" class="panel-collapse collapse"><div class="panel-body" data-translate="faqs.ans4">Service of an advocate is not entertained for filing a petition in the commission.</div></div></div><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" data-target="#collapse-5" data-translate="faqs.q5">Q5. Can I approach the Commission for getting solution in a civil case?</a></h4></div><div id="collapse-5" class="panel-collapse collapse"><div class="panel-body" data-translate="faqs.ans5">No. Petitions having a civil nature are not considered in the Commission.</div></div></div><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" data-target="#collapse-6" data-translate="faqs.q6">Q6. Are petitions by men accepted in the Commission?</a></h4></div><div id="collapse-6" class="panel-collapse collapse"><div class="panel-body" data-translate="faqs.ans6">In exceptional cases, petitions by men for family re-union/disputes are accepted in Women interest in the Commission.</div></div></div><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" data-target="#collapse-7" data-translate="faqs.q7">Q7. Petition, that does not involve harassment of women or any issues related to women entertained in the Commission?</a></h4></div><div id="collapse-7" class="panel-collapse collapse"><div class="panel-body" data-translate="faqs.ans7">No. Such general petitions not involving any issue of women are not entertained in the Commission.</div></div></div><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" data-target="#collapse-8" data-translate="faqs.q8">Q8.\xA0Can I approach the Commission for getting Divorce from my husband?</a></h4></div><div id="collapse-8" class="panel-collapse collapse"><div class="panel-body" data-translate="faqs.ans8">As such the Haryana Women\'s Commission does not accept any petition for divorce. But in some rare cases, it may be necessary for the wife to get relief from her husband through divorce; in such cases Commission may suggest them to file a case for divorce in the court.</div></div></div><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" data-target="#collapse-9" data-translate="faqs.q9">Q9. Does the Commission providing legal aid to the affected women?</a></h4></div><div id="collapse-9" class="panel-collapse collapse"><div class="panel-body" data-translate="faqs.ans9">The Commission recommends legal aid through HSLSA (Haryana State Legal Services authority) in Panchkula and through DLSA (District Legal Services Authority).</div></div></div><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" data-target="#collapse-10" data-translate="faqs.q10">Q10. Is the Commission providing financial assistance for conducting DNA test to solve disputed paternity?</a></h4></div><div id="collapse-10" class="panel-collapse collapse"><div class="panel-body" data-translate="faqs.ans10">Disputed paternity is quite often found in the petitions received in the Commission. In a majority of the cases, due to financial difficulties, the petitioners find it difficult to go for a DNA Test to prove their claim. In such cases, we recommend them to go to the police for FIR and thereafter request for DNA tests, if required.</div></div></div><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" data-target="#collapse-11" data-translate="faqs.q11">Q11. Is there any provision for counseling in the Women\'s Commission?</a></h4></div><div id="collapse-11" class="panel-collapse collapse"><div class="panel-body" data-translate="faqs.ans11">The Commission is providing the services at its office and in the course of its petition redressal activities conducted at various districts.</div></div></div><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" data-target="#collapse-12" data-translate="faqs.q12">Q12.\xA0Is the Commission providing any financial assistance to women for starting business enterprises?</a></h4></div><div id="collapse-12" class="panel-collapse collapse"><div class="panel-body" data-translate="faqs.ans12">No. The Commission does not provide such services. The Haryana State Women\'s Development Corporation is expected to perform such services for the needy women.</div></div></div><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" data-target="#collapse-13" data-translate="faqs.q13">Q13.\xA0What are the functions of the Commission ?</a></h4></div><div id="collapse-13" class="panel-collapse collapse"><div class="panel-body" data-translate="faqs.ans13"><b>Functions of the Commission</b><br><br>The Commission shall perform all or any of the following functions:-<br>a) investigate and examine all matters relating to the safeguards provided for women under the constitution and other laws;<br>b) present to the Government., annually and at such other times as the Commission may deem fit, reports upon the working of those safeguards;<br>c) make in such reports recommendations for the effective implementation of those safeguards for improving the conditions of women by the State;<br>d) Review, from time to time, the existing provisions of the Constitution and other laws affecting women and recommend amendments thereto so as to suggest remedial<br>legislative measures to meet any lacunae, inadequacies or shortcomings in such legislations;<br>e) Take up the cases of violations of the provisions of the constitution and of other laws, relating to women with the appropriate authorities;<br>f) Look into complaints and take suo motu notice of matters relating to-<br>( i ) deprivation of women\u2019s rights;<br>( ii ) non-implementation of laws enacted to provide protection to women and also to achieve the objective of equality and development;<br>( iii ) non-compliance of policy decisions, guidelines or instructions aimed at mitigating hardships and ensuring welfare and providing relief to women;<br>and take up the issues arising out of such matters with appropriate authorities;<br>g) call for special studies or investigations into specific problems or situations arising out of discrimination and atrocities against women and identify the constraints so as to recommend strategies for their removal;<br>h) undertake promotional and educational research so as to suggest ways of ensuring due representation of women in all spheres and identify factors responsible for<br>impeding their advancement, such as, lack of access to housing and basic services, inadequate support services and technologies for reducing drudgery and occupational health hazards and for increasing their productivity;<br>i) participate and advise on the planning process of socio-economic development of women;<br>j) monitor and review the women related schemes/ programmes in the state and evaluate the progress of the development of women under the State;<br>k) inspect or cause to be inspected Police Stations, Jail, remand home, women\u2019s institutions or other places of custody where women are kept as prisoners<br>or otherwise, and take up with the concerned authorities for remedial action, if found necessary;<br>l) call for data from any organization on various issues/aspects of journey of women towards development, empowerment and accessibility, including growth and hurdles faced by them from individual, family or society etc.;<br>m) make periodical reports to the Government on any matter pertaining to women and in particular various difficulties under which women toil;<br>n) any other matter which may be referred to it by the Government;<br>o) shall furnish comments and recommendations on any report of the National Commission for Women on any matter with which the Government is concerned as the Government may call for.</div></div></div><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" data-target="#collapse-14" data-translate="faqs.q14">Q14.\xA0Is the Commission providing financial assistance to women in distress ?</a></h4></div><div id="collapse-14" class="panel-collapse collapse"><div class="panel-body" data-translate="faqs.ans14">No, the Commission does not provides financial assistance to women in distress. However, certain government agencies provides assistance to wome in distress such as SC/BC Dept, Social Justice and Empowerment Dept, Women and Child Development under certain schemes/funds.</div></div></div><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" data-target="#collapse-15" data-translate="faqs.q15">Q15.\xA0Is the Commission providing shelter to women?</a></h4></div><div id="collapse-15" class="panel-collapse collapse"><div class="panel-body" data-translate="faqs.ans15">No. However, the Women and Child Development Dept, Haryana is running Mahila Ashrams/Homes for Widows and Destitute Women at different districts in the State of Haryana besides a Nari Niketan - which provides temporary shelter to women in distress who are unable to return to their homes fearing cruelty and harassment.</div></div></div><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" data-target="#collapse-16" data-translate="faqs.q16">Q16. What are the Powers of the Commission?</a></h4></div><div id="collapse-16" class="panel-collapse collapse"><div class="panel-body" data-translate="faqs.ans16"><b>The Powers of the Commission are as under:</b><br><br>The Commission have all the powers of a civil court trying a suit and in particular, in respect of the following matters, namely:-<br>a) Summoning and enforcing the attendance of any person from any part of India and examining him on oath;<br>b) Requiring the discovery and production of any document;<br>c) Receiving evidence on affidavits;<br>d) Requisitioning any public record or copy thereof from any public office;<br>e) Any other matter which may be prescribed.</div></div></div><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><a class="accordion-toggle" data-toggle="collapse" data-parent="#accordion" data-target="#collapse-17" data-translate="faqs.q17">Q17. Whether the Commission takes actions and hears the cases of Honey Trap?</a></h4></div><div id="collapse-17" class="panel-collapse collapse"><div class="panel-body" data-translate="faqs.ans17">Yes, the Commission does hear and takes appropriate actions and give relevant recommendations to the concerned authorities in the Honey Trap Cases.</div></div></div></div></div></div></div></div>');
$templateCache.put('app/file-complaints/complaintInstruction.html','<form ng-submit="vm.agree()"><div class="container-fluid"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title text-center">Instructions / \u0905\u0928\u0941\u0926\u0947\u0936</h4></div><div class="modal-body well instmodal"><p class="text-justify">The HSCW has fully functional Complaints Cell wherein we receive all kinds of complaints pertaining to women from all walks of life irrespective of their social, economic, political status. We receive such complaints received orally, written and/or suo-motu under Section 10(f) of the HSCW Act, 2012. The complaints received relate to almost all legislations relating to women-viz domestic violence, harassment, dowry, torture, desertion, bigamy, rape, refusal to register FIR, cruelty by husband, deprivation, gender discrimination and sexual harassment at work place.<br><br><b>The HSCW deals with above mentioned complaints via:</b><br><br></p><li>Investigating and Monitoring such complaints and thereby seeking action taken report (ATR) from the concerned police authority in the concerned District</li><br><li>Family discord/disputes are handled through reaching compromise and/or resolve through counseling.</li><br><li>Complaints relating to harassment and Sexual harassment are usually dealt by connecting with the concerned organization/institutions/Universities wherein the Commission urges the respective organization to expedite cases and the disposal is monitored through encouraging the ICCs. In certain specific cases, the HSCW recommends certain measures to constitute External inquiry Committee/s..</li><br><li>HSCW also conducts spot inquiries, examines collects evidence witnesses and submits reports where it makes recommendations /suggestions to relevant authorities for further action to relevant authorities.</li><br>The HSCW under the Act has powers to summon the accused, the witnesses and record their statements to facilitate the process of inquiry.<br><br><b>HSCW do not entertain such cases as under:</b><br><br><li>If complaints is illegible or vague, anonymous or pseudonymous;</li><br><li>If the complaint is that of frivolous or like nature;</li><br><li>If the Complaint relates to civil dispute between the parties such as contractual rights obligations and the like;</li><br><li>If the Complaint relates to service matters not involving any deprivation of women\'s rights;</li><br><li>If the Complaint relates to labour/industrial disputes not involving any deprivation of women\'s rights;</li><br><li>If matter is sub judice before a Court/Tribunal;</li><br><li>If matter is already decided by the Commission.</li><p></p></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Back / \u092A\u0940\u091B\u0947</span></button> <button type="submit" class="btn btn-primary"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span>I agree / \u092E\u0948\u0902 \u0938\u0939\u092E\u0924 \u0939\u0942\u0901</span></button></div></div></form>');
$templateCache.put('app/file-complaints/file-complaints.html','<div class="container-fluid"><h4 class="panel panel-danger panel-heading text-center"><strong>FILE COMPLAINT / \u0936\u093F\u0915\u093E\u092F\u0924 \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902</strong></h4><p class="text-danger text-right" ng-hide="vm.success || vm.error"><b>* mark field are mandatory</b></p><div class="col-lg-12 panel panel-danger panel-body"><div class="alert alert-success" ng-show="vm.success"><strong>Complaint Registration Successfull!</strong> We will take action as soon as possible. / \u0936\u093F\u0915\u093E\u092F\u0924 \u092A\u0902\u091C\u0940\u0915\u0930\u0923 \u0938\u092B\u0932 \u0939\u092E \u091C\u093F\u0924\u0928\u0940 \u091C\u0932\u094D\u0926\u0940 \u0939\u094B \u0938\u0915\u0947 \u0915\u093E\u0930\u094D\u0930\u0935\u093E\u0908 \u0915\u0930\u0947\u0902\u0917\u0947\u0964 &nbsp; <a ui-sref="home">Go Home / \u0917\u094B \u0939\u094B\u092E</a></div><div class="alert alert-danger" ng-show="vm.error"><strong>Complaint Registration failed!</strong> Please try again later. / \u0936\u093F\u0915\u093E\u092F\u0924 \u092A\u0902\u091C\u0940\u0915\u0930\u0923 \u0935\u093F\u092B\u0932! \u092C\u093E\u0926 \u092E\u0947\u0902 \u092A\u0941\u0928: \u092A\u094D\u0930\u092F\u093E\u0938 \u0915\u0930\u0947\u0902. &nbsp; <a ui-sref="home">Go Home / \u0917\u094B \u0939\u094B\u092E</a></div><div class="row" ng-hide="vm.success || vm.error"><form ng-submit="vm.save()"><div class="col-sm-12"><div class="bg-danger"><p class="text-center"><strong>TYPE OF COMPLAINT / \u0936\u093F\u0915\u093E\u092F\u0924 \u0915\u093E \u092A\u094D\u0930\u0915\u093E\u0930<span class="text-danger"> *</span></strong></p></div><div class="row"><div class="col-md-12 form-group"><select ng-options="x for x in vm.complaint" class="form-control" ng-model="vm.complaintForm.complaintType" required><option value="">-- SELECT COMPLAINT TYPE --</option></select></div><div class="col-md-12 form-group" ng-show="vm.complaintForm.complaintType==\'Any Other\'"><label>Describe / \u0935\u0930\u094D\u0923\u0928 \u0915\u0930\u0947\u0902 <span class="text-danger">*</span></label><input type="text" placeholder="Describe Other" class="form-control" ng-model="vm.complaintForm.other" ng-required="vm.complaintForm.complaintType==\'Any Other\'"></div></div><div class="bg-danger"><h5 class="text-center"><strong>DETAILS OF COMPLAINANT / \u0936\u093F\u0915\u093E\u092F\u0924\u0915\u0930\u094D\u0924\u093E \u0915\u093E \u0935\u093F\u0935\u0930\u0923</strong></h5></div><div class="row"><div class="col-sm-4 form-group"><label>Name / \u0928\u093E\u092E <span class="text-danger">*</span></label><input type="text" placeholder="Enter Name Here.." class="form-control" ng-model="vm.complaintForm.cName" required></div><div class="col-sm-4 form-group"><label>Sex / \u0932\u093F\u0902\u0917 <span class="text-danger">*</span></label><select ng-options="x for x in vm.sex" class="form-control" ng-model="vm.complaintForm.cSex" required><option value="">-- SELECT SEX --</option></select></div><div class="col-sm-4 form-group"><label>District / \u091C\u093F\u0932\u093E <span class="text-danger">*</span></label><select ng-options="x for x in vm.district" class="form-control" ng-model="vm.complaintForm.cDistrict" required><option value="">-- SELECT DISTRICT --</option></select></div></div><div class="row"><div class="col-sm-4 form-group"><label>Address / \u092A\u0924\u093E <span class="text-danger">*</span></label><textarea placeholder="Enter Address Here.." rows="2" class="form-control" ng-model="vm.complaintForm.cAddress" required></textarea></div><div class="col-sm-4 form-group"><label>Pin / \u092A\u093F\u0928 <span class="text-danger">*</span></label><input type="number" min="100000" max="999999" title="Enter 6 digits Pin" placeholder="Enter Pin Here.." class="form-control" ng-model="vm.complaintForm.cPin" required></div><div class="col-sm-4 form-group"><label>Mobile No. / \u092E\u094B\u092C\u093E\u0907\u0932 \u0928\u0902\u092C\u0930 <span class="text-danger">*</span></label><input type="number" min="1000000000" max="9999999999" title="Enter 10 digits Mobile No." placeholder="Enter Mobile Here.." class="form-control" ng-model="vm.complaintForm.cMobile" required></div></div><div class="row"><div class="col-sm-4 form-group"><label>Landline No. / \u0932\u0948\u0902\u0921\u0932\u093E\u0907\u0928 \u0928\u0902\u092C\u0930</label><input type="number" min="1000000000" max="9999999999" title="Enter 10 digits Landline No." placeholder="Enter Landline Here.." class="form-control" ng-model="vm.complaintForm.cLandline"></div><div class="col-sm-4 form-group"><label>E-Mail / \u0908-\u092E\u0947\u0932</label><input type="email" placeholder="Enter Email Here.." class="form-control" ng-model="vm.complaintForm.cEmail"></div></div><p class="bg-danger text-center"><strong>DETAILS OF VICTIM / \u092A\u0940\u095C\u093F\u0924 \u0915\u093E \u0935\u093F\u0935\u0930\u0923</strong></p><div class="row"><div class="col-md-4 col-xs-12 form-group"><label>Please tell if complainant is victim / \u0915\u0943\u092A\u092F\u093E \u092C\u0924\u093E\u090F\u0902 \u0915\u093F \u0915\u094D\u092F\u093E \u0936\u093F\u0915\u093E\u092F\u0924\u0915\u0930\u094D\u0924\u093E \u092A\u0940\u095C\u093F\u0924\u093E \u0939\u0948<span class="text-danger"> *</span></label><div class="col-md-6 col-xs-12 form-control input-group-md"><label class="col-md-6 col-xs-6">&nbsp; Yes / \u0939\u093E\u0901 <input type="radio" name="casvictim" class="col-md-2 form-control-md" ng-model="vm.complaintForm.complainantAsVictim" value="true" ng-click="complainantByVictim()"></label><label class="col-md-6 col-xs-6">&nbsp; No / \u0928\u093E <input type="radio" name="casvictim" class="col-md-2 form-control-md" ng-model="vm.complaintForm.complainantAsVictim" ng-init="vm.complaintForm.complainantAsVictim=\'false\'" value="false"></label></div></div><div class="col-sm-4 form-group" ng-hide="vm.complaintForm.complainantAsVictim==\'true\'"><label>Name / \u0928\u093E\u092E<span class="text-danger"> *</span></label><input type="text" placeholder="Enter Name Here.." class="form-control" ng-model="vm.complaintForm.vName" ng-required="vm.complaintForm.complainantAsVictim==\'false\'"></div><div class="col-sm-4 form-group" ng-hide="vm.complaintForm.complainantAsVictim==\'true\'"><label>Sex / \u0932\u093F\u0902\u0917<span class="text-danger"> *</span></label><select ng-options="x for x in vm.sex" class="form-control" ng-model="vm.complaintForm.vSex" ng-required="vm.complaintForm.complainantAsVictim==\'false\'"><option value="">-- SELECT SEX --</option></select></div></div><div class="row" ng-hide="vm.complaintForm.complainantAsVictim==\'true\'"><div class="col-sm-4 form-group"><label>Address / \u092A\u0924\u093E<span class="text-danger"> *</span></label><textarea placeholder="Enter Address Here.." rows="2" class="form-control" ng-model="vm.complaintForm.vAddress" ng-required="vm.complaintForm.complainantAsVictim==\'false\'"></textarea></div><div class="col-sm-4 form-group"><label>Pin / \u092A\u093F\u0928</label><input type="number" min="100000" max="999999" title="Enter 6 digits Pin" placeholder="Enter Pin Here.." class="form-control" ng-model="vm.complaintForm.vPin"></div><div class="col-sm-4 form-group"><label>District / \u091C\u093F\u0932\u093E<span class="text-danger"> *</span></label><select ng-options="x for x in vm.district" class="form-control" ng-model="vm.complaintForm.vDistrict" ng-required="vm.complaintForm.complainantAsVictim==\'false\'"><option value="">-- SELECT DISTRICT --</option></select></div></div><div class="row" ng-hide="vm.complaintForm.complainantAsVictim==\'true\'"><div class="col-sm-4 form-group"><label>Mobile No. / \u092E\u094B\u092C\u093E\u0907\u0932 \u0928\u0902\u092C\u0930<span class="text-danger"> *</span></label><input type="number" min="1000000000" max="9999999999" title="Enter 10 digits Mobile" placeholder="Enter Mobile Here.." class="form-control" ng-model="vm.complaintForm.vMobile" ng-required="vm.complaintForm.complainantAsVictim==\'false\'"></div><div class="col-sm-4 form-group"><label>Landline No. / \u0932\u0948\u0902\u0921\u0932\u093E\u0907\u0928 \u0928\u0902\u092C\u0930</label><input type="number" min="1000000000" max="9999999999" title="Enter 10 digits Landline No." placeholder="Enter Landline Here.." class="form-control" ng-model="vm.complaintForm.vLandline"></div><div class="col-sm-4 form-group"><label>E-mail / \u0908-\u092E\u0947\u0932</label><input type="email" placeholder="Enter Email Here.." class="form-control" ng-model="vm.complaintForm.vEmail"></div></div><div class="row"><div class="col-sm-4 form-group"><label>Religion / \u0927\u0930\u094D\u092E</label><select ng-options="x for x in vm.religion" class="form-control" ng-model="vm.complaintForm.vReligion"><option value="">-- SELECT RELIGION --</option></select></div><div class="col-sm-4 form-group"><label>Caste / \u091C\u093E\u0924\u093F</label><select ng-options="x for x in vm.caste" class="form-control" ng-model="vm.complaintForm.vCaste"><option value="">-- SELECT CASTE --</option></select></div></div><p class="bg-danger text-center"><strong>DETAILS OF ACCUSED OR OPPOSITE PARTY / \u0926\u094B\u0937 \u092F\u093E \u0928\u093F\u0937\u0947\u0927 \u092A\u0915\u094D\u0937 \u0915\u093E \u0935\u093F\u0935\u0930\u0923</strong></p><div class="row"><div class="col-sm-4 form-group"><label>Name / \u0928\u093E\u092E<span class="text-danger"> *</span></label><input type="text" placeholder="Enter Name Here.." class="form-control" ng-model="vm.complaintForm.accusedName" required></div><div class="col-sm-4 form-group"><label>Sex / \u0932\u093F\u0902\u0917<span class="text-danger"> *</span></label><select ng-options="x for x in vm.sex" class="form-control" ng-model="vm.complaintForm.accusedSex" required><option value="">-- SELECT SEX --</option></select></div><div class="col-sm-4 form-group"><label>District / \u091C\u093F\u0932\u093E</label><select ng-options="x for x in vm.district" class="form-control" ng-model="vm.complaintForm.accusedDistrict"><option value="">-- SELECT DISTRICT --</option></select></div></div><div class="row"><div class="col-sm-4 form-group"><label>Address / \u092A\u0924\u093E<span class="text-danger"> *</span></label><textarea placeholder="Enter Address Here.." rows="2" class="form-control" ng-model="vm.complaintForm.accusedAddress" required></textarea></div><div class="col-sm-4 form-group"><label>Pin / \u092A\u093F\u0928</label><input type="number" min="100000" max="999999" title="Enter 6 digits Pin" placeholder="Enter Pin Here.." class="form-control" ng-model="vm.complaintForm.accusedPin"></div><div class="col-sm-4 form-group"><label>Mobile No. / \u092E\u094B\u092C\u093E\u0907\u0932 \u0928\u0902\u092C\u0930</label><input type="number" min="1000000000" max="9999999999" title="Enter 10 digits Mobile" placeholder="Enter Mobile Here.." class="form-control" ng-model="vm.complaintForm.accusedMobile"></div></div><div class="row"><div class="col-sm-4 form-group"><label>Landline No. / \u0932\u0948\u0902\u0921\u0932\u093E\u0907\u0928 \u0928\u0902\u092C\u0930</label><input type="number" min="1000000000" max="9999999999" title="Enter 10 digits Landline" placeholder="Enter Landline Here.." class="form-control" ng-model="vm.complaintForm.accusedLandline"></div><div class="col-sm-4 form-group"><label>E-mail / \u0908-\u092E\u0947\u0932</label><input type="email" placeholder="Enter Email Here.." class="form-control" ng-model="vm.complaintForm.accusedEmail"></div></div><div class="row"><div class="col-sm-8 form-group"><label>Complete Detail of Incident / \u0918\u091F\u0928\u093E \u0915\u093E \u092A\u0942\u0930\u093E \u0935\u093F\u0935\u0930\u0923<span class="text-danger"> *</span></label><textarea class="form-control" id="incidentDetail" name="incidentDetail" placeholder="Please enter your message here..." rows="5" ng-model="vm.complaintForm.incidentDetail" required></textarea></div></div><div class="row"><div class="col-sm-12 form-group"><div class="row"><div class="col-sm-4"><label>Any Attachment / \u0915\u094B\u0908 \u0938\u0902\u0932\u0917\u094D\u0928\u0915</label></div><div class="col-sm-4"><input class="form-control" accept="application/pdf,image/*" type="file" file-model="vm.afFile"></div><!--<div class="col-sm-2">--><!--<button type="button" ng-click="vm.afUpload()">Upload</button>--><!--</div>--></div></div></div><div class="row"><div class="col-sm-12 form-group"><div class="row"><div class="col-sm-4"><label>Police Complaint Registered? / \u0915\u094D\u092F\u093E \u0936\u093F\u0915\u093E\u092F\u0924 \u092A\u0941\u0932\u093F\u0938 \u092E\u0947\u0902 \u092A\u0902\u091C\u0940\u0915\u0943\u0924 \u0939\u0948?<span class="text-danger"> *</span></label></div><div class="col-sm-3"><label class="col-sm-6">Yes <input type="radio" name="policeComplaintStatus" class="form-control-lg" ng-model="vm.complaintForm.policeComplaintRegistrationStatus" value="true"></label><label class="col-sm-6">No <input type="radio" name="policeComplaintStatus" class="form-control-lg" ng-model="vm.complaintForm.policeComplaintRegistrationStatus" value="false" ng-init="vm.complaintForm.policeComplaintRegistrationStatus=\'false\'"></label></div><div ng-show="vm.complaintForm.policeComplaintRegistrationStatus==\'true\'" class="col-sm-3"><input class="col-sm-4 form-control" accept="application/pdf,image/*" type="file" file-model="vm.pfFile"></div><!--<div class="col-sm-2" ng-show="vm.complaintForm.policeComplaintRegistrationStatus==\'true\'">--><!--<button type="button" ng-click="vm.pfUpload()">Upload</button>--><!--</div>--></div></div></div><div class="row"><div class="col-sm-12 form-group"><div class="row"><div class="col-sm-4"><label>Case filed in Court? / \u0915\u094D\u092F\u093E \u0915\u094B\u0930\u094D\u091F \u092E\u0947\u0902 \u092E\u093E\u092E\u0932\u093E \u0926\u093E\u092F\u0930 \u0939\u0948?<span class="text-danger"> *</span></label></div><div class="col-sm-3"><label class="col-sm-6">Yes <input type="radio" name="courtCaseStatus" class="form-control-lg" ng-model="vm.complaintForm.caseFiledInCourtStatus" value="true"></label><label class="col-sm-6">No <input type="radio" name="courtCaseStatus" class="form-control-lg" ng-model="vm.complaintForm.caseFiledInCourtStatus" value="false" ng-init="vm.complaintForm.caseFiledInCourtStatus=\'false\'"></label></div><div ng-show="vm.complaintForm.caseFiledInCourtStatus==\'true\'" class="col-sm-3"><input class="col-sm-4 form-control" accept="application/pdf,image/*" type="file" file-model="vm.cfFile"></div><!--<div class="col-sm-2" ng-show="vm.complaintForm.caseFiledInCourtStatus==\'true\'">--><!--<button type="button" ng-click="vm.cfUpload()">Upload</button>--><!--</div>--></div></div></div><div class="row form-group"><label class="col-sm-4 control-label">Expected Action from Commission / \u0906\u092F\u094B\u0917 \u0938\u0947 \u0909\u092E\u094D\u092E\u0940\u0926 \u0915\u0940 \u0917\u0908 \u0915\u093E\u0930\u094D\u0930\u0935\u093E\u0908<span class="text-danger"> *</span></label><div class="col-sm-4"><select ng-options="x for x in vm.expectedActionFromCommission" ng-model="vm.complaintForm.expectedActionFromCommission" class="form-control" required><option value="">-- SELECT --</option></select></div></div><br><br><div class="row text-center"><input type="submit" value="Submit / \u091C\u092E\u093E \u0915\u0930\u0947\u0902 " class="btn btn-md btn-danger"></div></div></form></div></div></div>');
$templateCache.put('app/home/home-msg.html','<div class="container-fluid"><div class="row"><div class="col-md-12 panel panel-primary bg-danger text-justify"><h4 class="text-danger text-center" data-translate="home.msg-cp">Message From The Chairperson</h4><div class="col-md-2 col-sm-3 col-xs-6"><img ng-src="api/DefaultImgGet?name=chairperson" class="img-responsive" alt="Chairperson"></div><b>Dear Patrons,</b><br>The Haryana State Commission for Women is committed to protecting the rights, dignity, and welfare of women across the State. The Commission serves as a platform for women to raise concerns related to domestic violence, dowry harassment, sexual offences, gender discrimination, cyber crimes, and other issues affecting their safety and well-being.<br><br>As Chairperson, I am dedicated to promoting women&#39;s empowerment, ensuring access to justice, and creating greater awareness about women&#39;s rights. Our goal is to build a society where every woman feels safe, respected, and empowered to achieve her full potential.<br><br>With the support and cooperation of all stakeholders, we will continue working towards a stronger, more inclusive and progressive Haryana.<br><b>Jai Hind</b><br><br><br><div class="text-right"><b>Smt. Usha Priyadarshi</b><br>Chairperson<br>Haryana State Commission For Women<br>Panchkula</div></div><br><!--        <div class="col-md-12 panel panel-primary bg-danger text-justify">--><!--            <h4 class="text-danger text-center" data-translate="home.msg-vc">Message From The Vice Chairperson</h4>--><!--            <div class="col-md-2 col-sm-3 col-xs-6">--><!--                <img ng-src="api/DefaultImgGet?name=Preeti_VC" class="img-responsive" alt="Vice Chairperson">--><!--            </div>--><!--            <b>Dear friend of HSCW,</b><br>--><!--            I am writing to ask you to have a look at our website and to help advance and protect gender equality by supporting women and their rights, especially in the State of Haryana to tackle the multifacted problem of violence against women. HSCW\u2019s newly launched website is an effort to generate legal awareness among women of Haryana and thus equipping them, with the legal knowledge as well as with a capacity to use their legal rights.--><!--            The Commission is making all possible efforts towards assisting women in redressing their grievances through investigating and examining all matters relating to the safeguards for women, taking suo moto notice of matters on deprivation of women rights and through our jan sunwai/public hearings and thereby facilitating speedy delivery of justice to women in all 22 districts of the State.<br>--><!--            Besides, utilizing our mandate i.e. to review of the existing provisions of laws affecting women and recommending amendments thereto, HSCW have achieved a landmark step in this direction by way of accpetance of our recommendations on death penalty provisions with regard to minor female vicitms of sexual assault in Haryana. We have miles to go still and therefore, we wish to ensure, our sisters that through <b>our madate and your support </b>- we can bring about that paradigm shift in the lives of lakhs of women in Haryana to fight against entrenched gender discrimination.--><!--            In view of the advancements in the field of electronic and social media, I urge all women of Haryana to open up, come up and use your rights, so that, there is no or minimal violation. Therefore, voice your voices, voice your concerns and voice your complaints - before Haryana Mahila Ayog. Take a tour to the HSCW website, and be with and be a part with our mission.--><!--            <br><b>Jai Hind Jai Haryana</b>--><!--            <br><br>--><!--            <div class="text-right">--><!--            <b>Preeti Bhardwaj Dalal</b>--><!--            <br>--><!--                Vice Chairperson<br>--><!--                Haryana State Commission For Women <br>--><!--                Panchkula--><!--            </div>--><!--        </div>--></div></div>');
$templateCache.put('app/home/home.html','<div class="container-fluid"><div class="row"><div id="myCarousel" class="carousel slide" data-ride="carousel"><!-- Indicators --><ol class="carousel-indicators"><li data-target="#myCarousel" data-slide-to="0" class="active"></li><li data-target="#myCarousel" data-slide-to="1"></li><li data-target="#myCarousel" data-slide-to="2"></li><!--                    <li data-target="#myCarousel" data-slide-to="3"></li>--><!--                    <li data-target="#myCarousel" data-slide-to="4"></li>--><!--                    <li data-target="#myCarousel" data-slide-to="5"></li>--><!--                    <li data-target="#myCarousel" data-slide-to="6"></li>--><!--                    <li data-target="#myCarousel" data-slide-to="7"></li>--></ol><!-- Wrapper for slides --><div class="carousel-inner"><!--Removed while code of conduct--><!--<div class="item active">--><!--<img ng-src="api/DefaultImgGet?name=1" class="img-responsive crouseldim" alt="Women Commission" style="height:500px; width:100%;">--><!--</div>--><!--Removed while code of conduct--><!--<div class="item">--><!--<img ng-src="api/DefaultImgGet?name=2" class="img-responsive crouseldim" alt="Women Commission" style="height:500px; width:100%;">--><!--</div>--><!--Already removed--><!--<div class="item">--><!--<img src="content/images/3.jpg" class="img-responsive crouseldim" alt="Women Commission" style="height:400px; width:100%;">--><!--</div>--><!--Removed while code of conduct--><!--<div class="item">--><!--<img ng-src="api/DefaultImgGet?name=4" class="img-responsive crouseldim" alt="Women Commission" style="height:500px; width:100%;">--><!--</div>--><div class="item active"><img ng-src="api/DefaultImgGet?name=5" class="img-responsive crouseldim" alt="Women Commission" style="height:500px; width:100%"></div><!--                    <div class="item">--><!--                        <img ng-src="api/DefaultImgGet?name=6" class="img-responsive crouseldim" alt="Women Commission" style="height:500px; width:100%;">--><!--                    </div>--><!--Removed while code of conduct--><!--<div class="item">--><!--<img ng-src="api/DefaultImgGet?name=7" class="img-responsive crouseldim" alt="Women Commission" style="height:500px; width:100%;">--><!--</div>--><!--                    <div class="item">--><!--                        <img ng-src="api/DefaultImgGet?name=8" class="img-responsive crouseldim" alt="Women Commission" style="height:500px; width:100%;">--><!--                    </div>--><!--                    <div class="item">--><!--                        <img ng-src="api/DefaultImgGet?name=11" class="img-responsive crouseldim" alt="Women Commission" style="height:500px; width:100%;">--><!--                    </div>--><div class="item"><img ng-src="api/DefaultImgGet?name=12" class="img-responsive crouseldim" alt="Women Commission" style="height:500px; width:100%"></div><!--                    <div class="item">--><!--                        <img ng-src="api/DefaultImgGet?name=13" class="img-responsive crouseldim" alt="Women Commission" style="height:500px; width:100%;">--><!--                    </div>--><!--                    <div class="item">--><!--                        <img ng-src="api/DefaultImgGet?name=14" class="img-responsive crouseldim" alt="Women Commission" style="height:500px; width:100%;">--><!--                    </div>--><!--                    <div class="item">--><!--                        <img ng-src="api/DefaultImgGet?name=15" class="img-responsive crouseldim" alt="Women Commission" style="height:500px; width:100%;">--><!--                    </div>--><!--                    &lt;!&ndash;Removed while code of conduct&ndash;&gt;--><!--                    <div class="item">--><!--                        <img ng-src="api/DefaultImgGet?name=9" class="img-responsive crouseldim" alt="Women Commission" style="height:500px; width:100%;">--><!--                    </div>--><!--Removed while code of conduct--><div class="item"><img ng-src="api/DefaultImgGet?name=10" class="img-responsive crouseldim" alt="Women Commission" style="height:500px; width:100%"></div></div><!-- Left and right controls --> <a class="left carousel-control" href="#myCarousel" data-slide="prev"><span class="glyphicon glyphicon-chevron-left"></span> <span class="sr-only">Previous</span> </a><a class="right carousel-control" href="#myCarousel" data-slide="next"><span class="glyphicon glyphicon-chevron-right"></span> <span class="sr-only">Next</span></a></div></div><hr><div class="row well" has-authority="ROLE_ADMIN"><form name="uploadForm" ng-submit="upload()"><div class="col-md-2 text-right" ng-hide="vm.del"><h5 class="control-label"><b>Select file:</b></h5></div><div class="col-md-5" ng-hide="vm.del"><input type="file" class="input-md form-control" file-model="vm.image" ng-required="!vm.del"></div><div class="col-md-2" ng-hide="vm.del"><input type="submit" ng-disabled="uploadForm.$invalid" class="form-control btn btn-md btn-primary" value="Upload"></div><div class="col-md-3" ng-hide="vm.del"><input type="button" class="btn btn-md btn-danger" ng-click="setDeleteVal()" value="Delete Photos" ng-show="!vm.del && !nofile"></div><div class="col-md-2 text-right" ng-show="vm.del"><h5 class="control-label"><b>Enter Filename:</b></h5></div><div class="col-md-5" ng-show="vm.del"><input id="filename" name="filename" type="text" placeholder="Enter without extensions..." class="form-control" ng-model="vm.filename" ng-required="vm.del"></div><div class="col-md-2" ng-show="vm.del"><button type="button" class="btn btn-sm btn-warning" value="Cancel" title="Cancel" ng-click="setDeleteVal()"><i class="glyphicon glyphicon-remove"></i></button> <button type="button" class="btn btn-sm btn-success" ng-click="deletePhoto(vm.filename)" title="Confirm" ng-show="vm.filename!=null"><i class="fa fa-check"></i></button></div><div class="col-md-3" ng-show="vm.del"></div></form><span class="text-danger pull-left" ng-hide="vm.del">&nbsp;&nbsp;&nbsp;&nbsp;Note: File must be below size 5 MB</span></div><div class="row"><div class="col-md-12"><h3 class="text-warning"><b data-translate="home.title">Haryana State Commission For Women</b></h3></div></div><div class="row"><div class="col-md-9 text-justify">The mandate of Haryana State Commission for Women flows from the special provisions that have been made in the Constitution of India to ensure protection of status of women in Haryana. In accordance with the above, the Government established HSCW with the aim of respecting and furthering the specific provisions of fundamental rights and to give effect to certain Directive Principles of State Policy. HSCW was established in the year 1999, vide notification and became a statutory body through an enactment by the State Legislature and known as the Haryana State Commission for Women Act of 2012. Under Section 3 of HSCW Act, it is provided that the Commission shall consist of a Chairperson, a Vice Chairperson and 5 members to be nominated by the Government, wherein one member shall be from scheduled caste. The Director, WCD and DG Police of Haryana are its ex-officio Members. The Administrative Secretary, WCD shall be a special invitee. The Commission shall have a Member Secretary. At present the sanctioned strength of staff is 25.</div><div class="col-md-3"><br><ul><li><a ui-sref="about-us"><b data-translate="home.titleconstitution">Constitution of Commission</b></a></li><br><li><a ui-sref="hscwact"><b data-translate="home.titlehscwact">HSCW ACT</b></a></li><br><li><a ui-sref="hscwfunctions"><b data-translate="home.titlebriefhistory">Brief History</b></a></li><br><li><a ui-sref="hscwpowers"><b data-translate="home.titlepowers">POWERS OF HSCW</b></a></li></ul></div></div><hr><div class="row"><div class="col-md-12"><div class="row"><div class="col-md-7"><center><div class="row bg-success"><h4 class="text-danger"><strong data-translate="home.helpline">Women Helpline - 1091</strong></h4><h4 class="text-danger"><strong data-translate="home.whatsappHelpline">Whatsapp Number for Complaints - 9560080115</strong></h4></div></center><div class="row"><div class="col-md-6 well mouseChange" ui-sref="pic-gallery-folder"><center><img class="img-responsive" style="width:100%; height:209px" ng-src="api/DefaultImgGet?name=galleryCover" alt="logo"></center></div><div class="col-md-6 well mouseChange" ui-sref="news"><center><img class="img-responsive" style="width:100%; height:209px" ng-src="api/DefaultImgGet?name=newsCover" alt="logo"></center></div></div></div><div class="col-md-5"><div class="panel panel-danger"><div class="panel-heading"><h3 class="panel-title" data-translate="home.nwsupdate">News & Updates</h3></div><div class="panel-body bodysize"><marquee direction="up" onmouseover="stop();" onmouseout="start();" style="margin-bottom: 0px;height: 235px" scrollamount="9"><div class="news_wrap"><span data-translate="home.news">Welcome to Haryana State Commission For Women website</span><ul style="list-style-type:disc"><li data-translate="home.subNews">We are happy to help you</li></ul></div><br><div class="news_wrap"><span data-translate="home.news3">What\'s New</span><ul style="list-style-type:disc"><img ng-src="api/DefaultImgGet?name=smritiMam" class="img-responsive crouseldim" alt="Women Commission" style="height:150px; width:50%"><li>Welcome to Ms. Samriti Irani, Hon\'ble Cabinet Minister, Ministry of Women and Child Development Department by Haryana State Commission for Women, Panchkula.</li><li><a target="_blank" href="../content/images/50Rights.pdf">50 Legal Rights of Women in India</a></li><li><a target="_blank" href="../content/images/2019-04-02.jpeg">\u092E\u093E\u0924\u093E-\u092A\u093F\u0924\u093E \u0915\u0947 \u0918\u0930 \u092A\u0930 \u092C\u0947\u091F\u0947 \u0915\u093E \u0905\u0927\u093F\u0915\u093E\u0930 \u0928\u0939\u0940&nbsp;(Son has no right on parent\'s house.)</a></li><li><a target="_blank" href="../content/images/BUDGET201920.pdf">What\'s in for Women in Budget 2019-20</a></li><li><a target="_blank" href="../content/images/TheMaternityBenefitsAct.pdf">Sweeping Changes and FAQs on Maternity Benefit (Amendment) Act, 2017</a></li><li><a target="_blank" href="api/defaultFileGet?name=PressNoteOnMeToo">Press Note on MeToo Movement</a></li><li><a target="_blank" href="https://www.youtube.com/watch?v=xtTva0zCNQA&t=19s">Manual on Sexual Harassment of Women at Workplace Prevention, Prohibition and Redressal Act, 2013</a></li><li><a target="_blank" href="api/defaultFileGet?name=FaqOnSexualHarassment">FAQs on Sexual Harassment of Women at Workplace Prevention, Prohibition and Redressal Act, 2013</a></li><li><a target="_blank" href="../content/images/CauseList.pdf">Hearing at Commission office on 14.09.2021</a></li><li><a target="_blank" href="../content/images/15.09.2021.jpeg">Hearing at Commission office on 15.09.2021</a></li><li><a target="_blank" href="../content/images/16.09.2021.pdf">Hearing at Commission office on 16.09.2021</a></li><li><a target="_blank" href="../content/images/PoshPolicyDraftDetailedFinal.pdf">Posh Policy Draft Final</a></li><li><a target="_blank" href="../content/images/PoshPolicyDraftShortFinal.pdf">Posh Policy Draft Short</a></li><li><a target="_blank" href="../content/images/Hearing-Cases-of-District-Ambala-on-18.02.2022.pdf">Hearing- Cases of District Ambala held at Panchayat Bhawan on 18.02.2022</a></li><li><a target="_blank" href="../content/images/Hearing-Cases-of-District-Faridabad-on-21.02.2022.pdf">Hearing- Cases of District Faridabad held at Circuit Guest House, Sector 16A (Near Women Police Station) on 21.02.2022</a></li><li><a target="_blank" href="../content/images/Cases-of-District-Nuh(Mewat)-on-21.03.2022.pdf">Hearing - Cases of District Nuh (Mewat) held at Circuit Guest House on 21.03.2022</a></li><li><a target="_blank" href="../content/images/Hearing of District Palwal held at SP Office, Palwal on 26.04.2022.pdf">Hearing - Hearing of District Palwal held at SP Office, Palwal on 26.04.2022</a></li><li><a target="_blank" href="../content/images/Hearing Cases of District Gurugram.pdf">Hearing Cases of District Gurugram Fixed On 11.05.2022 at Police Commissioner Office, Gurugram at 11:30 AM</a></li><li><a target="_blank" href="../content/images/Hearing cases of District Kurkshetra.pdf">Hearing cases of District Kurkshetra Fixed on 17.05.2022 at Deputy Commissioner Office, Conference Hall, Court Complex, Sector - 10, Kurukshetra at 12.00 (Noon)</a></li><li><a target="_blank" href="../content/images/Hearing of District Rohtak held at DC Office, Rohtak on 15.06.2022.pdf">Hearing - Hearing of District Rohtak held at DC Office, Rohtak on 15.06.2022</a></li><li><a target="_blank" href="../content/images/Hearing of District Rewari to be held at Conference Hall, DC Office, Rewari on 29.06.2022.pdf">Hearing - Hearing of District Rewari to be held at Conference Hall, DC Office, Rewari on 29.06.2022</a></li><li><a target="_blank" href="../content/images/Hearing Cases of District Mahendergarh held at SP Office, Conference Hall, Mahendergarh on 20.07.2022 at 01.00 PM.pdf">Hearing Cases of District Mahendergarh held at SP Office, Conference Hall, Mahendergarh on 20.07.2022 at 01.00 PM.</a></li><li><a target="_blank" href="../content/images/Hearing Cases of District Bhiwani held at Conference Hall, DC Office, Bhiwani.pdf">Hearing Cases of District Bhiwani held at Conference Hall, DC Office, Bhiwani on 09.08.2022 at 02.00 PM</a></li><li><a target="_blank" href="../content/images/Hearing of District Kaithal to be held at Meeting Hall (1st Floor), D.C Office, Kaithal.pdf">Hearing of District Kaithal to be held at Meeting Hall (1st Floor), D.C Office, Kaithal on 09.09.2022</a></li></ul></div><br><div class="news_wrap"><span data-translate="home.news4">content</span><ul style="list-style-type:disc"><li><a target="_blank" href="api/DefaultImgGet?name=IMG_20180816_114405" data-translate="home.newsLink4" download></a></li></ul></div><br><div class="news_wrap"><span data-translate="home.news5">content2</span><ul style="list-style-type:disc"><li><a target="_blank" href="../content/images/whats_new.pdf">\u0905\u092C \u0928\u093F\u091C\u0940 \u0915\u0902\u092A\u0928\u093F\u092F\u094B\u0902 \u0915\u094B \u0935\u093E\u0930\u094D\u0937\u093F\u0915 \u0930\u093F\u092A\u094B\u0930\u094D\u091F \u092E\u0947\u0902 \u0915\u093E\u0930\u094D\u092F\u0938\u094D\u200D\u0925\u0932 \u092A\u0930 \u092E\u0939\u093F\u0932\u093E\u0913\u0902 \u0915\u0947 \u092F\u094C\u0928 \u0909\u0924\u094D\u200D\u092A\u0940\u0921\u093C\u0928 \u0930\u094B\u0915\u0925\u093E\u092E, \u0928\u093F\u0937\u0947\u0927 \u0914\u0930 \u0928\u093F\u0935\u093E\u0930\u0923 \u0938\u0902\u092C\u0902\u0927\u0940 \u0935\u094D\u092F\u094B\u0930\u093E \u0926\u0947\u0928\u093E \u0939\u094B\u0917\u093E</a></li><li><a ui-sref="news-update({value: \'news3\'})" data-translate="home.newsLink3">content2</a></li></ul></div><br><div class="news_wrap"><span data-translate="home.news1">Creation of LOGO</span><ul style="list-style-type:disc"><li><a ui-sref="news-update({value: \'news1\'})" data-translate="home.newsLink1">With regard to our previous letters no. 897-1038 dated 08.02.2018, the HSCW has decided to accord further opportunity to more students for creating a LOGO of HSCW\u2019s Website.</a></li></ul></div><br><div class="news_wrap"><span data-translate="home.news2">content2</span><ul style="list-style-type:disc"><li><a ui-sref="news-update({value: \'news2\'})" data-translate="home.newsLink2">content2</a></li></ul></div><br><div class="news_wrap"><span target="_blank" data-translate="home.ntf">content2</span><ul style="list-style-type:disc"><li><a target="_blank" href="../content/images/Notification_Chairperson.pdf">Notification for Chairperson</a></li><li><a target="_blank" href="../content/images/Notification_Vice_Chairperson.pdf">Notification for Vice Chairperson</a></li><li><a target="_blank" href="../content/images/Notification_Member.pdf">Notification for Members</a></li></ul></div><br></marquee></div></div></div></div></div><!--        <div class="col-md-12 table-responsive">--><!--            <table class="table table-Stripped table-inverse table-bordered" >--><!--                <tbody>--><!--                <tr>--><!--                    <td class="col-md-2 col-sm-2 col-xs-2 text-center"><img class="img-responsive" style="width:100%; height:150px;" ng-src="api/DefaultImgGet?name=Default" alt="logo"/><p data-translate="home.monica"><b>Monica Malik</b><br>(Member Secretary)</p></td>--><!--                    <td class="col-md-2 col-sm-2 col-xs-2 text-center"><img class="img-responsive" style="width:100%; height:150px;" ng-src="api/DefaultImgGet?name=InduYadav" alt="logo"/><p data-translate="home.indu"><b>Indu Yadav</b><br>(Member)</p></td>--><!--                    <td class="col-md-2 col-sm-2 col-xs-2 text-center"><img class="img-responsive" style="width:100%; height:150px;" ng-src="api/DefaultImgGet?name=NamartaGaur" alt="logo"/><p data-translate="home.namrata"><b>Namrata Gaur</b><br>(Member)</p></td>--><!--                    <td class="col-md-2 col-sm-2 col-xs-2 text-center"><img class="img-responsive" style="width:100%; height:150px;" ng-src="api/DefaultImgGet?name=RenuBhatia" alt="logo"/><p data-translate="home.renu"><b>Renu Bhatia</b><br>(Member)</p></td>--><!--                    <td class="col-md-2 col-sm-2 col-xs-2 text-center"><img class="img-responsive" style="width:100%; height:150px;" ng-src="api/DefaultImgGet?name=SoniaAggarwal" alt="logo"/><p data-translate="home.sonia"><b>Sonia Aggarwal</b><br>(Member)</p></td>--><!--                    <td class="col-md-2 col-sm-2 col-xs-2 text-center"><img class="img-responsive" style="width:100%; height:150px;" ng-src="api/DefaultImgGet?name=SumanBedi" alt="logo"/><p data-translate="home.suman"><b>Suman Bedi</b><br>(Member)</p></td>--><!--                </tr>--><!--                </tbody>--><!--            </table>--><!--        </div>--></div><div class="row"><div class="col-md-6 panel panel-primary bg-danger text-justify"><h4 class="text-danger text-center" data-translate="home.msg-cp">Message From The Chairperson</h4><div class="col-md-3 col-sm-3 col-xs-6"><img ng-src="api/DefaultImgGet?name=chairperson" class="img-responsive" style="height: 120px" alt="Chairperson"></div><div class="col-md-8"><b>Dear Patrons,</b><br>The Haryana State Commission for Women is committed to protecting the rights, dignity, and welfare of women across the State. The Commission serves as a platform for women to raise concerns related to domestic violence, dowry harassment, sexual offences, gender discrimination...<a ui-sref="home-msg">Read more</a><br><br><div class="text-right"><b>Smt. Usha Priyadarshi</b><br>Chairperson<br>Haryana State Commission For Women<br>Panchkula</div><br></div></div><div class="col-md-6 panel panel-primary bg-danger text-justify"><h4 class="text-danger text-center">Message From The Vice Chairperson</h4><div class="col-md-3 col-sm-3 col-xs-6"><img ng-src="api/DefaultImgGet?name=vice_chairperson" class="img-responsive" style="height: 120px" alt="Vice Chairperson"></div><div class="col-md-8"><b>Dear Patrons,</b><br>The Haryana State Commission for Women is dedicated to safeguarding the rights, dignity, and welfare of women across the State. Our mission is to ensure that every woman has access to justice, equal opportunities, and a safe environment to live and thrive... <a ui-sref="vc-msg">Read more</a><br><br><br><div class="text-right"><b>Smt. Meena Parmar</b><br>Vice Chairperson<br>Haryana State Commission For Women<br>Panchkula</div><br></div></div></div></div>');
$templateCache.put('app/home/vc-msg.html','<div class="container-fluid"><div class="row"><div class="col-md-12 panel panel-primary bg-danger text-justify"><h4 class="text-danger text-center" data-translate="home.msg-vc">Message From The Vice Chairperson</h4><div class="col-md-2 col-sm-3 col-xs-6"><img ng-src="api/DefaultImgGet?name=vice_chairperson" class="img-responsive" alt="Vice Chairperson"></div><b>Dear Patrons,</b><br>The Haryana State Commission for Women is dedicated to safeguarding the rights, dignity, and welfare of women across the State. Our mission is to ensure that every woman has access to justice, equal opportunities, and a safe environment to live and thrive.<br><br>As Vice Chairperson, I am committed to supporting initiatives that promote women&#39;s empowerment, address their grievances, and strengthen awareness about their rights. Together, we can build a society where every woman feels secure, respected, and empowered.<br><br>I invite all citizens to join us in our efforts to create a more inclusive, equitable, and progressive Haryana.<br><b>Jai Hind</b><br><br><br><div class="text-right"><b>Smt. Meena Parmar</b><br>Vice Chairperson<br>Haryana State Commission For Women<br>Panchkula</div></div><br><!--        <div class="col-md-12 panel panel-primary bg-danger text-justify">--><!--            <h4 class="text-danger text-center" data-translate="home.msg-vc">Message From The Vice Chairperson</h4>--><!--            <div class="col-md-2 col-sm-3 col-xs-6">--><!--                <img ng-src="api/DefaultImgGet?name=Preeti_VC" class="img-responsive" alt="Vice Chairperson">--><!--            </div>--><!--            <b>Dear friend of HSCW,</b><br>--><!--            I am writing to ask you to have a look at our website and to help advance and protect gender equality by supporting women and their rights, especially in the State of Haryana to tackle the multifacted problem of violence against women. HSCW\u2019s newly launched website is an effort to generate legal awareness among women of Haryana and thus equipping them, with the legal knowledge as well as with a capacity to use their legal rights.--><!--            The Commission is making all possible efforts towards assisting women in redressing their grievances through investigating and examining all matters relating to the safeguards for women, taking suo moto notice of matters on deprivation of women rights and through our jan sunwai/public hearings and thereby facilitating speedy delivery of justice to women in all 22 districts of the State.<br>--><!--            Besides, utilizing our mandate i.e. to review of the existing provisions of laws affecting women and recommending amendments thereto, HSCW have achieved a landmark step in this direction by way of accpetance of our recommendations on death penalty provisions with regard to minor female vicitms of sexual assault in Haryana. We have miles to go still and therefore, we wish to ensure, our sisters that through <b>our madate and your support </b>- we can bring about that paradigm shift in the lives of lakhs of women in Haryana to fight against entrenched gender discrimination.--><!--            In view of the advancements in the field of electronic and social media, I urge all women of Haryana to open up, come up and use your rights, so that, there is no or minimal violation. Therefore, voice your voices, voice your concerns and voice your complaints - before Haryana Mahila Ayog. Take a tour to the HSCW website, and be with and be a part with our mission.--><!--            <br><b>Jai Hind Jai Haryana</b>--><!--            <br><br>--><!--            <div class="text-right">--><!--            <b>Preeti Bhardwaj Dalal</b>--><!--            <br>--><!--                Vice Chairperson<br>--><!--                Haryana State Commission For Women <br>--><!--                Panchkula--><!--            </div>--><!--        </div>--></div></div>');
$templateCache.put('app/interview/interview-folders.html','<div class="container-fluid"><div class="row"><div class="col-md-3"></div><div class="col-md-6"><h1 class="text-capitalize text-center" data-translate="news.interview">Title</h1></div><div class="col-md-3 text-right" has-any-authority="ROLE_ADMIN,ROLE_HSCW"><button type="button" class="btn btn-lg btn-primary" value="Create Folder" data-toggle="modal" data-target="#newFolder" title="Create New Album"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-lg btn-danger" ng-click="vm.delIcon()" value="Delete Album" title="Delete Albums" ng-show="!vm.del"><i class="glyphicon glyphicon-trash"></i></button> <button type="button" class="btn btn-lg btn-warning" ng-click="vm.delIcon()" value="Delete Album" title="Cancel" ng-show="vm.del"><i class="glyphicon glyphicon-remove"></i></button></div></div><div class="row"><div class="col-md-4 col-xs-12 col-sm-12" ng-repeat="image in vm.folderList | orderBy: \'-uploadDate\' track by $index"><br><button ng-show="vm.del" id="deleteButton" type="button" class="btn btn-danger" title="Remove Album" has-any-authority="ROLE_ADMIN,ROLE_HSCW" data-toggle="modal" ng-click="setValue(image)" value="image" data-target="#deleteDialog"><b>X</b></button><div ui-sref="interview({caption:image.caption})" class="mouseChange"><img id="panel" ng-src="api/ImgGet?name={{ image.filename }}" width="315px" height="200px" alt=""><div class="interviewAlbum"><h5><b>{{image.caption}}</b></h5></div></div><br></div><div id="deleteDialog" class="modal fade" role="dialog"><form><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">X</button><h4 class="modal-title">Confirm Delete</h4></div><div class="modal-body"><p>Are you sure you want to delete this album?</p></div><div class="modal-footer"><div class="col-md-4"></div><div class="col-md-5 pull-center"><div class="col-md-6"><button type="button" data-dismiss="modal" class="btn btn-warning"><span><i class="glyphicon glyphicon-remove"></i>&nbsp;</span> Cancel</button></div><div class="col-md-6"><button type="submit" data-dismiss="modal" class="btn btn-success" ng-click="vm.confirmDelete(vm.imageVal)"><span><i class="fa fa-check"></i>&nbsp;</span> Yes &nbsp;</button></div></div></div></div></div></form></div></div></div><div id="newFolder" class="modal fade" role="dialog"><form name="createFolder"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">X</button><h4 class="modal-title">Create Album</h4></div><div class="modal-body"><div class="form-group label-floating"><p class="control-label"><b>Select Cover Photo:</b></p><input type="file" accept="image/jpeg" class="input-md form-control" file-model="vm.image" required></div><br><div class="form-group label-floating"><p class="control-label"><b>Enter Caption:</b></p><input class="form-control" minlength="3" maxlength="65" type="text" ng-model="vm.photo.caption" placeholder="Enter Caption" required></div><div class="form-group label-floating text-right"><h6>(Min character length is 3)</h6></div></div><div class="modal-footer"><center><button type="submit" data-dismiss="modal" class="btn btn-success" ng-click="vm.upload()" ng-show="vm.photo.caption!=null && vm.image!=null"><span><i class="fa fa-check"></i>&nbsp;</span> Save</button></center></div></div></div></form></div>');
$templateCache.put('app/interview/interview-view.html','<form ng-submit="vm.agree()"><div class="container-fluid bg-clr"><div class="row"><span type="button" class="closeBtn pull-right" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeView()"><h4 class="badge"><b>X</b></h4>&nbsp;&nbsp;&nbsp;&nbsp;</span></div><center><img id="panel" class="img-responsive" src="api/ImgGet?name={{ filename }}" alt=""></center><div class="row"><br><span type="button" class="closeBtn pull-left" data-dismiss="modal" aria-hidden="true">&nbsp;&nbsp;&nbsp;&nbsp;<span class="badge" ng-click="vm.closeView()"><i class="glyphicon glyphicon-backward"></i></span></span></div><p></p><!--for space--></div></form>');
$templateCache.put('app/interview/interview.html','<div class="container-fluid"><div class="row well" has-any-authority="ROLE_ADMIN,ROLE_HSCW"><form name="uploadForm" ng-submit="vm.upload()"><div class="col-md-3 col-md-offset-1"><span class="control-label"><b>Select file: </b></span>&nbsp;&nbsp;&nbsp;&nbsp;<label><input type="radio" ng-model="vm.gallery.fileType" value="Image"> Image</label>&nbsp;&nbsp;&nbsp;<label><input type="radio" ng-model="vm.gallery.fileType" value="Video"> Video</label></div><div class="col-md-5" ng-show="vm.gallery.fileType===\'Image\'"><input type="file" accept="image/jpeg" class="input-md form-control" file-model="vm.image" multiple="multiple" ng-required="vm.gallery.fileType===\'Image\'"> <span class="text-danger pull-left">&nbsp;&nbsp;&nbsp;&nbsp;Note: Image should be equal to or less than 1 MB</span></div><div class="col-md-5" ng-show="vm.gallery.fileType===\'Video\'"><input type="text" name="input" class="input-md form-control" ng-model="vm.filename" ng-required="vm.gallery.fileType===\'Video\'" minlength="11" maxlength="11" placeholder="Enter 11 characters Embed Id"> <span class="text-danger pull-left">&nbsp;&nbsp;&nbsp;&nbsp;Note: Copy Embed Id of your youtube video to upload</span></div><div class="col-md-1"><button type="submit" ng-disabled="uploadForm.$invalid" class="btn btn-sm btn-primary" value="Upload">Upload</button></div><div class="col-md-2"><button type="button" class="btn btn-sm btn-danger" ng-click="vm.delIcon()" value="Delete" title="Delete" ng-show="!vm.mov && !vm.del && !nofile" title="Delete Photos"><i class="glyphicon glyphicon-trash"></i></button> <button type="button" class="btn btn-sm btn-warning" ng-click="vm.delIcon()" value="Cancel" ng-show="vm.del && !nofile"><i class="glyphicon glyphicon-remove"></i></button> <button type="button" class="btn btn-sm btn-success" ng-click="vm.removeImg()" value="Confirm" ng-show="vm.del && selection.length!=0"><i class="fa fa-check"></i></button> <button type="button" class="btn btn-sm btn-default" value="Move" ng-click="vm.moveIcon()" title="Move" ng-show="!vm.del && !vm.mov && !nofile"><i class="fa fa-arrows"></i></button> <button type="button" class="btn btn-sm btn-warning" value="Cancel" title="Cancel" ng-click="vm.moveIcon()" ng-show="vm.mov && !nofile"><i class="glyphicon glyphicon-remove"></i></button> <button type="button" class="btn btn-sm btn-success" value="Confirm Move" title="Confirm" ng-show="vm.mov && selection.length!=0" data-toggle="modal" data-target="#moveFolder"><i class="fa fa-check"></i></button></div></form></div><div class="row"><div class="col-md-12"><div class="col-md-3 text-left"><button type="button" class="btn btn-md btn-warning" ui-sref="interview-folder" title="Back"><i class="glyphicon glyphicon-chevron-left"></i></button></div><div class="col-md-6"><h2 class="text-capitalize text-center">{{vm.caption}} <span class="text-left" ng-show="vm.mov || vm.del"><small>(Total selected: <b>{{selection.length}}</b>)</small></span></h2></div></div><hr></div><div class="row"><div class="col-md-4 col-xs-12 col-sm-12" ng-repeat="image in vm.galleryList | filter:{fileType:\'Image\'} | orderBy: \'-uploadDate\' track by $index"><br><div><input class="selectCheckbox" type="checkbox" title="Remove Image" has-any-authority="ROLE_ADMIN,ROLE_HSCW" ng-show="vm.del && image.caption==null || vm.mov && image.caption==null" ng-checked="selection.indexOf(image.id_image.filename) > -1" ng-click="toggleSelection(image)"><div ui-sref="interview-view({filename:image.filename})" class="mouseChange"><img id="panel" ng-src="api/ImgGet?name={{ image.filename }}" width="315px" height="200px" alt=""></div></div><br></div></div><hr><div class="row"><div class="col-md-4 col-xs-12 col-sm-12" ng-repeat="image in vm.galleryList | filter:{fileType:\'Video\'} | orderBy: \'-uploadDate\' track by $index"><br><div><input class="selectCheckbox" type="checkbox" title="Remove Image" has-any-authority="ROLE_ADMIN,ROLE_HSCW" ng-show="vm.del && image.caption==null || vm.mov && image.caption==null" ng-checked="selection.indexOf(image.id_image.filename) > -1" ng-click="toggleSelection(image)"><div ui-sref="interview-view({filename:image.filename})" class="mouseChange"><iframe width="315" height="200" ng-src="{{vm.getImageUrl(image)}}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div></div><br></div></div></div><div id="moveFolder" class="modal fade" role="dialog"><div class="modal-dialog"><div class="modal-content"><form name="moveForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">X</button><h4 class="modal-title">Move Photo</h4></div><div class="modal-body"><div class="form-group label-floating"><label class="control-label">Move To<span class="text-danger"> *</span></label><select name="country" class="form-control" ng-model="vm.moveTo" required><option selected="selected" disabled="disabled">---Select folder---</option><option ng-repeat="name in vm.folderList " value="{{name.caption}}">{{name.caption}}</option><option value="Other">Other</option></select></div><div ng-show="vm.moveTo==\'Other\'" class="modal-body"><div class="form-group label-floating"><p class="control-label"><b>Select Cover Photo:</b></p><input type="file" accept="image/jpeg" class="input-md form-control" file-model="vm.image" required></div><br><div class="form-group label-floating"><p class="control-label"><b>Enter Caption:</b></p><input class="form-control" minlength="3" maxlength="50" type="text" ng-model="vm.photo.caption" placeholder="Enter Caption" required></div><div class="form-group label-floating text-right"><h6>(Min character length is 3)</h6></div></div></div><div class="modal-footer"><button type="submit" ng-show="vm.moveTo!=\'Other\' && vm.moveTo!=null" ng-click="vm.confirmMove()" data-dismiss="modal" class="btn btn-success" title="jo"><span><i class="fa fa-check"></i>&nbsp;</span> Confirm Move</button> <button type="submit" ng-show="vm.moveTo==\'Other\'" ng-click="vm.uploadCover()" ng-disabled="moveForm.$invalid" data-dismiss="modal" class="btn btn-success" title="jojojoj"><span><i class="fa fa-check"></i>&nbsp;</span> Confirm Move</button></div></form></div></div></div>');
$templateCache.put('app/join-us/join-us-interns.html','<div class="container-fluid"><div class="row"><div class="col-md-1 text-left"><h3><button type="button" class="btn btn-md btn-warning" ui-sref="joinus" title="Back"><i class="glyphicon glyphicon-chevron-left"></i></button></h3></div><div class="col-md-9 text-center"><h3><b>Intern\'s Reviews</b></h3></div><div class="col-md-2 text-right" has-any-authority="ROLE_ADMIN,ROLE_HSCW"><h3><button type="button" class="btn btn-md btn-danger" ng-click="vm.delIcon()" value="Delete" ng-show="!vm.del && !nofile" title="Delete"><i class="glyphicon glyphicon-trash"></i></button> <button type="button" class="btn btn-md btn-default" ng-click="vm.delIcon()" value="Cancel" ng-show="vm.del && !nofile" title="Cancel"><i class="glyphicon glyphicon-remove"></i></button> <button type="button" class="btn btn-md btn-success" ng-click="vm.removeImg()" value="Confirm" ng-show="vm.del && selection.length!=0" title="Confirm"><i class="fa fa-check"></i></button></h3></div></div><div class="row"><div class="col-md-4 col-xs-12 col-sm-12" ng-repeat="image in vm.newsList | filter:{fileType:\'Video\'} | orderBy: \'-uploadDate\' track by $index"><br><div><input class="selectCheckbox" type="checkbox" title="Remove Image" has-any-authority="ROLE_ADMIN,ROLE_HSCW" ng-show="vm.del" ng-checked="selection.indexOf(image.id_image.filename) > -1" ng-click="toggleSelection(image)"><iframe width="315" height="200" ng-src="{{vm.getImageUrl(image)}}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div><br></div></div></div>');
$templateCache.put('app/join-us/join-us.html','<div class="container-fluid"><div class="row well" has-any-authority="ROLE_ADMIN,ROLE_HSCW"><form name="uploadForm" ng-submit="vm.saveEntity()"><div class="col-md-3 col-md-offset-1 text-right"><span class="control-label"><b>Upload Video: </b></span>&nbsp;&nbsp;&nbsp;&nbsp;</div><div class="col-md-5"><input type="text" name="input" class="input-md form-control" ng-model="vm.gallery.filename" minlength="11" maxlength="11" placeholder="Enter 11 characters Embed Id" ng-required> <span class="text-danger pull-left">&nbsp;&nbsp;&nbsp;&nbsp;Note: Copy Embed Id of your youtube video to upload</span></div><div class="col-md-1"><button type="submit" ng-disabled="uploadForm.$invalid" class="btn btn-sm btn-primary" value="Upload">Upload</button></div><div class="col-md-2"><button type="button" class="btn btn-sm btn-danger" ng-click="vm.delIcon()" value="Delete" ng-show="!vm.del && !nofile" title="Delete"><i class="glyphicon glyphicon-trash"></i></button> <button type="button" class="btn btn-sm btn-warning" ng-click="vm.delIcon()" value="Cancel" ng-show="vm.del && !nofile" title="Cancel"><i class="glyphicon glyphicon-remove"></i></button> <button type="button" class="btn btn-sm btn-success" ng-click="vm.removeImg()" value="Confirm" ng-show="vm.del && selection.length!=0" title="Confirm"><i class="fa fa-check"></i></button></div></form></div><div class="col-md-12" ng-show="vm.newsList.length==0"><center><h3 class="text-danger" data-translate="join-us.title"></h3></center><p class="text-justify" data-translate="join-us.content1">Content</p><p data-translate="join-us.points"></p><p data-translate="join-us.points2"></p><p class="text-justify" data-translate="join-us.content2"></p><div class="well text-justify"><span data-translate="join-us.email"></span> <span class="pull-right"><b>Internship Programme</b> <a href="../content/images/internship.pdf" download><span class="btn btn-sm btn-default glyphicon glyphicon-download-alt"></span></a></span></div></div><div class="col-md-12" ng-show="vm.newsList.length!=0"><div class="col-md-9"><center><h3 class="text-danger" data-translate="join-us.title"></h3></center><p class="text-justify" data-translate="join-us.content1">Content</p><p data-translate="join-us.points"></p><p data-translate="join-us.points2"></p><p class="text-justify" data-translate="join-us.content2"></p><div class="well text-justify"><span data-translate="join-us.email"></span> <span class="pull-right"><b>Internship Programme</b> <a href="../content/images/internship.pdf" download><span class="btn btn-sm btn-default glyphicon glyphicon-download-alt"></span></a></span></div></div><div class="col-md-3"><h3><u>Intern\'s Reviews</u></h3><br><div class="mouseChange"><input class="selectCheckbox" type="checkbox" title="Remove Image" has-any-authority="ROLE_ADMIN,ROLE_HSCW" ng-show="vm.del" ng-checked="selection.indexOf(toggle1) > -1" ng-click="toggleSelection(vm.newsList[0])"><iframe width="280" height="180" ng-src="{{vm.src1}}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div><br><div class="mouseChange"><input class="selectCheckbox" type="checkbox" title="Remove Image" has-any-authority="ROLE_ADMIN,ROLE_HSCW" ng-show="vm.del" ng-checked="selection.indexOf(toggle2) > -1" ng-click="toggleSelection(vm.newsList[1])"><iframe width="280" height="180" ng-src="{{vm.src2}}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div><br><div class="mouseChange"><input class="selectCheckbox" type="checkbox" title="Remove Image" has-any-authority="ROLE_ADMIN,ROLE_HSCW" ng-show="vm.del" ng-checked="selection.indexOf(toggle3) > -1" ng-click="toggleSelection(vm.newsList[2])"><iframe width="280" height="180" ng-src="{{vm.src3}}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div><br><div class="text-right" ng-show="vm.newsList.length>3"><a class="text-danger" ui-sref="joinusInterns"><b>More reviews >></b></a></div></div></div></div>');
$templateCache.put('app/laws-pertaining-to-women/laws-pertaining-to-women.html','<div ng-cloak><div class="row"><div class="col-md-1"></div><div class="col-md-10"><h2 class="text-capitalize text-center text-danger" data-translate="laws-pertaining-to-women.title">Title</h2><hr><div><a href="http://ncw.nic.in/acts/THEIMMORALTRAFFIC(PREVENTION)ACT1956.pdf" target="_blank" data-translate="laws-pertaining-to-women.act1"></a></div><br><div><a href="http://ncw.nic.in/acts/TheIndecentRepresentationofWomenProhibitionAct1986.pdf" target="_blank" data-translate="laws-pertaining-to-women.act2"></a></div><br><div><a href="http://ncw.nic.in/frmLLawsRelatedtoWomen.aspx" target="_blank" data-translate="laws-pertaining-to-women.act3"></a></div><br><div><a href="http://ncw.nic.in/PDFFiles/SexualHarassmentofWomenatWorkPlaceAct2013.pdf" target="_blank" data-translate="laws-pertaining-to-women.act4"></a></div><br><div><a href="http://ncw.nic.in/acts/The_Criminal_Law_Amendment_Act_2013.pdf" target="_blank" data-translate="laws-pertaining-to-women.act5"></a></div><br><div><p data-translate="laws-pertaining-to-women.act6"></p><ul><li><a href="http://wcdhry.gov.in/Women_Acts/Dowry_Act.pdf" target="_blank" data-translate="laws-pertaining-to-women.act6a"></a></li><li><a href="http://wcdhry.gov.in/Women_Acts/Dowry_Rules.pdf" target="_blank" data-translate="laws-pertaining-to-women.act6b"></a></li></ul></div><br><div><a href="../content/images/Women Act, 2012.docx" target="_blank" data-translate="laws-pertaining-to-women.act7"></a></div><br><div><a href="http://tcw.nic.in/Acts/ChildLabour_Prohibition_Regulation_Act,1986.pdf" target="_blank" data-translate="laws-pertaining-to-women.act8a"></a></div><br><div><a href="http://tcw.nic.in/Acts/equal_remuneration_act_1976.pdf" target="_blank" data-translate="laws-pertaining-to-women.act8b"></a></div><br><div><a href="http://tcw.nic.in/Acts/maternity_benefit_act_1961.pdf" target="_blank" data-translate="laws-pertaining-to-women.act8c"></a><ul><br><li><a href="../content/images/TheMaternityBenefitsAct.pdf" target="_blank" data-translate="laws-pertaining-to-women.act8ca"></a></li></ul></div><br><div><a href="http://tcw.nic.in/Acts/infantmilkpact1.pdf" target="_blank" data-translate="laws-pertaining-to-women.act8d"></a></div><br><div><a href="http://tcw.nic.in/Acts/ThepaymentofWages-Procedure-Rules1937.pdf" target="_blank" data-translate="laws-pertaining-to-women.act8f"></a></div><br><div><a href="http://tcw.nic.in/Acts/ncwact.pdf" target="_blank" data-translate="laws-pertaining-to-women.act8g"></a></div><br><div><a href="http://tcw.nic.in/Acts/MTP-Act-1971.pdf" target="_blank" data-translate="laws-pertaining-to-women.act8h"></a></div><br><div><a href="http://tcw.nic.in/Acts/pndt-regulation.pdf" target="_blank" data-translate="laws-pertaining-to-women.act8k"></a></div><br><div><a href="http://tcw.nic.in/Acts/IPC1860.pdf" target="_blank" data-translate="laws-pertaining-to-women.act8l"></a></div><br><div><a href="http://tcw.nic.in/The%20Protection%20of%20children%20from%20Sexual%20Offences%20Act,%2020.pdf" target="_blank" data-translate="laws-pertaining-to-women.act8n"></a></div><br><div><a href="http://tcw.nic.in/Acts/TheMarriedWomenPropertyAct1874-3of1874.pdf" target="_blank" data-translate="laws-pertaining-to-women.act8o"></a></div><br><div><a href="http://tcw.nic.in/Acts/Hindu%20adoption%20and%20Maintenance%20Act.pdf" target="_blank" data-translate="laws-pertaining-to-women.act8p"></a></div><br><div><a href="http://tcw.nic.in/Acts/TheCommissionofSatiPreventionAct1987-of1988.pdf" target="_blank" data-translate="laws-pertaining-to-women.act8q "></a></div><br><div><a data-translate="laws-pertaining-to-women.act8r"></a></div><br><div><p data-translate="laws-pertaining-to-women.act9"></p><ul><li><a href="../content/images/rti english.pdf" target="_blank" data-translate="laws-pertaining-to-women.act10"></a></li><li><a href="/content/images/rti hindi.pdf" target="_blank" data-translate="laws-pertaining-to-women.act11"></a></li></ul></div><br></div></div></div>');
$templateCache.put('app/news/news-view.html','<form ng-submit="vm.agree()"><div class="container-fluid bg-clr"><div class="row"><span type="button" class="closeBtn pull-right" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeView()"><h4 class="badge"><b>X</b></h4>&nbsp;&nbsp;&nbsp;&nbsp;</span></div><center><img id="panel" class="img-responsive" src="api/ImgGet?name={{ filename }}" alt=""></center><div class="row"><br><span type="button" class="closeBtn pull-left" data-dismiss="modal" aria-hidden="true">&nbsp;&nbsp;&nbsp;&nbsp;<span class="badge" ng-click="vm.closeView()"><i class="glyphicon glyphicon-backward"></i></span></span></div><p></p><!--for space--></div></form>');
$templateCache.put('app/news/news.html','<div class="container-fluid"><div class="row well" has-any-authority="ROLE_ADMIN,ROLE_HSCW"><form name="uploadForm" ng-submit="vm.upload()"><div class="col-md-3 col-md-offset-1"><span class="control-label"><b>Select file: </b></span>&nbsp;&nbsp;&nbsp;&nbsp;<label><input type="radio" ng-model="vm.gallery.fileType" value="Image"> Image</label>&nbsp;&nbsp;&nbsp;<label><input type="radio" ng-model="vm.gallery.fileType" value="Video"> Video</label></div><div class="col-md-5" ng-show="vm.gallery.fileType===\'Image\'"><input type="file" accept="image/jpeg" class="input-md form-control" file-model="vm.image" multiple="multiple" ng-required="vm.gallery.fileType===\'Image\'"> <span class="text-danger pull-left">&nbsp;&nbsp;&nbsp;&nbsp;Note: Image should be equal to or less than 1 MB</span></div><div class="col-md-5" ng-show="vm.gallery.fileType===\'Video\'"><input type="text" name="input" class="input-md form-control" ng-model="vm.filename" ng-required="vm.gallery.fileType===\'Video\'" minlength="11" maxlength="11" placeholder="Enter 11 characters Embed Id"> <span class="text-danger pull-left">&nbsp;&nbsp;&nbsp;&nbsp;Note: Copy Embed Id of your youtube video to upload</span></div><div class="col-md-1"><button type="submit" ng-disabled="uploadForm.$invalid" class="btn btn-sm btn-primary" value="Upload">Upload</button></div><div class="col-md-2"><button type="button" class="btn btn-sm btn-danger" ng-click="vm.delIcon()" value="Delete" ng-show="!vm.del && !nofile" title="Delete"><i class="glyphicon glyphicon-trash"></i></button> <button type="button" class="btn btn-sm btn-warning" ng-click="vm.delIcon()" value="Cancel" ng-show="vm.del && !nofile" title="Cancel"><i class="glyphicon glyphicon-remove"></i></button> <button type="button" class="btn btn-sm btn-success" ng-click="vm.removeImg()" value="Confirm" ng-show="vm.del && selection.length!=0" title="Confirm"><i class="fa fa-check"></i></button></div></form></div><div class="row"><div class="col-md-1"></div><div class="col-md-10"><h1 class="text-capitalize text-center"><span data-translate="news.title">Title</span> <span class="text-left" ng-show="vm.del"><small>(Total selected: <b>{{selection.length}}</b>)</small></span></h1></div><hr><div class="col-md-1"></div></div><div class="row"><div class="col-md-4 col-xs-12 col-sm-12" ng-repeat="image in vm.newsList | filter:{fileType:\'Image\'} | orderBy: \'-uploadDate\' track by $index"><br><div><input class="selectCheckbox" type="checkbox" title="Remove Image" has-any-authority="ROLE_ADMIN,ROLE_HSCW" ng-show="vm.del" ng-checked="selection.indexOf(image.id_image.filename) > -1" ng-click="toggleSelection(image)"><div ui-sref="news-view({filename:image.filename})" class="mouseChange"><img id="panel" ng-src="api/ImgGet?name={{ image.filename }}" width="315px" height="200px" alt=""></div></div><br></div></div><hr><div class="row"><div class="col-md-4 col-xs-12 col-sm-12" ng-repeat="image in vm.newsList | filter:{fileType:\'Video\'} | orderBy: \'-uploadDate\' track by $index"><br><div><input class="selectCheckbox" type="checkbox" title="Remove Image" has-any-authority="ROLE_ADMIN,ROLE_HSCW" ng-show="vm.del" ng-checked="selection.indexOf(image.id_image.filename) > -1" ng-click="toggleSelection(image)"><div ui-sref="news-view({filename:image.filename})" class="mouseChange"><iframe width="315" height="200" ng-src="{{vm.getImageUrl(image)}}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div></div><br></div></div></div>');
$templateCache.put('app/pics-gallery/pic-gallery-folders.html','<div class="container-fluid"><div class="row"><div class="col-md-3"></div><div class="col-md-6"><h1 class="text-capitalize text-center" data-translate="pic-gallery.title">Title</h1></div><div class="col-md-3 text-right" has-any-authority="ROLE_ADMIN,ROLE_HSCW"><button type="button" class="btn btn-lg btn-primary" value="Create Folder" data-toggle="modal" data-target="#newFolder" title="Create New Album"><i class="fa fa-plus"></i></button> <button type="button" class="btn btn-lg btn-danger" ng-click="vm.delIcon()" value="Delete Album" title="Delete Albums" ng-show="!vm.del"><i class="glyphicon glyphicon-trash"></i></button> <button type="button" class="btn btn-lg btn-warning" ng-click="vm.delIcon()" value="Delete Album" title="Cancel" ng-show="vm.del"><i class="glyphicon glyphicon-remove"></i></button></div></div><div class="row"><div class="col-md-4 col-xs-12 col-sm-12" ng-repeat="image in vm.folderList | orderBy: \'-uploadDate\' track by $index"><br><button ng-show="vm.del" id="deleteButton" type="button" class="btn btn-danger" title="Remove Album" has-any-authority="ROLE_ADMIN,ROLE_HSCW" data-toggle="modal" ng-click="setValue(image)" value="image" data-target="#deleteDialog"><b>X</b></button><div ui-sref="pic-gallery({caption:image.caption})" class="mouseChange"><img id="panel" ng-src="api/ImgGet?name={{ image.filename }}" width="315px" height="200px" alt=""><div class="album" style="height: 75px; width: 315px; font-size: 15px"><b>{{image.caption}}</b></div></div><br></div><div id="deleteDialog" class="modal fade" role="dialog"><form><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">X</button><h4 class="modal-title">Confirm Delete</h4></div><div class="modal-body"><p>Are you sure you want to delete this album?</p></div><div class="modal-footer"><div class="col-md-4"></div><div class="col-md-5 pull-center"><div class="col-md-6"><button type="button" data-dismiss="modal" class="btn btn-warning"><span><i class="glyphicon glyphicon-remove"></i>&nbsp;</span> Cancel</button></div><div class="col-md-6"><button type="submit" data-dismiss="modal" class="btn btn-success" ng-click="vm.confirmDelete(vm.imageVal)"><span><i class="fa fa-check"></i>&nbsp;</span> Yes &nbsp;</button></div></div></div></div></div></form></div></div></div><div id="newFolder" class="modal fade" role="dialog"><form name="createFolder"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">X</button><h4 class="modal-title">Create Album</h4></div><div class="modal-body"><div class="form-group label-floating"><p class="control-label"><b>Select Cover Photo:</b></p><input type="file" accept="image/jpeg" class="input-md form-control" file-model="vm.image" required></div><br><div class="form-group label-floating"><p class="control-label"><b>Enter Caption:</b></p><input class="form-control" minlength="3" type="text" ng-model="vm.photo.caption" placeholder="Enter Caption" required></div><div class="form-group label-floating text-right"><h6>(Min character length is 3)</h6></div></div><div class="modal-footer"><center><button type="submit" data-dismiss="modal" class="btn btn-success" ng-click="vm.upload()" ng-show="vm.photo.caption!=null && vm.image!=null"><span><i class="fa fa-check"></i>&nbsp;</span> Save</button></center></div></div></div></form></div>');
$templateCache.put('app/pics-gallery/pic-gallery-view.html','<form ng-submit="vm.agree()"><div class="container-fluid bg-clr"><div class="row"><span type="button" class="closeBtn pull-right" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeView()"><h4 class="badge"><b>X</b></h4>&nbsp;&nbsp;&nbsp;&nbsp;</span></div><center><img id="panel" class="img-responsive" src="api/ImgGet?name={{ filename }}" alt=""></center><div class="row"><br><span type="button" class="closeBtn pull-left" data-dismiss="modal" aria-hidden="true">&nbsp;&nbsp;&nbsp;&nbsp;<span class="badge" ng-click="vm.closeView()"><i class="glyphicon glyphicon-backward"></i></span></span></div><p></p><!--for space--></div></form>');
$templateCache.put('app/pics-gallery/pic-gallery.html','<div class="container-fluid"><div class="row well" has-any-authority="ROLE_ADMIN,ROLE_HSCW"><form name="uploadForm" ng-submit="vm.upload()"><div class="col-md-3 col-md-offset-1"><span class="control-label"><b>Select file: </b></span>&nbsp;&nbsp;&nbsp;&nbsp;<label><input type="radio" ng-model="vm.gallery.fileType" value="Image"> Image</label>&nbsp;&nbsp;&nbsp;<label><input type="radio" ng-model="vm.gallery.fileType" value="Video"> Video</label></div><div class="col-md-5" ng-show="vm.gallery.fileType===\'Image\'"><input type="file" accept="image/jpeg" class="input-md form-control" file-model="vm.image" multiple="multiple" ng-required="vm.gallery.fileType===\'Image\'"> <span class="text-danger pull-left">&nbsp;&nbsp;&nbsp;&nbsp;Note: Image should be equal to or less than 1 MB</span></div><div class="col-md-5" ng-show="vm.gallery.fileType===\'Video\'"><input type="text" name="input" class="input-md form-control" ng-model="vm.filename" ng-required="vm.gallery.fileType===\'Video\'" minlength="11" maxlength="11" placeholder="Enter 11 characters Embed Id"> <span class="text-danger pull-left">&nbsp;&nbsp;&nbsp;&nbsp;Note: Copy Embed Id of your youtube video to upload</span></div><div class="col-md-1"><button type="submit" ng-disabled="uploadForm.$invalid" class="btn btn-sm btn-primary" value="Upload">Upload</button></div><div class="col-md-2"><button type="button" class="btn btn-sm btn-danger" ng-click="vm.delIcon()" value="Delete" title="Delete" ng-show="!vm.mov && !vm.del && !nofile" title="Delete Photos"><i class="glyphicon glyphicon-trash"></i></button> <button type="button" class="btn btn-sm btn-warning" ng-click="vm.delIcon()" value="Cancel" ng-show="vm.del && !nofile"><i class="glyphicon glyphicon-remove"></i></button> <button type="button" class="btn btn-sm btn-success" ng-click="vm.removeImg()" value="Confirm" ng-show="vm.del && selection.length!=0"><i class="fa fa-check"></i></button> <button type="button" class="btn btn-sm btn-default" value="Move" ng-click="vm.moveIcon()" title="Move" ng-show="!vm.del && !vm.mov && !nofile"><i class="fa fa-arrows"></i></button> <button type="button" class="btn btn-sm btn-warning" value="Cancel" title="Cancel" ng-click="vm.moveIcon()" ng-show="vm.mov && !nofile"><i class="glyphicon glyphicon-remove"></i></button> <button type="button" class="btn btn-sm btn-success" value="Confirm Move" title="Confirm" ng-show="vm.mov && selection.length!=0" data-toggle="modal" data-target="#moveFolder"><i class="fa fa-check"></i></button></div></form></div><div class="row"><div class="col-md-12"><div class="col-md-3 text-left"><button type="button" class="btn btn-md btn-warning" ui-sref="pic-gallery-folder" title="Back"><i class="glyphicon glyphicon-chevron-left"></i></button></div><div class="col-md-6"><h2 class="text-capitalize text-center">{{vm.caption}} <span class="text-left" ng-show="vm.mov || vm.del"><small>(Total selected: <b>{{selection.length}}</b>)</small></span></h2></div></div><hr></div><div class="row"><div class="col-md-4 col-xs-12 col-sm-12" ng-repeat="image in vm.galleryList | filter:{fileType:\'Image\'} | orderBy: \'-uploadDate\' track by $index"><br><div><input class="selectCheckbox" type="checkbox" title="Remove Image" has-any-authority="ROLE_ADMIN,ROLE_HSCW" ng-show="vm.del && image.caption==null || vm.mov && image.caption==null" ng-checked="selection.indexOf(image.id_image.filename) > -1" ng-click="toggleSelection(image)"><div ui-sref="pic-gallery-view({filename:image.filename})" class="mouseChange"><img id="panel" ng-src="api/ImgGet?name={{ image.filename }}" width="315px" height="200px" alt=""></div></div><br></div></div><hr><div class="row"><div class="col-md-4 col-xs-12 col-sm-12" ng-repeat="image in vm.galleryList | filter:{fileType:\'Video\'} | orderBy: \'-uploadDate\' track by $index"><br><div><input class="selectCheckbox" type="checkbox" title="Remove Image" has-any-authority="ROLE_ADMIN,ROLE_HSCW" ng-show="vm.del && image.caption==null || vm.mov && image.caption==null" ng-checked="selection.indexOf(image.id_image.filename) > -1" ng-click="toggleSelection(image)"><div ui-sref="pic-gallery-view({filename:image.filename})" class="mouseChange"><iframe width="315" height="200" ng-src="{{vm.getImageUrl(image)}}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div></div><br></div></div></div><div id="moveFolder" class="modal fade" role="dialog"><div class="modal-dialog"><div class="modal-content"><form name="moveForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">X</button><h4 class="modal-title">Move Photo</h4></div><div class="modal-body"><div class="form-group label-floating"><label class="control-label">Move To<span class="text-danger"> *</span></label><select name="country" class="form-control" ng-model="vm.moveTo" required><option selected="selected" disabled="disabled">---Select folder---</option><option ng-repeat="name in vm.folderList " value="{{name.caption}}">{{name.caption}}</option><option value="Other">Other</option></select></div><div ng-show="vm.moveTo==\'Other\'" class="modal-body"><div class="form-group label-floating"><p class="control-label"><b>Select Cover Photo:</b></p><input type="file" accept="image/jpeg" class="input-md form-control" file-model="vm.image" required></div><br><div class="form-group label-floating"><p class="control-label"><b>Enter Caption:</b></p><input class="form-control" minlength="3" type="text" ng-model="vm.photo.caption" placeholder="Enter Caption" required></div><div class="form-group label-floating text-right"><h6>(Min character length is 3)</h6></div></div></div><div class="modal-footer"><button type="submit" ng-show="vm.moveTo!=\'Other\' && vm.moveTo!=null" ng-click="vm.confirmMove()" data-dismiss="modal" class="btn btn-success" title="jo"><span><i class="fa fa-check"></i>&nbsp;</span> Confirm Move</button> <button type="submit" ng-show="vm.moveTo==\'Other\'" ng-click="vm.uploadCover()" ng-disabled="moveForm.$invalid" data-dismiss="modal" class="btn btn-success" title="jojojoj"><span><i class="fa fa-check"></i>&nbsp;</span> Confirm Move</button></div></form></div></div></div>');
$templateCache.put('app/press-note/press-note-view.html','<form ng-submit="vm.agree()"><div class="container-fluid bg-clr"><div class="row"><span type="button" class="closeBtn pull-right" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeView()"><h4 class="badge"><b>X</b></h4>&nbsp;&nbsp;&nbsp;&nbsp;</span></div><center><img id="panel" class="img-responsive" src="api/ImgGet?name={{ filename }}" alt=""></center><div class="row"><br><span type="button" class="closeBtn pull-left" data-dismiss="modal" aria-hidden="true">&nbsp;&nbsp;&nbsp;&nbsp;<span class="badge" ng-click="vm.closeView()"><i class="glyphicon glyphicon-backward"></i></span></span></div><p></p><!--for space--></div></form>');
$templateCache.put('app/press-note/press-note.html','<div class="container-fluid"><div class="row well" has-any-authority="ROLE_ADMIN,ROLE_HSCW"><form name="uploadForm" ng-submit="vm.upload()"><div class="col-md-3"><span class="control-label"><b>Select file: </b></span>&nbsp;&nbsp;&nbsp;&nbsp;<label><input type="radio" ng-model="vm.gallery.fileType" value="Image"> Image</label>&nbsp;&nbsp;&nbsp;<label><input type="radio" ng-model="vm.gallery.fileType" value="Pdf"> Pdf</label></div><div class="col-md-2"><input type="text" class="form-control" name="caption" ng-model="vm.gallery.caption" placeholder="Caption" ng-required="vm.gallery.fileType===\'Pdf\'" maxlength="25"></div><div class="col-md-6" ng-show="vm.gallery.fileType===\'Image\'"><input type="file" accept="image/jpeg" class="input-md form-control" file-model="vm.image" multiple="multiple" ng-required="vm.gallery.fileType===\'Image\'"> <span class="text-danger pull-left">&nbsp;&nbsp;&nbsp;&nbsp;Note: Image should be equal to or less than 1 MB</span></div><div class="col-md-4" ng-show="vm.gallery.fileType===\'Pdf\'"><input type="file" accept="application/pdf" class="input-md form-control" file-model="vm.image" multiple="multiple" ng-required="vm.gallery.fileType===\'Pdf\'"> <span class="text-danger pull-left">&nbsp;&nbsp;&nbsp;&nbsp;Note: Pdf should be equal to or less than 1 MB</span></div><div class="col-md-1"><button type="submit" ng-disabled="uploadForm.$invalid" class="btn btn-sm btn-primary" value="Upload">Upload</button></div><div class="col-md-2"><button type="button" class="btn btn-sm btn-danger" ng-click="vm.delIcon()" value="Delete" ng-show="!vm.del && !nofile" title="Delete"><i class="glyphicon glyphicon-trash"></i></button> <button type="button" class="btn btn-sm btn-warning" ng-click="vm.delIcon()" value="Cancel" ng-show="vm.del && !nofile" title="Cancel"><i class="glyphicon glyphicon-remove"></i></button> <button type="button" class="btn btn-sm btn-success" ng-click="vm.removeImg()" value="Confirm" ng-show="vm.del && selection.length!=0" title="Confirm"><i class="fa fa-check"></i></button></div></form></div><div class="row"><div class="col-md-1"></div><div class="col-md-10"><h1 class="text-capitalize text-center"><span data-translate="news.pressnote">Title</span> <span class="text-left" ng-show="vm.del"><small>(Total selected: <b>{{selection.length}}</b>)</small></span></h1></div><hr><div class="col-md-1"></div></div><div class="row"><div class="col-md-4 col-xs-12 col-sm-12" ng-repeat="image in vm.newsList | filter:{fileType:\'Image\'} | orderBy: \'-uploadDate\' track by $index"><br><div><input class="selectCheckbox" type="checkbox" title="Remove Image" has-any-authority="ROLE_ADMIN,ROLE_HSCW" ng-show="vm.del" ng-checked="selection.indexOf(image.id_image.filename) > -1" ng-click="toggleSelection(image)"><div ui-sref="press-note-view({filename:image.filename})" class="mouseChange"><img id="panel" ng-src="api/ImgGet?name={{ image.filename }}" width="315px" height="200px" alt=""><div class="album"><h5><b>{{image.caption}}</b></h5></div></div></div><br></div></div><hr><div class="row"><div class="col-md-4 col-xs-12 col-sm-12" ng-repeat="image in vm.newsList | filter:{fileType:\'Pdf\'} | orderBy: \'-uploadDate\' track by $index"><br><div><input class="selectCheckbox" type="checkbox" title="Remove Image" has-any-authority="ROLE_ADMIN,ROLE_HSCW" ng-show="vm.del" ng-checked="selection.indexOf(image.id_image.filename) > -1" ng-click="toggleSelection(image)"><a target="_blank" href="api/PdfGet?name={{ image.filename }}" class="mouseChange"><img id="panels" src="content/images/pdf.jpg" width="315px" height="200px" alt=""><div class="album"><h5><b>{{image.caption}}</b></h5></div></a></div><br></div></div></div>');
$templateCache.put('app/sitemap/budget.html','<div class="container-fluid"><div class="row"><div class="col-md-1"></div><div class="col-md-10"><h3 class="text-danger text-center" ng-show="vm.news1">Creation of Logo</h3><h3 class="text-danger text-center" ng-show="vm.news2">RTI Notification</h3></div><hr><div class="col-md-1"></div></div><div class="row"><img class="img-responsive imgMargin" src="api/DefaultImgGet?name=budget1" alt="logo"></div><br><div class="row"><img class="img-responsive imgMargin" ng-src="api/DefaultImgGet?name=budget2" alt="logo"></div><br><div class="row"><img class="img-responsive imgMargin" ng-src="api/DefaultImgGet?name=budget3" alt="logo"></div><br><div class="row"><img class="img-responsive imgMargin" ng-src="api/DefaultImgGet?name=budget4" alt="logo"></div><br><div class="row"><img class="img-responsive imgMargin" ng-src="api/DefaultImgGet?name=budget5" alt="logo"></div><br><div class="row"><img class="img-responsive imgMargin" ng-src="api/DefaultImgGet?name=budget6" alt="logo"></div><br><div class="row"><img class="img-responsive imgMargin" ng-src="api/DefaultImgGet?name=budget7" alt="logo"></div><br></div>');
$templateCache.put('app/sitemap/sitemap.html','<div class="container-fluid"><div class="row"><div class="col-sm-12"><h3 class="text-danger" data-translate="sitemap.title">Sitemap:</h3><ul><li><a ui-sref="home"><strong data-translate="sitemap.home">HOME</strong></a></li><li><a ui-sref="about-us"><strong data-translate="sitemap.abouthscw">ABOUT HSCW</strong></a></li><ul><!--<li><a data-translate="sitemap.history">Brief History</a></li>--><li><a ui-sref="about-us" data-translate="sitemap.constitution">Constitution of Commission</a></li><!--<li><a data-translate="sitemap.mandate">Mandate Of Commission</a></li>--><li><a ui-sref="hscwact" data-translate="sitemap.act">HSCW ACT</a></li><li><a ui-sref="hscwfunctions" data-translate="sitemap.history">HSCW Functions</a></li><li><a ui-sref="hscwpowers" data-translate="sitemap.powers">POWERS OF HSCW</a></li></ul><li><a ui-sref="chairpersons"><strong data-translate="sitemap.commission">THE COMMISSION</strong></a></li><ul><li><a ui-sref="chairpersons" data-translate="sitemap.chairperson">List of Chairpersons</a></li><li><a ui-sref="vicechairpersons" data-translate="sitemap.vicechairperson">List of Vice Chairpersons</a></li></ul><li><a ui-sref="contacts"><strong data-translate="sitemap.contacts">CONTACT DETAILS</strong></a></li><ul><li><a ui-sref="contacts" data-translate="sitemap.cp">Commissioner of Police</a></li><li><a ui-sref="sp" data-translate="sitemap.sp">Superintendent of Police</a></li><li><a ui-sref="po" data-translate="sitemap.po">Protection Officer</a></li><li><a ui-sref="dpo" data-translate="sitemap.dpo">District Programme Officer</a></li><li><a ui-sref="dcpo" data-translate="sitemap.dcpo">District Child Program Officer</a></li><li><a ui-sref="wps" data-translate="contact-us.wps">Women Police Station</a></li></ul><!--<li><a><strong data-translate="sitemap.reach">HOW TO REACH HCSW</strong></a></li>--><!--<ul>--><!--<li><a data-translate="sitemap.complaint">Complaint Cell</a></li>--><!--<li><a data-translate="sitemap.legal">Legal Cell</a></li>--><!--<li><a data-translate="sitemap.rti">RTI Cell</a></li>--><!--<li><a data-translate="sitemap.public">Public Relations Cell</a></li>--><!--</ul>--><li><a ui-sref="news"><strong data-translate="sitemap.publications">NEWSLETTER</strong></a></li></ul></div></div></div>');
$templateCache.put('app/suggestions/suggestions.html','<div class="container"><div class="row"><div class="col-md-9 col-md-offset-1"><div class="alert alert-success" ng-show="vm.success"><strong>Thanks for your suggestion! / \u0906\u092A\u0915\u0947 \u0938\u0941\u091D\u093E\u0935 \u0915\u0947 \u0932\u093F\u090F \u0927\u0928\u094D\u092F\u0935\u093E\u0926\u0964</strong> &nbsp; <a ui-sref="home">Go Home / \u0917\u094B \u0939\u094B\u092E</a></div><div class="alert alert-danger" ng-show="vm.error"><strong>Suggestion failed!</strong> Please try again later. / \u0938\u0941\u091D\u093E\u0935 \u0935\u093F\u092B\u0932 \u0939\u0941\u0906 \u092C\u093E\u0926 \u092E\u0947\u0902 \u092A\u0941\u0928: \u092A\u094D\u0930\u092F\u093E\u0938 \u0915\u0930\u0947\u0902. &nbsp; <a ui-sref="home">Go Home / \u0917\u094B \u0939\u094B\u092E</a></div><div class="well well-sm" ng-hide="vm.success || vm.error"><form class="form-horizontal" ng-submit="vm.save()"><fieldset><legend class="text-center text-danger" data-translate="suggestions.title">title</legend><div class="form-group"><label class="col-md-4 control-label" for="name">Name / \u0928\u093E\u092E<span class="text-danger"> *</span></label><div class="col-md-8"><input id="name" name="name" type="text" placeholder="Your name" class="form-control" ng-model="vm.suggestion.name" required></div></div><div class="form-group"><label class="col-md-4 control-label" for="email">E-mail / \u0908-\u092E\u0947\u0932</label><div class="col-md-8"><input id="email" name="email" type="email" placeholder="Your email" class="form-control" ng-model="vm.suggestion.email"></div></div><div class="form-group"><label class="col-md-4 control-label" for="mobile">Mobile No. / \u092E\u094B\u092C\u093E\u0907\u0932 \u0928\u0902\u092C\u0930<span class="text-danger"> *</span></label><div class="col-md-8"><input name="mobile" id="mobile" type="number" min="1000000000" max="9999999999" title="Enter 10 digits Mobile No." placeholder="Enter Mobile Here.." class="form-control" ng-model="vm.suggestion.mobile" required></div></div><div class="form-group"><label class="col-md-4 control-label" for="mobile">Suggestion Type / \u0938\u0941\u091D\u093E\u0935 \u0935\u093F\u0937\u092F<span class="text-danger"> *</span></label><div class="col-md-8"><select ng-options="x for x in vm.suggestions" ng-model="vm.suggestion.suggestionType" class="form-control" required><option value="">-- SELECT --</option></select></div></div><div class="form-group" ng-show="vm.suggestion.suggestionType==\'Other\'"><label class="col-md-4 control-label" for="other">Describe / \u0935\u0930\u094D\u0923\u0928 \u0915\u0930\u0947\u0902</label><div class="col-md-8"><input id="other" name="other" type="text" placeholder="Describe Other" class="form-control" ng-model="vm.suggestion.other" ng-required="vm.suggestion.suggestionType==\'Other\'"></div></div><div class="form-group"><label class="col-md-4 control-label" for="message">Message / \u0938\u0902\u0926\u0947\u0936<span class="text-danger"> *</span></label><div class="col-md-8"><textarea class="form-control" id="message" name="message" placeholder="Please enter your message here..." rows="5" ng-model="vm.suggestion.message" required></textarea></div></div><div class="form-group"><div class="col-md-12 text-center"><button type="submit" class="btn btn-danger btn-md">Send / \u092D\u0947\u091C\u0947</button></div></div></fieldset></form></div></div></div></div>');
$templateCache.put('app/update-soon/news.html','<div class="container-fluid"><div class="row"><div class="col-md-1"></div><div class="col-md-10"><h3 class="text-danger text-center" ng-show="vm.news1">Creation of Logo</h3><h3 class="text-danger text-center" ng-show="vm.news2">RTI Notification</h3></div><hr><div class="col-md-1"></div></div><div ng-show="vm.news1"><div class="row"><img class="img-responsive imgMargin" src="content/images/Logo.jpg" alt="logo"></div><br><div class="row"><img class="img-responsive imgMargin" src="content/images/Logo 1.jpg" alt="logo"></div></div><div ng-show="vm.news3"><div class="col-md-10 col-md-offset-1"><h4 class="text-center text-success">International Women\'s Day Message, 2018</h4></div><br><div class="col-md-8 col-md-offset-2"><img class="img-responsive imgMargin" src="content/images/mahiladiwasmessage.jpg" alt="logo"></div></div><div ng-show="vm.news2"><div class="well"><h4>Detail of RTI OFFICERS</h4><table class="table table-bordered"><thead><tr><th>Sr.No</th><th>Name</th><th>Designation</th><th>Contact</th></tr></thead><tbody><tr><td>1</td><td>Ms. Monica Malik</td><td>First Appellate Authority</td><td>0172-2584039</td></tr><tr><td>2</td><td>Sh. Bhushan Gera</td><td>State Public Information Officer</td><td>0172-2584039, 9877082369</td></tr><tr><td>3</td><td>Sh. Rakesh Kumar</td><td>RTI Assistant</td><td>0172-2584039</td></tr><!--                <tr>--><!--                    <td>4</td>--><!--                    <td>Km. Rajwanti Verma</td>--><!--                    <td>Legal Assistant</td>--><!--                    <td>9417614301</td>--><!--                </tr>--></tbody></table></div><div class="row"><img class="img-responsive imgMargin" src="content/images/RTI.jpg" alt="logo"></div><br><div class="row"><img class="img-responsive imgMargin" src="content/images/RTI1.jpg" alt="logo"></div><br></div></div>');
$templateCache.put('app/update-soon/update-soon.html','<div ng-cloak><div class="row"><div class="col-md-1"></div><div class="col-md-10"><h2 class="text-capitalize text-center text-danger"><b>RTI Data</b></h2><hr><ul style="list-style-type:disc"><li><a target="_blank" href="../content/images/RTIData2017.pdf">RTI Complaints Data 2017-18</a></li><li><a target="_blank" href="../content/images/RTIData2018.pdf">RTI Complaints Data 2018-19</a></li><li><a target="_blank" href="../content/images/RTIData2019.pdf">RTI Complaints Data 2019-20</a></li><li><a target="_blank" href="../content/images/RTIData2020.pdf">RTI Complaints Data 2020-21</a></li><li><a target="_blank" href="../content/images/RTICasesForTheYear2021.pdf">RTI Complaints Data 2021-22 (Till August, 2021)</a></li><li>RTI Act</li><a target="_blank" href="../content/images/rti-actinhindi.pdf">- RTI Act (Hindi)</a><br><a target="_blank" href="../content/images/rti-actineng.pdf">- RTI Act (English)</a><li><a target="_blank" href="../content/images/Detail of RTI OFFICERS.docx">Details Of RTI Officers</a></li></ul></div></div></div>');
$templateCache.put('app/useful-links/useful-links.html','<div ng-cloak><div class="row"><div class="col-md-1"></div><div class="col-md-10"><h2 class="text-capitalize text-center text-danger" data-translate="useful-links.title">Title</h2><hr><div><a href="http://haryanapoliceonline.gov.in/Login.aspx" target="_blank" data-translate="useful-links.har1"></a></div><br><div><a href="http://haryanaprisons.gov.in/index.asp" target="_blank" data-translate="useful-links.har2"></a></div><br><div><a href="http://socialjusticehry.gov.in/" target="_blank" data-translate="useful-links.har3"></a></div><br><div><a href="http://www.wcdhry.gov.in/" target="_blank" data-translate="useful-links.har4"></a></div><br><div><a href="http://hhrc.gov.in/" target="_blank" data-translate="useful-links.har5"></a></div><br><div><a href="http://www.ncpcr.gov.in/index1.php?lang=1&level=2&&sublinkid=1104&lid=1321" target="_blank" data-translate="useful-links.har6"></a></div><br><div><a href="http://hslsa.gov.in/" target="_blank" data-translate="useful-links.har7"></a></div><br><div><a href="http://www.hssc.gov.in/" target="_blank" data-translate="useful-links.har8"></a></div><br><div><a href="http://hpsc.gov.in/" target="_blank" data-translate="useful-links.har9"></a></div><br><div><a href="http://hbcc.nic.in//" target="_blank" data-translate="useful-links.har10"></a></div><br><div><a href="http://b3pharyana.gov.in/" target="_blank" data-translate="useful-links.har11"></a></div><br><div><a href="http://www.wcdhry.gov.in/np.pdf" target="_blank" data-translate="useful-links.har12"></a></div><br><div><a href="http://www.wcdhry.gov.in/noti417.pdf" target="_blank" data-translate="useful-links.har13"></a></div><br><div><a href="https://wcd.nic.in/schemes/one-stop-centre-scheme-1/" target="_blank" data-translate="useful-links.har14"></a></div><br><div><a href="http://connectharyana.org/" target="_blank" data-translate="useful-links.har15"></a></div><br></div><div class="col-md-1"></div></div></div>');
$templateCache.put('app/view-complaint/view-complaint.html','<div ng-cloak><div class="container-fluid"><div class="row"><div ng-hide="vm.arr.length==0"><div class="row"><div class="col-md-6 col-xs-12"><h4 class="text-center pull-left text-success"><span class="glyphicon glyphicon-list-alt"></span> <b>Complaints Received</b></h4></div><div class="col-md-2 col-xs-12"><h5 class="text-right hidden-xs">Search File:</h5><h5 class="visible-xs">Search File:</h5></div><div class="col-md-4 col-xs-12"><div class="input-group"><input type="text" class="form-control" placeholder="Search" ng-model="name"><div class="input-group-btn"><button class="btn btn-default" type="submit"><i class="glyphicon glyphicon-search"></i></button></div></div></div></div><p class="text-right textzero-margin">Total no. of documents: <b>{{results.length}}</b></p></div><br><div class="panel panel-success"><div class="table-space table-responsive overflowOthers"><table class="table table-hover" ng-hide="vm.complaintForms.length==0 || results.length==0"><thead><tr><th><h5 class="text-primary"><b>#</b></h5></th><th><h5 class="text-primary"><b>From</b></h5></th><th><h5 class="text-primary"><b>Description</b></h5></th><th><h5 class="text-primary"><b>District</b></h5></th><th><h5 class="pull-right text-primary"><b>Complaint Date</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h5></th></tr></thead><tbody ng-repeat="arr in vm.complaintForms | filter:filterData | filter : name | orderBy: \'-complaintDate\' as results"><tr class="mouseChange"><td class="tdOutline" ui-sref="view-complaint-detail({id:arr.id})"><b>{{$index+1}}</b></td><td class="tdOutline" ui-sref="view-complaint-detail({id:arr.id})"><b>{{arr.cName}}</b></td><td class="tdOutline" ui-sref="view-complaint-detail({id:arr.id})">{{arr.complaintType}}</td><td class="tdOutline" ui-sref="view-complaint-detail({id:arr.id})">{{arr.cDistrict}}</td><td class="tdOutline" ui-sref="view-complaint-detail({id:arr.id})"><small class="pull-right"><b>{{arr.complaintDate | date : \'dd-MMM-yyyy\'}},&nbsp;{{arr.sharedDate | date : \'hh:mm:ss a\'}}&nbsp;&nbsp;&nbsp;</b></small></td></tr></tbody></table><div ng-show="vm.complaintForms.length==0 || results.length==0"><br><h4><center><b>No Files!</b></center></h4></div></div></div></div></div></div>');
$templateCache.put('app/view-complaint/viewComplaintDetail.html','<div class="pull-right"><a class="bg-success" title="Print" ng-print ng-click="vm.printToCart(\'printSectionId\')">Print and Download <span class="glyphicon glyphicon-print"></span> </a><!--&nbsp;&nbsp;&nbsp;<button class="btn btn-sm" ng-click="vm.complaintFormPdf()">Download</button>--></div><div ng-show="false" id="printSectionId"><div class="col-md-12"><h2 style="color:#800000;  text-align:center"><b>Complaint Form</b></h2><hr><table><tr><td style="width:400px; text-align:center"><b>Complaint Id</b></td><td style="width:400px; text-align:center"><b>Complaint Type</b></td><td style="width:400px; text-align:center"><b>Complaint Date</b></td></tr><tr><td style="width:400px; text-align:center">{{vm.complaintForm.id}}</td><td style="width:400px; text-align:center">{{vm.complaintForm.complaintType}}</td><td style="width:400px; text-align:center">{{vm.complaintForm.complaintDate | date:\'medium\'}}</td></tr></table><hr><h4><b>Incident Detail /</b> \u0918\u091F\u0928\u093E \u0915\u093E \u092A\u0942\u0930\u093E \u0935\u093F\u0935\u0930\u0923</h4><p style="border: 1px solid gray; text-align: justify">{{vm.complaintForm.incidentDetail}}</p><br><h4 style="text-align:center">DETAILS OF COMPLAINANT / \u0936\u093F\u0915\u093E\u092F\u0924\u0915\u0930\u094D\u0924\u093E \u0915\u093E \u0935\u093F\u0935\u0930\u0923</h4><table><tr><td style="text-align:right; width:20%"><b>Name /</b> \u0928\u093E\u092E&nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.cName}}</td><td style="text-align:right; width:20%"><b>Address /</b> \u092A\u0924\u093E&nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.cAddress}}</td></tr><tr><td style="text-align:right; width:20%"><b>District /</b> \u091C\u093F\u0932\u093E&nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.cDistrict}}</td><td style="text-align:right; width:20%"><b>Pin /</b> \u092A\u093F\u0928&nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.cPin}}</td></tr><tr><td style="text-align:right; width:20%"><b>E-mail /</b> \u0908-\u092E\u0947\u0932&nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.cEmail}}</td><td style="text-align:right; width:20%"><b>Mobile /</b> \u092E\u094B\u092C\u093E\u0907\u0932 &nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.cMobile}}</td></tr><tr><td style="text-align:right; width:20%"><b>Landline /</b> \u0932\u0948\u0902\u0921\u0932\u093E\u0907\u0928&nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.cLandline}}</td><td style="text-align:right; width:20%"><b>Sex /</b> \u0932\u093F\u0902\u0917&nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.cSex}}</td></tr></table><br><h4 style="text-align:center">DETAILS OF VICTIM / \u0935\u093F\u092A\u0924\u094D\u0924\u093F-\u0917\u094D\u0930\u0938\u094D\u0924 \u0915\u093E \u0935\u093F\u0935\u0930\u0923</h4><table><b>&nbsp;&nbsp;&nbsp;&nbsp;Complainant is victim? /</b> \u0915\u0943\u092A\u092F\u093E \u092C\u0924\u093E\u090F\u0902 \u0915\u093F \u0915\u094D\u092F\u093E \u0936\u093F\u0915\u093E\u092F\u0924\u0915\u0930\u094D\u0924\u093E \u092A\u0940\u095C\u093F\u0924\u093E \u0939\u0948? : <span style="color: red"><b>{{vm.asVictim}}</b></span><tr><td style="text-align:right; width:20%"><b>Name /</b> \u0928\u093E\u092E&nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.vName}}</td><td style="text-align:right; width:20%"><b>Address /</b> \u092A\u0924\u093E&nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.vAddress}}</td></tr><tr><td style="text-align:right; width:20%"><b>District /</b> \u091C\u093F\u0932\u093E&nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.vDistrict}}</td><td style="text-align:right; width:20%"><b>Pin /</b> \u092A\u093F\u0928&nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.cPin}}</td></tr><tr><td style="text-align:right; width:20%"><b>E-mail /</b> \u0908-\u092E\u0947\u0932&nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.vEmail}}</td><td style="text-align:right; width:20%"><b>Mobile /</b> \u092E\u094B\u092C\u093E\u0907\u0932 &nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.vMobile}}</td></tr><tr><td style="text-align:right; width:20%"><b>Landline /</b> \u0932\u0948\u0902\u0921\u0932\u093E\u0907\u0928&nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.vLandline}}</td><td style="text-align:right; width:20%"><b>Sex /</b> \u0932\u093F\u0902\u0917&nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.vSex}}</td></tr><tr><td style="text-align:right; width:20%"><b>Religion /</b> \u0927\u0930\u094D\u092E&nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.vReligion}}</td><td style="text-align:right; width:20%"><b>Caste /</b> \u091C\u093E\u0924\u093F&nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.vCaste}}</td></tr></table><br><h4 style="text-align:center">DETAILS OF ACCUSED / \u0926\u094B\u0937 \u092F\u093E \u0928\u093F\u0937\u0947\u0927 \u092A\u0915\u094D\u0937 \u0915\u093E \u0935\u093F\u0935\u0930\u0923</h4><table><tr><td style="text-align:right; width:20%"><b>Name /</b> \u0928\u093E\u092E&nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.accusedName}}</td><td style="text-align:right; width:20%"><b>Address /</b> \u092A\u0924\u093E&nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.accusedAddress}}</td></tr><tr><td style="text-align:right; width:20%"><b>District /</b> \u091C\u093F\u0932\u093E&nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.accusedDistrict}}</td><td style="text-align:right; width:20%"><b>Pin /</b> \u092A\u093F\u0928&nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.accusedPin}}</td></tr><tr><td style="text-align:right; width:20%"><b>E-mail /</b> \u0908-\u092E\u0947\u0932&nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.accusedEmail}}</td><td style="text-align:right; width:20%"><b>Mobile /</b> \u092E\u094B\u092C\u093E\u0907\u0932 &nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.accusedMobile}}</td></tr><tr><td style="text-align:right; width:20%"><b>Landline /</b> \u0932\u0948\u0902\u0921\u0932\u093E\u0907\u0928&nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.accusedLandline}}</td><td style="text-align:right; width:20%"><b>Sex /</b> \u0932\u093F\u0902\u0917&nbsp;&nbsp;&nbsp;</td><td style="text-align:left; width:30%">{{vm.complaintForm.accusedSex}}</td></tr></table><br><!--<table>--><!--<tr>--><!--<td style="width:400px; text-align:center;"><b>Other Attachments /</b> \u0905\u0928\u094D\u092F \u0938\u0902\u0932\u0917\u094D\u0928\u0915</td>--><!--<td style="width:400px; text-align:center;"><b>Case filed in Court /</b> \u0928\u094D\u092F\u093E\u092F\u093E\u0932\u092F \u092E\u0947\u0902 \u0926\u093E\u092F\u0930 \u092E\u093E\u092E\u0932\u093E</td>--><!--<td style="width:400px; text-align:center;"><b>Police Complaint /</b> \u092A\u0941\u0932\u093F\u0938 \u0936\u093F\u0915\u093E\u092F\u0924</td>--><!--</tr><hr>--><!--<tr class="cursor">--><!--<td ng-show="vm.afilename!=null"><center><a type="button" href="api/FileGet?name={{vm.afilename}}" class="btn btn-primary">Download</a></center></td>--><!--<td ng-show="vm.ccfilename!=null"><center><a type="button" href="api/FileGet?name={{vm.ccfilename}}" class="btn btn-primary">Download</a></center></td>--><!--<td ng-show="vm.pcfilename!=null"><center><a type="button" href="api/FileGet?name={{vm.pcfilename}}" class="btn btn-primary">Download</a></center></td>--><!--</tr>--><!--</table>--><h4 style="text-align:center"><b style="color: red">Expected Action From Commission /</b> \u0906\u092F\u094B\u0917 \u0938\u0947 \u0909\u092E\u094D\u092E\u0940\u0926 \u0915\u0940 \u0917\u0908 \u0915\u093E\u0930\u094D\u0930\u0935\u093E\u0908 : <b>{{vm.complaintForm.expectedActionFromCommission}}</b></h4></div></div><div class="container-fluid"><center><h2><span>Complaint Form</span></h2></center><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal"><div class="row"><tr><div class="col-sm-4"><center><b><td><span>Complaint id</span></td><br></b></center><center><td><span>{{vm.complaintForm.id}}</span></td></center></div><div class="col-sm-4"><center><b><td><span>Complaint Type</span></td><br></b></center><center><td><span>{{vm.complaintForm.complaintType}}</span></td></center></div><div class="col-sm-4"><center><b><td><span>Complaint Date</span></td><br></b></center><center><td><span>{{vm.complaintForm.complaintDate | date:\'medium\'}}</span></td></center></div></tr></div><br><div class="col-sm-12"><h3>Incident Detail / \u0918\u091F\u0928\u093E \u0915\u093E \u092A\u0942\u0930\u093E \u0935\u093F\u0935\u0930\u0923</h3><p class="text-justify" style="border: 1px solid black">{{vm.complaintForm.incidentDetail}}</p></div><div class="row"><div class="col-sm-12"><br><center><h4>DETAILS OF COMPLAINANT / \u0936\u093F\u0915\u093E\u092F\u0924\u0915\u0930\u094D\u0924\u093E \u0915\u093E \u0935\u093F\u0935\u0930\u0923</h4></center><div class="well"><div class="row"><div class="col-sm-6"><dt><span>Name / \u0928\u093E\u092E</span></dt><dd><span>{{vm.complaintForm.cName}}</span></dd></div><div class="col-sm-6"><dt><span>Address / \u092A\u0924\u093E</span></dt><dd><span>{{vm.complaintForm.cAddress}}</span></dd></div><br><br></div><div class="row"><div class="col-sm-6"><dt><span>District / \u091C\u093F\u0932\u093E</span></dt><dd><span>{{vm.complaintForm.cDistrict}}</span></dd></div><div class="col-sm-6"><dt><span>Pin / \u092A\u093F\u0928</span></dt><dd><span>{{vm.complaintForm.cPin}}</span></dd></div><br><br></div><div class="row"><div class="col-sm-6"><dt><span>E-mail / \u0908-\u092E\u0947\u0932</span></dt><dd><span>{{vm.complaintForm.cEmail}}</span></dd></div><div class="col-sm-6"><dt><span>Mobile / \u092E\u094B\u092C\u093E\u0907\u0932</span></dt><dd><span>{{vm.complaintForm.cMobile}}</span></dd></div><br><br></div><div class="row"><div class="col-sm-6"><dt><span>Landline / \u0932\u0948\u0902\u0921\u0932\u093E\u0907\u0928</span></dt><dd><span>{{vm.complaintForm.cLandline}}</span></dd></div><div class="col-sm-6"><dt><span>Sex / \u0932\u093F\u0902\u0917</span></dt><dd><span>{{vm.complaintForm.cSex}}</span></dd></div><br><br></div></div></div><div class="col-sm-12"><h4 class="text-center">DETAILS OF VICTIM / \u092A\u0940\u095C\u093F\u0924 \u0915\u093E \u0935\u093F\u0935\u0930\u0923</h4><div class="well"><div class="col-sm-12"><span><b>Complainant is victim? / \u0915\u0943\u092A\u092F\u093E \u092C\u0924\u093E\u090F\u0902 \u0915\u093F \u0915\u094D\u092F\u093E \u0936\u093F\u0915\u093E\u092F\u0924\u0915\u0930\u094D\u0924\u093E \u092A\u0940\u095C\u093F\u0924\u093E \u0939\u0948?</b> </span><span class="text-danger"><b>{{vm.asVictim}}</b></span><hr></div><div class="row" ng-show="vm.complaintForm.complainantAsVictim==false"><div class="col-sm-6"><dt><span>Name / \u0928\u093E\u092E</span></dt><dd><span>{{vm.complaintForm.vName}}</span></dd></div><div class="col-sm-6"><dt><span>Address / \u092A\u0924\u093E</span></dt><dd><span>{{vm.complaintForm.vAddress}}</span></dd></div></div><br><div class="row" ng-show="vm.complaintForm.complainantAsVictim==false"><div class="col-sm-6"><dt><span>District / \u091C\u093F\u0932\u093E</span></dt><dd><span>{{vm.complaintForm.vDistrict}}</span></dd></div><div class="col-sm-6"><dt><span>Pin / \u092A\u093F\u0928</span></dt><dd><span>{{vm.complaintForm.vPin}}</span></dd></div></div><br><div class="row" ng-show="vm.complaintForm.complainantAsVictim==false"><div class="col-sm-6"><dt><span>E-mail / \u0908-\u092E\u0947\u0932</span></dt><dd><span>{{vm.complaintForm.vEmail}}</span></dd></div><div class="col-sm-6"><dt><span>Landline / \u0932\u0948\u0902\u0921\u0932\u093E\u0907\u0928</span></dt><dd><span>{{vm.complaintForm.vLandline}}</span></dd></div></div><br><div class="row" ng-show="vm.complaintForm.complainantAsVictim==false"><div class="col-sm-6"><dt><span>Mobile / \u092E\u094B\u092C\u093E\u0907\u0932</span></dt><dd><span>{{vm.complaintForm.vMobile}}</span></dd></div><div class="col-sm-6"><dt><span>Sex / \u0932\u093F\u0902\u0917</span></dt><dd><span>{{vm.complaintForm.vSex}}</span></dd></div></div><br><div class="row"><div class="col-sm-6"><dt><span>Religion / \u0927\u0930\u094D\u092E</span></dt><dd><span>{{vm.complaintForm.vReligion}}</span></dd></div><div class="col-sm-6"><dt><span>Caste / \u091C\u093E\u0924\u093F</span></dt><dd><span>{{vm.complaintForm.vCaste}}</span></dd></div></div><br></div></div><div class="col-sm-12"><h4 class="text-center">DETAILS OF ACCUSED / \u0926\u094B\u0937 \u092F\u093E \u0928\u093F\u0937\u0947\u0927 \u092A\u0915\u094D\u0937 \u0915\u093E \u0935\u093F\u0935\u0930\u0923</h4><div class="well"><div class="row"><div class="col-sm-6"><dt><span>Name / \u0928\u093E\u092E</span></dt><dd><span>{{vm.complaintForm.accusedName}}</span></dd></div><div class="col-sm-6"><dt><span>Address / \u092A\u0924\u093E</span></dt><dd><span>{{vm.complaintForm.accusedAddress}}</span></dd></div></div><br><div class="row"><div class="col-sm-6"><dt><span>District / \u091C\u093F\u0932\u093E</span></dt><dd><span>{{vm.complaintForm.accusedDistrict}}</span></dd></div><div class="col-sm-6"><dt><span>Pin / \u092A\u093F\u0928</span></dt><dd><span>{{vm.complaintForm.accusedPin}}</span></dd></div></div><br><div class="row"><div class="col-sm-6"><dt><span>E-mail / \u0908-\u092E\u0947\u0932</span></dt><dd><span>{{vm.complaintForm.accusedEmail}}</span></dd></div><div class="col-sm-6"><dt><span>Mobile / \u092E\u094B\u092C\u093E\u0907\u0932</span></dt><dd><span>{{vm.complaintForm.accusedMobile}}</span></dd></div></div><br><div class="row"><div class="col-sm-6"><dt><span>Landline / \u0932\u0948\u0902\u0921\u0932\u093E\u0907\u0928</span></dt><dd><span>{{vm.complaintForm.accusedLandline}}</span></dd></div><div class="col-sm-6"><dt><span>Sex / \u0932\u093F\u0902\u0917</span></dt><dd><span>{{vm.complaintForm.accusedSex}}</span></dd></div></div><br></div></div><div class="row" ng-show="vm.afilename!=null || vm.ccfilename!=null || vm.pcfilename!=null"><table class="table table-hover" ng-hide="vm.complaintForms.length==0 || results.length==0"><thead><tr><th ng-show="vm.afilename!=null"><center><b>Other Attachments / \u0905\u0928\u094D\u092F \u0938\u0902\u0932\u0917\u094D\u0928\u0915</b></center></th><th ng-show="vm.ccfilename!=null"><center><b>Case filed in Court / \u0928\u094D\u092F\u093E\u092F\u093E\u0932\u092F \u092E\u0947\u0902 \u0926\u093E\u092F\u0930 \u092E\u093E\u092E\u0932\u093E</b></center></th><th ng-show="vm.pcfilename!=null"><center><b>Police Complaint / \u092A\u0941\u0932\u093F\u0938 \u0936\u093F\u0915\u093E\u092F\u0924</b></center></th></tr></thead><tbody><tr class="cursor"><td ng-show="vm.afilename!=null"><center><a type="button" href="api/FileGet?name={{vm.afilename}}" target="_blank" class="btn btn-primary">Download</a></center></td><td ng-show="vm.ccfilename!=null"><center><a type="button" href="api/FileGet?name={{vm.ccfilename}}" target="_blank" class="btn btn-primary">Download</a></center></td><td ng-show="vm.pcfilename!=null"><center><a type="button" href="api/FileGet?name={{vm.pcfilename}}" target="_blank" class="btn btn-primary">Download</a></center></td></tr></tbody></table></div><div class="col-sm-12 well"><h5 class="text-center"><b class="text-danger">Expected Action From Commission / \u0906\u092F\u094B\u0917 \u0938\u0947 \u0909\u092E\u094D\u092E\u0940\u0926 \u0915\u0940 \u0917\u0908 \u0915\u093E\u0930\u094D\u0930\u0935\u093E\u0908 :</b> <span><b>{{vm.complaintForm.expectedActionFromCommission}}</b></span></h5></div></div></dl></div>');
$templateCache.put('app/view-suggestion/view-suggestion.html','<div ng-cloak><div class="container-fluid"><div class="row"><div ng-hide="vm.arr.length==0"><div class="row"><div class="col-md-6 col-xs-12"><h4 class="text-center pull-left text-success"><span class="glyphicon glyphicon-list-alt"></span> <b>Suggestions Received</b></h4></div><div class="col-md-2 col-xs-12"><h5 class="text-right hidden-xs">Search File:</h5><h5 class="visible-xs">Search File:</h5></div><div class="col-md-4 col-xs-12"><div class="input-group"><input type="text" class="form-control" placeholder="Search" ng-model="name"><div class="input-group-btn"><button class="btn btn-default" type="submit"><i class="glyphicon glyphicon-search"></i></button></div></div></div></div><p class="text-right textzero-margin">Total no. of documents: <b>{{results.length}}</b></p></div><br><div class="panel panel-success"><div class="table-space table-responsive overflowOthers"><table class="table table-hover" ng-hide="vm.complaintForms.length==0 || results.length==0"><thead><tr><th><h5 class="text-primary"><b>#</b></h5></th><th><h5 class="text-primary"><b>Name</b></h5></th><th><h5 class="text-primary"><b>Suggestion Type</b></h5></th><th><h5 class="text-primary"><b>Description</b></h5></th><th><h5 class="pull-right text-primary"><b>Suggestion Date</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h5></th></tr></thead><tbody ng-repeat="arr in vm.suggestions | filter:filterData | filter : name | orderBy: \'-suggestionDate\' as results"><tr class="mouseChange"><td class="tdOutline" ui-sref="view-suggestion-detail({id:arr.id})"><b>{{$index+1}}</b></td><td class="tdOutline" ui-sref="view-suggestion-detail({id:arr.id})"><b>{{arr.name}}</b></td><td class="tdOutline" ui-sref="view-suggestion-detail({id:arr.id})">{{arr.suggestionType}}</td><td class="tdOutline" ui-sref="view-suggestion-detail({id:arr.id})">{{arr.message}}</td><td class="tdOutline" ng-click="view-suggestion-detail({id:arr.id})"><small class="pull-right"><b>{{arr.suggestionDate | date : \'dd-MMM-yyyy\'}},&nbsp;{{arr.suggestionDate | date : \'hh:mm:ss a\'}}&nbsp;&nbsp;&nbsp;</b></small></td></tr></tbody></table><div ng-show="vm.suggestions.length==0 || results.length==0"><br><h4><center><b>No Files!</b></center></h4></div></div></div></div></div></div>');
$templateCache.put('app/view-suggestion/viewSuggestionDetail.html','<div class="pull-right"><a class="bg-success" title="Print" ng-print ng-click="vm.printToCart(\'printSectionId\')">Print and Download <span class="glyphicon glyphicon-print"></span></a></div><div ng-show="false" id="printSectionId"><div class="col-md-12"><h2 style="text-align:center"><b>Suggestion Form</b></h2><hr><table><tr><td style="width:400px; text-align:center"><b>Suggestion Id</b></td><td style="width:400px; text-align:center"><b>Suggestion Type</b></td><td style="width:400px; text-align:center"><b>Suggestion Date</b></td></tr><tr><td style="width:400px; text-align:center">{{vm.suggestion.id}}</td><td style="width:400px; text-align:center">{{vm.suggestion.suggestionType}}</td><td style="width:400px; text-align:center">{{vm.suggestion.suggestionDate | date:\'medium\'}}</td></tr></table><hr><h3 style="text-align:center">PERSON\'S DETAIL / \u0935\u094D\u092F\u0915\u094D\u0924\u093F \u0915\u093E \u0935\u093F\u0938\u094D\u0924\u093E\u0930</h3><table><tr><td style="text-align:right; width:10%"><b>Name /</b> \u0928\u093E\u092E&nbsp;:&nbsp;</td><td style="text-align:left; width:10%">{{vm.suggestion.name}}</td><td style="text-align:right; width:13%"><b>E-mail /</b> \u0908-\u092E\u0947\u0932&nbsp;:&nbsp;</td><td style="text-align:left; width:10%">{{vm.suggestion.email}}</td><td style="text-align:right; width:13%"><b>Mobile /</b> \u092E\u094B\u092C\u093E\u0907\u0932&nbsp;:&nbsp;</td><td style="text-align:left; width:15%">{{vm.suggestion.mobile}}</td></tr><tr></tr></table><br><h4><b>SUGGESTION DETAIL / \u0938\u0941\u091D\u093E\u0935 \u0915\u093E \u0935\u093F\u0938\u094D\u0924\u093E\u0930</b></h4><p style="border: 1px solid gray; text-align: justify">{{vm.suggestion.message}}</p><br></div></div><div class="container-fluid"><center><h2><span>Suggestion Form</span></h2></center><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal"><div class="row"><tr><div class="col-sm-4"><center><b><td><span>Suggestion id</span></td><br></b></center><center><td><span>{{vm.suggestion.id}}</span></td></center></div><div class="col-sm-4"><center><b><td><span>Suggestion Type</span></td><br></b></center><center><td><span>{{vm.suggestion.suggestionType}}</span></td></center></div><div class="col-sm-4"><center><b><td><span>Suggestion Date</span></td><br></b></center><center><td><span>{{vm.suggestion.suggestionDate | date:\'medium\'}}</span></td></center></div></tr></div><br><div class="row"><div class="col-sm-12"><br><center><h4>PERSON\'S DETAIL / \u0935\u094D\u092F\u0915\u094D\u0924\u093F \u0915\u093E \u0935\u093F\u0938\u094D\u0924\u093E\u0930</h4></center><div class="well"><div class="row"><div class="col-sm-6"><dt><span>Name / \u0928\u093E\u092E</span></dt><dd><span>{{vm.suggestion.name}}</span></dd></div><div class="col-sm-6"><dt><span>E-mail / \u0908-\u092E\u0947\u0932</span></dt><dd><span>{{vm.suggestion.email}}</span></dd></div><br><br></div><div class="row"><div class="col-sm-6"><dt><span>Mobile No. / \u092E\u094B\u092C\u093E\u0907\u0932 \u0928\u0902\u092C\u0930</span></dt><dd><span>{{vm.suggestion.mobile}}</span></dd></div><div class="col-sm-6"></div><br><br></div></div></div><div class="col-sm-12"><h4 class="text-center">SUGGESTION DETAIL / \u0938\u0941\u091D\u093E\u0935 \u0915\u093E \u0935\u093F\u0938\u094D\u0924\u093E\u0930</h4><div class="well"><p class="test-justify">{{vm.suggestion.message}}</p></div></div></div></dl></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Change Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div class="alert alert-danger" ng-show="vm.errorOldNotMatch">Old password do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="oldPassword">Old password</label><input type="password" class="form-control" id="oldPassword" name="oldPassword" placeholder="Old Password" ng-model="vm.oldPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.oldPassword.$dirty && form.oldPassword.$invalid"><p class="help-block" ng-show="form.oldPassword.$error.required">Your old password is required.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>Email is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><h3 ng-hide="filteredConfig.length === 0">Spring configuration</h3><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length === 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-success break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><h4 ng-hide="filtered.length === 0"><span>{{key}}</span></h4><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length === 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-success break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated" data-translate="userManagement.activated">Activated</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.user.id"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" required ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="userManagement.login">Login</span></th><th><span data-translate="userManagement.email">Email</span></th><th></th><th><span data-translate="userManagement.langKey">Lang Key</span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login === user.login" data-translate="userManagement.activated">Activated</button></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login === user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" autocomplete="off" readonly="readonly" onfocus="this.removeAttribute(\'readonly\');" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><center><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></center></form><p></p><!--<div class="alert alert-warning">--><!--<a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a>--><!--</div>--><!--<div class="alert alert-warning" data-translate="global.messages.info.register" translate-compile>--><!--You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a>--><!--</div>--></div></div></div>');
$templateCache.put('app/entities/complaint-form/complaint-form-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.complaintForm.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="womenCellApp.complaintForm.delete.question" translate-values="{id: \'{{vm.complaintForm.id}}\'}">Are you sure you want to delete this Complaint Form?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/complaint-form/complaint-form-detail.html','<div><h2><span data-translate="womenCellApp.complaintForm.detail.title">Complaint Form</span> {{vm.complaintForm.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="womenCellApp.complaintForm.cName">C Name</span></dt><dd><span>{{vm.complaintForm.cName}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.cAddress">C Address</span></dt><dd><span>{{vm.complaintForm.cAddress}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.cDistrict">C District</span></dt><dd><span>{{vm.complaintForm.cDistrict}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.cPin">C Pin</span></dt><dd><span>{{vm.complaintForm.cPin}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.cEmail">C Email</span></dt><dd><span>{{vm.complaintForm.cEmail}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.cMobile">C Mobile</span></dt><dd><span>{{vm.complaintForm.cMobile}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.cLandline">C Landline</span></dt><dd><span>{{vm.complaintForm.cLandline}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.cSex">C Sex</span></dt><dd><span>{{vm.complaintForm.cSex}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.complainantAsVictim">Complainant As Victim</span></dt><dd><span>{{vm.complaintForm.complainantAsVictim}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.vName">V Name</span></dt><dd><span>{{vm.complaintForm.vName}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.vAddress">V Address</span></dt><dd><span>{{vm.complaintForm.vAddress}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.vDistrict">V District</span></dt><dd><span>{{vm.complaintForm.vDistrict}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.vPin">V Pin</span></dt><dd><span>{{vm.complaintForm.vPin}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.vEmail">V Email</span></dt><dd><span>{{vm.complaintForm.vEmail}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.vLandline">V Landline</span></dt><dd><span>{{vm.complaintForm.vLandline}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.vMobile">V Mobile</span></dt><dd><span>{{vm.complaintForm.vMobile}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.vSex">V Sex</span></dt><dd><span>{{vm.complaintForm.vSex}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.vReligion">V Religion</span></dt><dd><span>{{vm.complaintForm.vReligion}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.vCaste">V Caste</span></dt><dd><span>{{vm.complaintForm.vCaste}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.accusedName">Accused Name</span></dt><dd><span>{{vm.complaintForm.accusedName}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.accusedAddress">Accused Address</span></dt><dd><span>{{vm.complaintForm.accusedAddress}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.accusedDistrict">Accused District</span></dt><dd><span>{{vm.complaintForm.accusedDistrict}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.accusedPin">Accused Pin</span></dt><dd><span>{{vm.complaintForm.accusedPin}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.accusedEmail">Accused Email</span></dt><dd><span>{{vm.complaintForm.accusedEmail}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.accusedMobile">Accused Mobile</span></dt><dd><span>{{vm.complaintForm.accusedMobile}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.accusedLandline">Accused Landline</span></dt><dd><span>{{vm.complaintForm.accusedLandline}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.accusedSex">Accused Sex</span></dt><dd><span>{{vm.complaintForm.accusedSex}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.complaintDate">Complaint Date</span></dt><dd><span>{{vm.complaintForm.complaintDate | date:\'medium\'}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.complaintType">Complaint Type</span></dt><dd><span>{{vm.complaintForm.complaintType}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.incidentDetail">Incident Detail</span></dt><dd><span>{{vm.complaintForm.incidentDetail}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.policeComplaintRegistrationStatus">Police Complaint Registration Status</span></dt><dd><span>{{vm.complaintForm.policeComplaintRegistrationStatus}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.caseFiledInCourtStatus">Case Filed In Court Status</span></dt><dd><span>{{vm.complaintForm.caseFiledInCourtStatus}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.expectedActionFromCommission">Expected Action From Commission</span></dt><dd><span>{{vm.complaintForm.expectedActionFromCommission}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.policeComplaintFileName">Police Complaint File Name</span></dt><dd><span>{{vm.complaintForm.policeComplaintFileName}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.caseInCourtFileName">Case In Court File Name</span></dt><dd><span>{{vm.complaintForm.caseInCourtFileName}}</span></dd><dt><span data-translate="womenCellApp.complaintForm.attachedFileName">Attached File Name</span></dt><dd><span>{{vm.complaintForm.attachedFileName}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="complaint-form-detail.edit({id:vm.complaintForm.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/complaint-form/complaint-form-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myComplaintFormLabel" data-translate="womenCellApp.complaintForm.home.createOrEditLabel">Create or edit a Complaint Form</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.complaintForm.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.complaintForm.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.cName" for="field_cName">C Name</label><input type="text" class="form-control" name="cName" id="field_cName" ng-model="vm.complaintForm.cName"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.cAddress" for="field_cAddress">C Address</label><input type="text" class="form-control" name="cAddress" id="field_cAddress" ng-model="vm.complaintForm.cAddress"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.cDistrict" for="field_cDistrict">C District</label><input type="text" class="form-control" name="cDistrict" id="field_cDistrict" ng-model="vm.complaintForm.cDistrict"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.cPin" for="field_cPin">C Pin</label><input type="number" class="form-control" name="cPin" id="field_cPin" ng-model="vm.complaintForm.cPin"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.cEmail" for="field_cEmail">C Email</label><input type="text" class="form-control" name="cEmail" id="field_cEmail" ng-model="vm.complaintForm.cEmail"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.cMobile" for="field_cMobile">C Mobile</label><input type="text" class="form-control" name="cMobile" id="field_cMobile" ng-model="vm.complaintForm.cMobile"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.cLandline" for="field_cLandline">C Landline</label><input type="text" class="form-control" name="cLandline" id="field_cLandline" ng-model="vm.complaintForm.cLandline"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.cSex" for="field_cSex">C Sex</label><input type="text" class="form-control" name="cSex" id="field_cSex" ng-model="vm.complaintForm.cSex"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.complainantAsVictim" for="field_complainantAsVictim">Complainant As Victim</label><input type="checkbox" name="complainantAsVictim" id="field_complainantAsVictim" ng-model="vm.complaintForm.complainantAsVictim"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.vName" for="field_vName">V Name</label><input type="text" class="form-control" name="vName" id="field_vName" ng-model="vm.complaintForm.vName"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.vAddress" for="field_vAddress">V Address</label><input type="text" class="form-control" name="vAddress" id="field_vAddress" ng-model="vm.complaintForm.vAddress"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.vDistrict" for="field_vDistrict">V District</label><input type="text" class="form-control" name="vDistrict" id="field_vDistrict" ng-model="vm.complaintForm.vDistrict"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.vPin" for="field_vPin">V Pin</label><input type="number" class="form-control" name="vPin" id="field_vPin" ng-model="vm.complaintForm.vPin"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.vEmail" for="field_vEmail">V Email</label><input type="text" class="form-control" name="vEmail" id="field_vEmail" ng-model="vm.complaintForm.vEmail"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.vLandline" for="field_vLandline">V Landline</label><input type="text" class="form-control" name="vLandline" id="field_vLandline" ng-model="vm.complaintForm.vLandline"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.vMobile" for="field_vMobile">V Mobile</label><input type="text" class="form-control" name="vMobile" id="field_vMobile" ng-model="vm.complaintForm.vMobile"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.vSex" for="field_vSex">V Sex</label><input type="text" class="form-control" name="vSex" id="field_vSex" ng-model="vm.complaintForm.vSex"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.vReligion" for="field_vReligion">V Religion</label><input type="text" class="form-control" name="vReligion" id="field_vReligion" ng-model="vm.complaintForm.vReligion"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.vCaste" for="field_vCaste">V Caste</label><input type="text" class="form-control" name="vCaste" id="field_vCaste" ng-model="vm.complaintForm.vCaste"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.accusedName" for="field_accusedName">Accused Name</label><input type="text" class="form-control" name="accusedName" id="field_accusedName" ng-model="vm.complaintForm.accusedName"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.accusedAddress" for="field_accusedAddress">Accused Address</label><input type="text" class="form-control" name="accusedAddress" id="field_accusedAddress" ng-model="vm.complaintForm.accusedAddress"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.accusedDistrict" for="field_accusedDistrict">Accused District</label><input type="text" class="form-control" name="accusedDistrict" id="field_accusedDistrict" ng-model="vm.complaintForm.accusedDistrict"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.accusedPin" for="field_accusedPin">Accused Pin</label><input type="number" class="form-control" name="accusedPin" id="field_accusedPin" ng-model="vm.complaintForm.accusedPin"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.accusedEmail" for="field_accusedEmail">Accused Email</label><input type="text" class="form-control" name="accusedEmail" id="field_accusedEmail" ng-model="vm.complaintForm.accusedEmail"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.accusedMobile" for="field_accusedMobile">Accused Mobile</label><input type="text" class="form-control" name="accusedMobile" id="field_accusedMobile" ng-model="vm.complaintForm.accusedMobile"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.accusedLandline" for="field_accusedLandline">Accused Landline</label><input type="text" class="form-control" name="accusedLandline" id="field_accusedLandline" ng-model="vm.complaintForm.accusedLandline"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.accusedSex" for="field_accusedSex">Accused Sex</label><input type="text" class="form-control" name="accusedSex" id="field_accusedSex" ng-model="vm.complaintForm.accusedSex"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.complaintDate" for="field_complaintDate">Complaint Date</label><div class="input-group"><input id="field_complaintDate" type="text" class="form-control" name="complaintDate" datetime-picker="{{dateformat}}" ng-model="vm.complaintForm.complaintDate" is-open="vm.datePickerOpenStatus.complaintDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'complaintDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.complaintType" for="field_complaintType">Complaint Type</label><input type="text" class="form-control" name="complaintType" id="field_complaintType" ng-model="vm.complaintForm.complaintType"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.incidentDetail" for="field_incidentDetail">Incident Detail</label><input type="text" class="form-control" name="incidentDetail" id="field_incidentDetail" ng-model="vm.complaintForm.incidentDetail"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.policeComplaintRegistrationStatus" for="field_policeComplaintRegistrationStatus">Police Complaint Registration Status</label><input type="checkbox" name="policeComplaintRegistrationStatus" id="field_policeComplaintRegistrationStatus" ng-model="vm.complaintForm.policeComplaintRegistrationStatus"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.caseFiledInCourtStatus" for="field_caseFiledInCourtStatus">Case Filed In Court Status</label><input type="checkbox" name="caseFiledInCourtStatus" id="field_caseFiledInCourtStatus" ng-model="vm.complaintForm.caseFiledInCourtStatus"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.expectedActionFromCommission" for="field_expectedActionFromCommission">Expected Action From Commission</label><input type="text" class="form-control" name="expectedActionFromCommission" id="field_expectedActionFromCommission" ng-model="vm.complaintForm.expectedActionFromCommission"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.policeComplaintFileName" for="field_policeComplaintFileName">Police Complaint File Name</label><input type="text" class="form-control" name="policeComplaintFileName" id="field_policeComplaintFileName" ng-model="vm.complaintForm.policeComplaintFileName"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.caseInCourtFileName" for="field_caseInCourtFileName">Case In Court File Name</label><input type="text" class="form-control" name="caseInCourtFileName" id="field_caseInCourtFileName" ng-model="vm.complaintForm.caseInCourtFileName"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.complaintForm.attachedFileName" for="field_attachedFileName">Attached File Name</label><input type="text" class="form-control" name="attachedFileName" id="field_attachedFileName" ng-model="vm.complaintForm.attachedFileName"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/complaint-form/complaint-forms.html','<div><h2 data-translate="womenCellApp.complaintForm.home.title">Complaint Forms</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="complaint-form.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="womenCellApp.complaintForm.home.createLabel">Create new Complaint Form</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="womenCellApp.complaintForm.cName">C Name</span></th><th><span data-translate="womenCellApp.complaintForm.cAddress">C Address</span></th><th><span data-translate="womenCellApp.complaintForm.cDistrict">C District</span></th><th><span data-translate="womenCellApp.complaintForm.cPin">C Pin</span></th><th><span data-translate="womenCellApp.complaintForm.cEmail">C Email</span></th><th><span data-translate="womenCellApp.complaintForm.cMobile">C Mobile</span></th><th><span data-translate="womenCellApp.complaintForm.cLandline">C Landline</span></th><th><span data-translate="womenCellApp.complaintForm.cSex">C Sex</span></th><th><span data-translate="womenCellApp.complaintForm.complainantAsVictim">Complainant As Victim</span></th><th><span data-translate="womenCellApp.complaintForm.vName">V Name</span></th><th><span data-translate="womenCellApp.complaintForm.vAddress">V Address</span></th><th><span data-translate="womenCellApp.complaintForm.vDistrict">V District</span></th><th><span data-translate="womenCellApp.complaintForm.vPin">V Pin</span></th><th><span data-translate="womenCellApp.complaintForm.vEmail">V Email</span></th><th><span data-translate="womenCellApp.complaintForm.vLandline">V Landline</span></th><th><span data-translate="womenCellApp.complaintForm.vMobile">V Mobile</span></th><th><span data-translate="womenCellApp.complaintForm.vSex">V Sex</span></th><th><span data-translate="womenCellApp.complaintForm.vReligion">V Religion</span></th><th><span data-translate="womenCellApp.complaintForm.vCaste">V Caste</span></th><th><span data-translate="womenCellApp.complaintForm.accusedName">Accused Name</span></th><th><span data-translate="womenCellApp.complaintForm.accusedAddress">Accused Address</span></th><th><span data-translate="womenCellApp.complaintForm.accusedDistrict">Accused District</span></th><th><span data-translate="womenCellApp.complaintForm.accusedPin">Accused Pin</span></th><th><span data-translate="womenCellApp.complaintForm.accusedEmail">Accused Email</span></th><th><span data-translate="womenCellApp.complaintForm.accusedMobile">Accused Mobile</span></th><th><span data-translate="womenCellApp.complaintForm.accusedLandline">Accused Landline</span></th><th><span data-translate="womenCellApp.complaintForm.accusedSex">Accused Sex</span></th><th><span data-translate="womenCellApp.complaintForm.complaintDate">Complaint Date</span></th><th><span data-translate="womenCellApp.complaintForm.complaintType">Complaint Type</span></th><th><span data-translate="womenCellApp.complaintForm.incidentDetail">Incident Detail</span></th><th><span data-translate="womenCellApp.complaintForm.policeComplaintRegistrationStatus">Police Complaint Registration Status</span></th><th><span data-translate="womenCellApp.complaintForm.caseFiledInCourtStatus">Case Filed In Court Status</span></th><th><span data-translate="womenCellApp.complaintForm.expectedActionFromCommission">Expected Action From Commission</span></th><th><span data-translate="womenCellApp.complaintForm.policeComplaintFileName">Police Complaint File Name</span></th><th><span data-translate="womenCellApp.complaintForm.caseInCourtFileName">Case In Court File Name</span></th><th><span data-translate="womenCellApp.complaintForm.attachedFileName">Attached File Name</span></th><th></th></tr></thead><tbody><tr ng-repeat="complaintForm in vm.complaintForms track by complaintForm.id"><td><a ui-sref="complaint-form-detail({id:complaintForm.id})">{{complaintForm.id}}</a></td><td>{{complaintForm.cName}}</td><td>{{complaintForm.cAddress}}</td><td>{{complaintForm.cDistrict}}</td><td>{{complaintForm.cPin}}</td><td>{{complaintForm.cEmail}}</td><td>{{complaintForm.cMobile}}</td><td>{{complaintForm.cLandline}}</td><td>{{complaintForm.cSex}}</td><td>{{complaintForm.complainantAsVictim}}</td><td>{{complaintForm.vName}}</td><td>{{complaintForm.vAddress}}</td><td>{{complaintForm.vDistrict}}</td><td>{{complaintForm.vPin}}</td><td>{{complaintForm.vEmail}}</td><td>{{complaintForm.vLandline}}</td><td>{{complaintForm.vMobile}}</td><td>{{complaintForm.vSex}}</td><td>{{complaintForm.vReligion}}</td><td>{{complaintForm.vCaste}}</td><td>{{complaintForm.accusedName}}</td><td>{{complaintForm.accusedAddress}}</td><td>{{complaintForm.accusedDistrict}}</td><td>{{complaintForm.accusedPin}}</td><td>{{complaintForm.accusedEmail}}</td><td>{{complaintForm.accusedMobile}}</td><td>{{complaintForm.accusedLandline}}</td><td>{{complaintForm.accusedSex}}</td><td>{{complaintForm.complaintDate | date:\'medium\'}}</td><td>{{complaintForm.complaintType}}</td><td>{{complaintForm.incidentDetail}}</td><td>{{complaintForm.policeComplaintRegistrationStatus}}</td><td>{{complaintForm.caseFiledInCourtStatus}}</td><td>{{complaintForm.expectedActionFromCommission}}</td><td>{{complaintForm.policeComplaintFileName}}</td><td>{{complaintForm.caseInCourtFileName}}</td><td>{{complaintForm.attachedFileName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="complaint-form-detail({id:complaintForm.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="complaint-form.edit({id:complaintForm.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="complaint-form.delete({id:complaintForm.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/gallery/galleries.html','<div><h2 data-translate="womenCellApp.gallery.home.title">Galleries</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="gallery.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="womenCellApp.gallery.home.createLabel">Create new Gallery</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="womenCellApp.gallery.filename">Filename</span></th><th><span data-translate="womenCellApp.gallery.type">Type</span></th><th><span data-translate="womenCellApp.gallery.description">Description</span></th><th><span data-translate="womenCellApp.gallery.uploadDate">Upload Date</span></th><th><span data-translate="womenCellApp.gallery.caption">Caption</span></th><th><span data-translate="womenCellApp.gallery.fileType">File Type</span></th><th></th></tr></thead><tbody><tr ng-repeat="gallery in vm.galleries track by gallery.id"><td><a ui-sref="gallery-detail({id:gallery.id})">{{gallery.id}}</a></td><td>{{gallery.filename}}</td><td>{{gallery.type}}</td><td>{{gallery.description}}</td><td>{{gallery.uploadDate | date:\'medium\'}}</td><td>{{gallery.caption}}</td><td>{{gallery.fileType}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="gallery-detail({id:gallery.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="gallery.edit({id:gallery.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="gallery.delete({id:gallery.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/gallery/gallery-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.gallery.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="womenCellApp.gallery.delete.question" translate-values="{id: \'{{vm.gallery.id}}\'}">Are you sure you want to delete this Gallery?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/gallery/gallery-detail.html','<div><h2><span data-translate="womenCellApp.gallery.detail.title">Gallery</span> {{vm.gallery.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="womenCellApp.gallery.filename">Filename</span></dt><dd><span>{{vm.gallery.filename}}</span></dd><dt><span data-translate="womenCellApp.gallery.type">Type</span></dt><dd><span>{{vm.gallery.type}}</span></dd><dt><span data-translate="womenCellApp.gallery.description">Description</span></dt><dd><span>{{vm.gallery.description}}</span></dd><dt><span data-translate="womenCellApp.gallery.uploadDate">Upload Date</span></dt><dd><span>{{vm.gallery.uploadDate | date:\'medium\'}}</span></dd><dt><span data-translate="womenCellApp.gallery.caption">Caption</span></dt><dd><span>{{vm.gallery.caption}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="gallery-detail.edit({id:vm.gallery.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/gallery/gallery-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myGalleryLabel" data-translate="womenCellApp.gallery.home.createOrEditLabel">Create or edit a Gallery</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.gallery.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.gallery.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.gallery.filename" for="field_filename">Filename</label><input type="text" class="form-control" name="filename" id="field_filename" ng-model="vm.gallery.filename"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.gallery.type" for="field_type">Type</label><input type="text" class="form-control" name="type" id="field_type" ng-model="vm.gallery.type"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.gallery.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.gallery.description"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.gallery.fileType" for="field_fileType">File Type</label><input type="text" class="form-control" name="description" id="field_fileType" ng-model="vm.gallery.fileType"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.gallery.uploadDate" for="field_uploadDate">Upload Date</label><div class="input-group"><input id="field_uploadDate" type="text" class="form-control" name="uploadDate" datetime-picker="{{dateformat}}" ng-model="vm.gallery.uploadDate" is-open="vm.datePickerOpenStatus.uploadDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'uploadDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.gallery.caption" for="field_caption">Caption</label><input type="text" class="form-control" name="caption" id="field_caption" ng-model="vm.gallery.caption"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/suggestion/suggestion-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.suggestion.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="womenCellApp.suggestion.delete.question" translate-values="{id: \'{{vm.suggestion.id}}\'}">Are you sure you want to delete this Suggestion?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/suggestion/suggestion-detail.html','<div><h2><span data-translate="womenCellApp.suggestion.detail.title">Suggestion</span> {{vm.suggestion.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="womenCellApp.suggestion.name">Name</span></dt><dd><span>{{vm.suggestion.name}}</span></dd><dt><span data-translate="womenCellApp.suggestion.email">Email</span></dt><dd><span>{{vm.suggestion.email}}</span></dd><dt><span data-translate="womenCellApp.suggestion.mobile">Mobile</span></dt><dd><span>{{vm.suggestion.mobile}}</span></dd><dt><span data-translate="womenCellApp.suggestion.suggestionType">Suggestion Type</span></dt><dd><span>{{vm.suggestion.suggestionType}}</span></dd><dt><span data-translate="womenCellApp.suggestion.message">Message</span></dt><dd><span>{{vm.suggestion.message}}</span></dd><dt><span data-translate="womenCellApp.suggestion.suggestionDate">Suggestion Date</span></dt><dd><span>{{vm.suggestion.suggestionDate | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="suggestion-detail.edit({id:vm.suggestion.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/suggestion/suggestion-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySuggestionLabel" data-translate="womenCellApp.suggestion.home.createOrEditLabel">Create or edit a Suggestion</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.suggestion.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.suggestion.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.suggestion.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.suggestion.name"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.suggestion.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.suggestion.email"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.suggestion.mobile" for="field_mobile">Mobile</label><input type="text" class="form-control" name="mobile" id="field_mobile" ng-model="vm.suggestion.mobile"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.suggestion.suggestionType" for="field_suggestionType">Suggestion Type</label><input type="text" class="form-control" name="suggestionType" id="field_suggestionType" ng-model="vm.suggestion.suggestionType"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.suggestion.message" for="field_message">Message</label><input type="text" class="form-control" name="message" id="field_message" ng-model="vm.suggestion.message"></div><div class="form-group"><label class="control-label" data-translate="womenCellApp.suggestion.suggestionDate" for="field_suggestionDate">Suggestion Date</label><div class="input-group"><input id="field_suggestionDate" type="text" class="form-control" name="suggestionDate" datetime-picker="{{dateformat}}" ng-model="vm.suggestion.suggestionDate" is-open="vm.datePickerOpenStatus.suggestionDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'suggestionDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/suggestion/suggestions.html','<div><h2 data-translate="womenCellApp.suggestion.home.title">Suggestions</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="suggestion.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="womenCellApp.suggestion.home.createLabel">Create new Suggestion</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="womenCellApp.suggestion.name">Name</span></th><th><span data-translate="womenCellApp.suggestion.email">Email</span></th><th><span data-translate="womenCellApp.suggestion.mobile">Mobile</span></th><th><span data-translate="womenCellApp.suggestion.suggestionType">Suggestion Type</span></th><th><span data-translate="womenCellApp.suggestion.message">Message</span></th><th><span data-translate="womenCellApp.suggestion.suggestionDate">Suggestion Date</span></th><th></th></tr></thead><tbody><tr ng-repeat="suggestion in vm.suggestions track by suggestion.id"><td><a ui-sref="suggestion-detail({id:suggestion.id})">{{suggestion.id}}</a></td><td>{{suggestion.name}}</td><td>{{suggestion.email}}</td><td>{{suggestion.mobile}}</td><td>{{suggestion.suggestionType}}</td><td>{{suggestion.message}}</td><td>{{suggestion.suggestionDate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="suggestion-detail({id:suggestion.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="suggestion.edit({id:suggestion.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="suggestion.delete({id:suggestion.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.http.403">You are not authorized to access this page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/footer.html','<footer><div class="container"><div class="col-md-4"><br><br><ul><li><a ui-sref="home"><h5><strong data-translate="footer.home">Home</strong></h5></a></li><li><a ui-sref="sitemap"><h5><strong data-translate="footer.sitemap">Sitemap</strong></h5></a></li><li><a ui-sref="faqs"><h5><strong data-translate="footer.faqs">FAQs</strong></h5></a></li><li><a ui-sref="suggestions"><h5><strong data-translate="footer.suggestions">Suggestions</strong></h5></a></li><li><a ui-sref="contacts"><h5><strong data-translate="footer.contacts">Contacts</strong></h5></a></li><li><a ui-sref="chairpersons"><h5><strong data-translate="footer.commission">Commission</strong></h5></a></li><li><a ui-sref="budget"><h5><strong data-translate="footer.budget">Budget</strong></h5></a></li><li><a ui-sref="updatesoon"><h5><strong data-translate="footer.publichearing">Public Hearing</strong></h5></a></li></ul></div><div class="col-md-4"><h3 data-translate="footer.ourlocation">Our Location</h3><iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3430.7258242079993!2d76.85671478013326!3d30.697989409111454!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390f9371c5ceef49%3A0x9f2835b7ce2a6e6!2s31-34%2C%20haryana%20state%20commission%20for%20women%20Bay%2C%20near%20by%20BP%20PETROL%E2%9B%BD%20PUMP%2C%20Sector%202%2C%20Panchkula%2C%20Haryana%20134109!5e0!3m2!1sen!2sin!4v1781593863255!5m2!1sen!2sin" width="600" height="450" style="border:0" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe></div><div class="col-md-4"><h3 data-translate="footer.titlecontactus">Contact Us</h3><div data-translate="footer.contentcontactus">address</div></div></div><br><div class="footerHeader"><div class="col-md-12"><div class="col-md-4"></div><div class="col-md-4"><center><b>&#9400; 2026 Hartron. All rights reserved</b></center></div><div class="col-md-4"><center><h5 class="pull-right" style="margin-top: 0px; margin-bottom: 0px"><b>No. of Visitors: </b><!--<img src="https://smallseotools.com/counterDisplay?code=94cb3b99eb07cccd967cf239e2245119&style=0003&pad=7&type=page&initCount=147"  title="Total Visitors" Alt="Web Counter" border="0">--> <img src="http://hitwebcounter.com/counter/counter.php?page=6925902&style=0025&nbdigits=7&type=page&initCount=173" title="Total Visitors" alt="Visitors Counting" border="0"></h5></center></div></div><br></div></footer>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container-fluid"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-left"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><h6><span class="visible-sm glyphicon glyphicon-home" name="home"></span> <span class="hidden-sm" data-translate="global.menu.home"><b>Home</b></span></h6></a></li><li ui-sref-active="active"><a ui-sref="about-us" ng-click="vm.collapseNavbar()"><h6><span class="visible-sm glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.about-us"><b>About Us</b></span></h6></a></li><li ui-sref-active="active"><a ui-sref="pic-gallery-folder" ng-click="vm.collapseNavbar()"><h6><span class="visible-sm glyphicon glyphicon-camera"></span> <span class="hidden-sm" data-translate="global.menu.pic-gallery.events">Events</span></h6></a></li><li ui-sref-active="active"><a ui-sref="news" ng-click="vm.collapseNavbar()"><h6><span class="visible-sm glyphicon glyphicon-eye-open"></span> <span class="hidden-sm" data-translate="global.menu.pic-gallery.news">HSCW in News</span></h6></a></li><li ui-sref-active="active"><a ui-sref="updatesoon" ng-click="vm.collapseNavbar()"><h6><span class="visible-sm glyphicon glyphicon-eye-open"></span> <span class="hidden-sm" data-translate="global.menu.rti">RTI</span></h6></a></li><li ui-sref-active="active"><a ui-sref="pressnote" ng-click="vm.collapseNavbar()"><h6><span class="visible-sm glyphicon glyphicon-eye-open"></span> <span class="hidden-sm" data-translate="global.menu.pressnote">Press Note</span></h6></a></li><li ui-sref-active="active"><a ui-sref="useful-links" ng-click="vm.collapseNavbar()"><h6><span class="visible-sm glyphicon glyphicon-link"></span> <span class="hidden-sm" data-translate="global.menu.useful-links">Useful Links</span></h6></a></li><li ui-sref-active="active"><a ui-sref="complaintInstruction" ng-click="vm.collapseNavbar()"><h6><span class="visible-sm glyphicon glyphicon-file"></span> <span class="hidden-sm" data-translate="global.menu.file-complaints">File Complaints</span></h6></a></li><li ui-sref-active="active"><a ui-sref="laws-pertaining-to-women" ng-click="vm.collapseNavbar()"><h6><span class="visible-sm glyphicon glyphicon-education"></span> <span class="hidden-sm" data-translate="global.menu.laws-pertaining-to-women">Laws Pertaining To Women</span></h6></a></li><li ui-sref-active="active"><a ui-sref="interview-folder" ng-click="vm.collapseNavbar()"><h6><span class="visible-sm glyphicon glyphicon-envelope"></span> <span class="hidden-sm" data-translate="global.menu.interview">Interview with Luminaries</span></h6></a></li><li uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="help-menu"><span><h6><span class="visible-sm glyphicon glyphicon-question-sign"></span> <span class="hidden-sm" data-translate="global.menu.help.main">Help</span> <b class="hidden-sm caret"></b></h6></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="faqs" ng-click="vm.collapseNavbar()"><h6><span class="glyphicon glyphicon-info-sign"></span> <span data-translate="global.menu.help.faqs">FAQs</span></h6></a></li><li ui-sref-active="active"><a ui-sref="suggestions" ng-click="vm.collapseNavbar()"><h6><span class="glyphicon glyphicon-bell"></span> <span data-translate="global.menu.help.suggestions">Suggestions</span></h6></a></li><li ui-sref-active="active"><a ui-sref="contact-us" ng-click="vm.collapseNavbar()"><h6><span class="glyphicon glyphicon-map-marker"></span> <span data-translate="global.menu.contact-us">Contact Us</span></h6></a></li><!--<li ui-sref-active="active">--><!--<a ui-sref="websitepolicy" ng-click="vm.collapseNavbar()">--><!--<h6><span class="glyphicon glyphicon-bell"></span>--><!--<span data-translate="global.menu.help.websitepolicy">We Us</span></h6>--><!--</a>--><!--</li>--></ul></li><li ui-sref-active="active"><a ui-sref="joinus" ng-click="vm.collapseNavbar()"><h6><span class="visible-sm glyphicon glyphicon-envelope"></span> <span class="hidden-sm" data-translate="global.menu.help.join-us">Internship</span></h6></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_HSCW"><a ui-sref="view-complaint" ng-click="vm.collapseNavbar()"><h6><span class="visible-sm glyphicon glyphicon-map-marker"></span> <span class="hidden-sm" data-translate="global.menu.view-complaint">View Complaint</span></h6></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_HSCW"><a ui-sref="view-suggestion" ng-click="vm.collapseNavbar()"><h6><span class="visible-sm glyphicon glyphicon-map-marker"></span> <span class="hidden-sm" data-translate="global.menu.view-suggestion">View Suggestion</span></h6></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><!--<li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer">--><!--<a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu">--><!--<span>--><!--<span class="glyphicon glyphicon-th-list"></span>--><!--<span class="hidden-sm" data-translate="global.menu.entities.main">--><!--Entities--><!--</span>--><!--<b class="caret"></b>--><!--</span>--><!--</a>--><!--<ul class="dropdown-menu" uib-dropdown-menu>--><!--<li ui-sref-active="active">--><!--<a ui-sref="complaint-form" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.complaintForm">Complaint Form</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="gallery" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.gallery">Gallery</span>--><!--</a>--><!--</li>--><!--&lt;!&ndash; jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here &ndash;&gt;--><!--</ul>--><!--</li>--><!--<li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer">--><!--<a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu">--><!--<span>--><!--<span class="glyphicon glyphicon-user"></span>--><!--<span class="hidden-sm" data-translate="global.menu.account.main">--><!--Account--><!--</span>--><!--<b class="caret"></b>--><!--</span>--><!--</a>--><!--<ul class="dropdown-menu" uib-dropdown-menu>--><!--<li ui-sref-active="active" ng-switch-when="true">--><!--<a ui-sref="settings" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-wrench"></span>&nbsp;--><!--<span data-translate="global.menu.account.settings">Settings</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active" ng-switch-when="true">--><!--<a ui-sref="password" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-lock"></span>&nbsp;--><!--<span data-translate="global.menu.account.password">Password</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active" ng-switch-when="true">--><!--<a href="" ng-click="vm.logout()" id="logout">--><!--<span class="glyphicon glyphicon-log-out"></span>&nbsp;--><!--<span data-translate="global.menu.account.logout">Sign out</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active" ng-switch-when="false">--><!--<a href="" ng-click="vm.login()" id="login">--><!--<span class="glyphicon glyphicon-log-in"></span>&nbsp;--><!--<span data-translate="global.menu.account.login">Sign in</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active" ng-switch-when="false">--><!--<a ui-sref="register" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-plus-sign"></span>&nbsp;--><!--<span data-translate="global.menu.account.register">Register</span>--><!--</a>--><!--</li>--><!--</ul>--><!--</li>--><!--<li ng-class="{active: vm.$state.includes(\'admin\')}"  ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer">--><!--<a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu">--><!--<span>--><!--<span class="glyphicon glyphicon-tower"></span>--><!--<span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span>--><!--<b class="caret"></b>--><!--</span>--><!--</a>--><!--<ul class="dropdown-menu" uib-dropdown-menu>--><!--<li ui-sref-active="active">--><!--<a ui-sref="user-management" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-user"></span>&nbsp;--><!--<span data-translate="global.menu.admin.userManagement">User management</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-dashboard"></span>&nbsp;--><!--<span data-translate="global.menu.admin.metrics">Metrics</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="jhi-health" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-heart"></span>&nbsp;--><!--<span data-translate="global.menu.admin.health">Health</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-list-alt"></span>&nbsp;--><!--<span data-translate="global.menu.admin.configuration">Configuration</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="logs" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-tasks"></span>&nbsp;--><!--<span data-translate="global.menu.admin.logs">Logs</span>--><!--</a>--><!--</li>--><!--<li ng-show="vm.swaggerEnabled" ui-sref-active="active">--><!--<a ui-sref="docs" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-book"></span>&nbsp;--><!--<span data-translate="global.menu.admin.apidocs">API</span>--><!--</a>--><!--</li>--><!--&lt;!&ndash; jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here &ndash;&gt;--><!--</ul>--><!--</li>--><!--<li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm">--><!--<a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1">--><!--<span>--><!--<span class="glyphicon glyphicon-flag"></span>--><!--<span class="hidden-sm" data-translate="global.menu.language">Language</span>--><!--<b class="caret"></b>--><!--</span>--><!--</a>--><!--<ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1">--><!--<li active-menu="{{language}}" ng-repeat="language in languageVm.languages">--><!--<a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a>--><!--</li>--><!--</ul>--><!--</li>--></ul></div></div></nav>');
$templateCache.put('app/layouts/navbar/topHeader.html','<div class="topHeaderBg"><div class="container"><div class="row"><div class="col-md-3 col-sm-2 col-xs-2 textColor paddingRemove1"><small class="col-xs-12">{{ clock | date:\'medium\'}}</small></div><div class="col-md-6 col-sm-6 col-xs-5 textColor paddingRemove1 topHeaderHover"><a ui-sref="sitemap" class="textColor" data-translate="footer.sitemap">Sitemap </a>&nbsp; | <a ui-sref="faqs" class="textColor" data-translate="footer.faqs">&nbsp; FAQs </a>&nbsp; | <a ui-sref="suggestions" class="textColor" data-translate="footer.suggestions">&nbsp; Suggestions </a>&nbsp; | <a ui-sref="contacts" class="textColor" data-translate="footer.contacts">&nbsp; Contacts </a>&nbsp; | <a ui-sref="chairpersons" class="textColor" data-translate="footer.commission">&nbsp; Commission</a>&nbsp; | <a ui-sref="budget" class="textColor" data-translate="footer.budget">&nbsp; Budget</a>&nbsp; | <a ui-sref="updatesoon" class="textColor" data-translate="footer.publichearing">&nbsp; Public Hearing</a></div><div class="col-md-3 col-sm-4 col-xs-5"><ul ui-sref-active="active" class="textColor text-right" uib-dropdown class="dropdown pointer dropdown-menu-right" ng-controller="JhiLanguageController as languageVm" ng-switch="vm.isAuthenticated()"><a href="" ng-click="vm.login()" id="login" ng-switch-when="false"><span class="textColor text-right glyphicon glyphicon-log-in" title="Sign-In"></span>&nbsp;<!--<span class="textColor" data-translate="global.menu.account.login">Signin</span>--> </a><a href="" ng-click="vm.logout()" id="logout" ng-switch-when="true"><span class="textColor glyphicon glyphicon-log-out" title="Sign-Out"></span>&nbsp;<!--<span class="textColor" data-translate="global.menu.account.logout">Signout</span>--> </a>&nbsp; <a ui-sref="password" ng-switch-when="true"><span class="textColor glyphicon glyphicon-lock" title="Change Password"></span>&nbsp;<!--<span data-translate="global.menu.account.password">Password</span>--> </a>&nbsp; <a class="dropdown-toggle text-right" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="textColor" data-translate="global.menu.language">Language</span> <span><b class="caret textColor"></b></span> </span></a><!--<a target="_blank" href="https://www.facebook.com/Haryana-State-Commission-for-Women-611632172299264/">&nbsp;&nbsp;&nbsp;<i class="fa fa-facebook-square fa-lg" style="color:white;" aria-hidden="true" title="Facebook"></i></a>--><!--<a target="_blank" href="https://www.youtube.com/channel/UCQtb42n3rF5GOPUYqk_XM5Q">&nbsp;&nbsp;&nbsp;<i class="fa fa-youtube-play fa-lg" style="color:white;" aria-hidden="true" title="Youtube"></i></a>--><ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></ul></div></div></div></div><div class="header-head"><div class="container-fluid"><div class="row"><a class="header-brand" href="#/" ng-click="vm.collapseNavbar()"><ul class="col-md-12 col-xs-12 col-sm-12 paddingRemove1"><li class="col-md-2 col-md-offset-1 col-sm-2 col-xs-2"><img class="logo-img" src="content/images/hscw-logo.png" alt="logo"></li><li class="col-md-6 col-sm-8 col-xs-10"><ul><li class="col-md-12 col-md-offset-5 col-sm-12 col-sm-offset-5 hidden-xs"><img class="logo-img2" src="content/images/hry-logo.png" alt="logo"></li><li class="col-md-12 col-sm-12 col-xs-12 text-center text-danger"><h2 class="hidden-xs hidden-sm"><b>&nbsp; \u0939\u0930\u093F\u092F\u093E\u0923\u093E&nbsp; \u0930\u093E\u091C\u094D\u092F&nbsp; \u092E\u0939\u093F\u0932\u093E&nbsp; \u0906\u092F\u094B\u0917</b></h2><h3 class="hidden-xs visible-sm"><b>\u0939\u0930\u093F\u092F\u093E\u0923\u093E \u0930\u093E\u091C\u094D\u092F \u092E\u0939\u093F\u0932\u093E \u0906\u092F\u094B\u0917</b></h3><h5 class="visible-xs hidden-sm"><b>\u0939\u0930\u093F\u092F\u093E\u0923\u093E \u0930\u093E\u091C\u094D\u092F \u092E\u0939\u093F\u0932\u093E \u0906\u092F\u094B\u0917</b></h5><h3 class="hidden-xs hidden-sm"><b>Haryana State Commission For Women</b></h3><h5 class="hidden-xs visible-sm"><b>Haryana State Commission For Women</b></h5><p class="visible-xs hidden-sm"><b>Haryana State Commission For Women</b></p><br></li></ul></li><li class="col-md-3 col-sm-2 hidden-xs"><img class="logo-img1 col-md-offset-3" src="content/images/betibachao.png" alt="logo"></li></ul></a></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>Email address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the email address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success === \'OK\'"><p data-translate="reset.request.messages.success">Check your emails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');}]);})();